// This file is auto-generated by scripts/gen-openapi.ts
// Do not edit manually - regenerate using npm run generate:types

export enum AccountType {
    Bank = 'BANK',
    Current = 'CURRENT',
    Currliab = 'CURRLIAB',
    Depreciatn = 'DEPRECIATN',
    Directcosts = 'DIRECTCOSTS',
    Equity = 'EQUITY',
    Expense = 'EXPENSE',
    Fixed = 'FIXED',
    Inventory = 'INVENTORY',
    Liability = 'LIABILITY',
    Noncurrent = 'NONCURRENT',
    Otherincome = 'OTHERINCOME',
    Overheads = 'OVERHEADS',
    Prepayment = 'PREPAYMENT',
    Revenue = 'REVENUE',
    Sales = 'SALES',
    Termliab = 'TERMLIAB',
    Paygliability = 'PAYGLIABILITY',
    Payg = 'PAYG',
    Superannuationexpense = 'SUPERANNUATIONEXPENSE',
    Superannuationliability = 'SUPERANNUATIONLIABILITY',
    Wagesexpense = 'WAGESEXPENSE'
}

export enum AggregationType {
    Min = 'Min',
    Max = 'Max',
    Median = 'Median',
    Mean = 'Mean'
}

export enum ApiType {
    OnSight = 'OnSight',
    ThreeDEye = 'ThreeDEye'
}

export enum AssetNotificationType {
    AssetUseStarted = 'AssetUseStarted',
    AssetUseEnd = 'AssetUseEnd',
    AssetUsedNoLicence = 'AssetUsedNoLicence'
}

export enum AssetType {
    Person = 'Person',
    Equipment = 'Equipment',
    Plant = 'Plant',
    Vehicle = 'Vehicle'
}

export enum AssetUserStatus {
    Available = 'Available',
    InUse = 'InUse',
    InUseByUser = 'InUseByUser'
}

export enum BillingType {
    Invoice = 'Invoice',
    CreditNote = 'CreditNote'
}

export enum Comparator {
    Eq = 'Eq',
    Gt = 'Gt',
    Lt = 'Lt',
    Like = 'Like',
    GtEq = 'GtEq',
    LtEq = 'LtEq',
    NEq = 'NEq',
    ILike = 'ILike'
}

export enum ComponentType {
    MqttRelay = 'MqttRelay',
    Camera = 'Camera',
    Router = 'Router',
    Siren = 'Siren'
}

export enum ConnectionType {
    Cloudflared = 'Cloudflared',
    CloudflareIpsec = 'CloudflareIpsec'
}

export enum CrudOperation {
    Create = 'Create',
    Read = 'Read',
    Update = 'Update',
    Delete = 'Delete'
}

export enum CurrentArmState {
    Armed = 'Armed',
    Disarmed = 'Disarmed',
    TestMode = 'TestMode'
}

export enum DayOfWeek {
    Sunday = 'Sunday',
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
    Saturday = 'Saturday'
}

export enum DetectionLabel {
    Person = 'Person',
    Vehicle = 'Vehicle'
}

export enum DeviceOrientation {
    Portrait = 'Portrait',
    Landscape = 'Landscape'
}

export enum EmailSystem {
    Rentals = 'Rentals',
    Monitoring = 'Monitoring'
}

export enum EnumAiAutomationLevel {
    None = 'None',
    Assistant = 'Assistant',
    Full = 'Full'
}

export enum EnumAlertOperation {
    Above = 'Above',
    Below = 'Below',
    Equals = 'Equals'
}

export enum EnumAlertStatus {
    New = 'New',
    Weather = 'Weather',
    Other = 'Other',
    FalsePositive = 'FalsePositive',
    PossiblyStaff = 'PossiblyStaff',
    ConfirmedStaff = 'ConfirmedStaff',
    Intruder = 'Intruder',
    Unknown = 'Unknown',
    NoThreat = 'NoThreat',
    SuspiciousPerson = 'SuspiciousPerson',
    AnimalOrInsect = 'AnimalOrInsect',
    Environment = 'Environment',
    LightReflection = 'LightReflection',
    NeedsService = 'NeedsService',
    IncorrectMotionGrids = 'IncorrectMotionGrids',
    SafetyEvent = 'SafetyEvent'
}

export enum EnumAlertValueCombination {
    All = 'All',
    Any = 'Any'
}

export enum EnumArmingEventType {
    Armed = 'Armed',
    Disarmed = 'Disarmed'
}

export enum EnumArmProfile {
    Auto = 'Auto',
    Armed = 'Armed',
    Disarmed = 'Disarmed',
    TestMode = 'TestMode'
}

export enum EnumAssetStatus {
    New = 'New',
    Deployed = 'Deployed',
    Stock = 'Stock',
    Problem = 'Problem',
    Retired = 'Retired',
    Hidden = 'Hidden'
}

export enum EnumAuditLogObject {
    AdminLogin = 'AdminLogin',
    Contract = 'Contract',
    User = 'User'
}

export enum EnumBillingCycle {
    Standard = 'Standard',
    AdvanceBilling1M = 'AdvanceBilling1M',
    AdvanceBilling2M = 'AdvanceBilling2M'
}

export enum EnumCameraStatus {
    Unknown = 'Unknown',
    Online = 'Online',
    Offline = 'Offline'
}

export enum EnumComplianceEventType {
    NoHardHat = 'NoHardHat',
    PersonSeen = 'PersonSeen'
}

export enum EnumComplianceEventValueType {
    NoHardHat = 'NoHardHat',
    PersonSeen = 'PersonSeen',
    SnapshotImage = 'SnapshotImage',
    PreviewVideoLink = 'PreviewVideoLink'
}

export enum EnumComponentAuditLogType {
    PasswordGenerated = 'PasswordGenerated',
    PasswordViewed = 'PasswordViewed'
}

export enum EnumContactEventType {
    Police = 'Police',
    ContactEmail = 'ContactEmail',
    ContactSms = 'ContactSms',
    ContactSmsReply = 'ContactSmsReply',
    ContactCall = 'ContactCall',
    MonitoringNotified = 'MonitoringNotified'
}

export enum EnumContactPreference {
    SmsThenCall = 'SmsThenCall',
    SmsOnly = 'SmsOnly',
    CallOnly = 'CallOnly',
    None = 'None'
}

export enum EnumContractStatus {
    New = 'New',
    Commencing = 'Commencing',
    InProgress = 'InProgress',
    Concluded = 'Concluded'
}

export enum EnumCreditNoteStatus {
    Draft = 'DRAFT',
    Submitted = 'SUBMITTED',
    Deleted = 'DELETED',
    Authorised = 'AUTHORISED',
    Paid = 'PAID',
    Voided = 'VOIDED'
}

export enum EnumEmailType {
    Welcome = 'Welcome',
    PasswordReset = 'PasswordReset',
    VerifyEmail = 'VerifyEmail',
    HardwareAlertBreach = 'HardwareAlertBreach',
    HardwareAlertBreachEnd = 'HardwareAlertBreachEnd',
    AdminPasswordReset = 'AdminPasswordReset',
    AdminWelcome = 'AdminWelcome',
    MonitoringLogin = 'MonitoringLogin',
    ProjectMonitoringAlert = 'ProjectMonitoringAlert',
    EText = 'EText',
    ProjectEnhancedMonitoringAlert = 'ProjectEnhancedMonitoringAlert',
    SlaBreach = 'SlaBreach',
    MonitorWelcome = 'MonitorWelcome',
    NotifyHoliday = 'NotifyHoliday',
    AlertIntruderClosed = 'AlertIntruderClosed',
    AlertIntruderOpened = 'AlertIntruderOpened',
    AlertIntruderPolice = 'AlertIntruderPolice',
    AlertIntruderChanged = 'AlertIntruderChanged',
    PasswordResetGo = 'PasswordResetGo'
}

export enum EnumInvoiceStatus {
    Draft = 'DRAFT',
    Submitted = 'SUBMITTED',
    Deleted = 'DELETED',
    Authorised = 'AUTHORISED',
    Paid = 'PAID',
    Voided = 'VOIDED'
}

export enum EnumMaintainanceTask {
    MotionGridsIncorrect = 'MotionGridsIncorrect',
    CameraObstruction = 'CameraObstruction',
    CameraMoved = 'CameraMoved'
}

export enum EnumMonitoringEventType {
    Unknown = 'Unknown',
    CameraOnline = 'CameraOnline',
    CameraOffline = 'CameraOffline',
    CameraTampered = 'CameraTampered',
    CameraFailRecord = 'CameraFailRecord',
    CameraOverheated = 'CameraOverheated',
    CameraMotion = 'CameraMotion',
    PersonSeen = 'PersonSeen',
    PersonLoitering = 'PersonLoitering',
    PersonCount = 'PersonCount',
    PersonWallScale = 'PersonWallScale',
    VehicleSeen = 'VehicleSeen',
    SoundDetected = 'SoundDetected',
    Analytic = 'Analytic'
}

export enum EnumProductType {
    Unknown = 'Unknown',
    AssetRental = 'AssetRental',
    OneOffCharge = 'OneOffCharge',
    RecurringCharge = 'RecurringCharge'
}

export enum EnumProjectAction {
    ArmProfileChanged = 'ArmProfileChanged',
    SirenProfileChanged = 'SirenProfileChanged',
    NoThreatDispositionChanged = 'NoThreatDispositionChanged',
    MonitoringZoneUpdated = 'MonitoringZoneUpdated',
    NameChanged = 'NameChanged',
    CompanyChanged = 'CompanyChanged',
    NewMonitoringAlertsAfterSecondsChanged = 'NewMonitoringAlertsAfterSecondsChanged',
    SirenCooldownSecondsChanged = 'SirenCooldownSecondsChanged',
    SirensUnlinkedChanged = 'SirensUnlinkedChanged',
    GuardResponseEnabledChanged = 'GuardResponseEnabledChanged',
    GuardResponseDispatchCodeChanged = 'GuardResponseDispatchCodeChanged',
    ComplianceEnabledChanged = 'ComplianceEnabledChanged',
    SiteNotesChanged = 'SiteNotesChanged',
    AiAutomationLevelChanged = 'AiAutomationLevelChanged',
    AiPrimerChanged = 'AiPrimerChanged',
    NoThreatAiPrimerChanged = 'NoThreatAiPrimerChanged',
    TimeZoneChanged = 'TimeZoneChanged',
    AddressChanged = 'AddressChanged',
    DetectionLabelsChanged = 'DetectionLabelsChanged',
    ExternalServiceOptionsChanged = 'ExternalServiceOptionsChanged',
    ArchivedAtChanged = 'ArchivedAtChanged',
    ScheduleChanged = 'ScheduleChanged',
    GridChanged = 'GridChanged',
    CalendarEventChanged = 'CalendarEventChanged'
}

export enum EnumProjectMemberType {
    Unknown = 'Unknown',
    MonitoringCompany = 'MonitoringCompany',
    Client = 'Client',
    Admin = 'Admin',
    Nvr = 'NVR'
}

export enum EnumReportType {
    AssetActivity = 'AssetActivity',
    AssetJourney = 'AssetJourney'
}

export enum EnumSensorType {
    Acc = 'Acc',
    Temperature = 'Temperature',
    Humidity = 'Humidity',
    Gps = 'Gps',
    Rssi = 'Rssi',
    Battery = 'Battery',
    Zone = 'Zone',
    BeaconProximity = 'BeaconProximity'
}

export enum EnumSirenProfile {
    All = 'All',
    None = 'None',
    Intruder = 'Intruder'
}

export enum EnumValueType {
    AccX = 'AccX',
    AccY = 'AccY',
    AccZ = 'AccZ',
    Temperature = 'Temperature',
    Humidity = 'Humidity',
    Battery = 'Battery',
    Rssi = 'Rssi',
    Zone = 'Zone',
    TransmissionPower = 'TransmissionPower',
    Distance = 'Distance',
    Latitude = 'Latitude',
    Longitude = 'Longitude',
    GpsAccuracy = 'GpsAccuracy'
}

export enum EnumVideoProcessor {
    UmboCv = 'UmboCv',
    ThreeDEye = 'ThreeDEye',
    Smtp = 'Smtp',
    Milestone = 'Milestone',
    Camect = 'Camect',
    NxWitness = 'NxWitness',
    HikVisionNvr = 'HikVisionNvr',
    DahuaCamera = 'DahuaCamera',
    OpenEye = 'OpenEye',
    IntegrationHub = 'IntegrationHub'
}

export enum EnumViewerType {
    Human = 'Human',
    Quill = 'Quill'
}

export enum EnumWebhookType {
    Umbo = 'Umbo',
    ThreeDEye = 'ThreeDEye',
    Smtp = 'Smtp',
    Milestone = 'Milestone',
    Camect = 'Camect',
    NxVms = 'NXVms',
    OpenEye = 'OpenEye',
    HikVisionNvr = 'HikVisionNvr',
    IntegrationHub = 'IntegrationHub'
}

export enum ExternalConnectionType {
    ExternalService = 'ExternalService',
    Vms = 'Vms'
}

export enum FilterOperator {
    And = 'And',
    Or = 'Or'
}

export enum IncidentSeverity {
    Unspecified = 'Unspecified',
    Low = 'Low',
    Medium = 'Medium',
    High = 'High'
}

export enum IntegrationLogLevel {
    Debug = 'Debug',
    Info = 'Info',
    Warning = 'Warning',
    Error = 'Error'
}

export enum IntegrationType {
    Nvr = 'Nvr',
    Camera = 'Camera',
    Sensor = 'Sensor',
    ExternalService = 'ExternalService',
    Vms = 'Vms',
    Relay = 'Relay',
    Speaker = 'Speaker'
}

export enum LogoType {
    Primary = 'Primary',
    Mini = 'Mini',
    Reversed = 'Reversed',
    MiniReversed = 'MiniReversed'
}

export enum MessageResponseCode {
    Ok = 'OK',
    BadRequest = 'BadRequest',
    Unauthorized = 'Unauthorized',
    Forbidden = 'Forbidden',
    NotFound = 'NotFound',
    Conflict = 'Conflict',
    InternalServerError = 'InternalServerError',
    NotImplemented = 'NotImplemented'
}

export enum MetricBreakdown {
    Site = 'Site',
    Customer = 'Customer',
    Camera = 'Camera',
    ViewerType = 'ViewerType',
    Disposition = 'Disposition',
    EventType = 'EventType',
    AlertStatus = 'AlertStatus',
    OffenceType = 'OffenceType',
    DeviceBrand = 'DeviceBrand',
    HasSpeaker = 'HasSpeaker',
    IngestionStage = 'IngestionStage',
    IngestionOutcome = 'IngestionOutcome',
    IngestionVendor = 'IngestionVendor'
}

export enum MetricCube {
    MonitoringEvents = 'MonitoringEvents',
    Alerts = 'Alerts',
    Assets = 'Assets',
    AssetDeletions = 'AssetDeletions',
    Sites = 'Sites',
    SitesArchived = 'SitesArchived',
    Customers = 'Customers',
    IngestionEvents = 'IngestionEvents'
}

export enum MetricGranularity {
    Hour = 'Hour',
    Day = 'Day',
    Week = 'Week',
    Month = 'Month',
    Quarter = 'Quarter',
    Year = 'Year'
}

export enum MetricMeasure {
    EventCount = 'EventCount',
    QuillPercent = 'QuillPercent',
    BillableEventCount = 'BillableEventCount',
    P50TimeToView = 'P50TimeToView',
    P95TimeToView = 'P95TimeToView',
    P99TimeToView = 'P99TimeToView',
    ActiveCameraCount = 'ActiveCameraCount',
    ActiveSiteCount = 'ActiveSiteCount',
    AlertCount = 'AlertCount',
    IncidentCount = 'IncidentCount',
    SlaBreachCount = 'SlaBreachCount',
    SlaBreachRate = 'SlaBreachRate',
    P50TimeToClose = 'P50TimeToClose',
    P95TimeToClose = 'P95TimeToClose',
    AvgTimeToClose = 'AvgTimeToClose',
    P50TimeToNotify = 'P50TimeToNotify',
    P95TimeToNotify = 'P95TimeToNotify',
    PoliceCalloutCount = 'PoliceCalloutCount',
    PoliceResponseCount = 'PoliceResponseCount',
    PoliceResponseRate = 'PoliceResponseRate',
    CameraCount = 'CameraCount',
    CameraWithSpeakerCount = 'CameraWithSpeakerCount',
    SiteCount = 'SiteCount',
    CustomerCount = 'CustomerCount',
    TotalCameraCount = 'TotalCameraCount',
    TotalSiteCount = 'TotalSiteCount',
    TotalCustomerCount = 'TotalCustomerCount',
    ArchivedSiteCount = 'ArchivedSiteCount',
    DeletedCameraCount = 'DeletedCameraCount',
    DeletedSiteCount = 'DeletedSiteCount',
    DeletedCustomerCount = 'DeletedCustomerCount',
    IngestionEventCount = 'IngestionEventCount',
    IngestionSuccessCount = 'IngestionSuccessCount',
    IngestionFailureCount = 'IngestionFailureCount',
    IngestionErrorCount = 'IngestionErrorCount',
    IngestionFailureRate = 'IngestionFailureRate',
    IngestionUniquePipelineCount = 'IngestionUniquePipelineCount',
    IngestionActiveCameraCount = 'IngestionActiveCameraCount',
    IngestionActiveSiteCount = 'IngestionActiveSiteCount'
}

export enum MetricSegment {
    Incidents = 'Incidents',
    PoliceCallouts = 'PoliceCallouts',
    PoliceResponses = 'PoliceResponses',
    SlaBreaches = 'SlaBreaches',
    Closed = 'Closed'
}

export enum MetricSortDirection {
    Asc = 'Asc',
    Desc = 'Desc'
}

export enum MetricSortField {
    Measure = 'Measure',
    Time = 'Time',
    Breakdown = 'Breakdown'
}

export enum MonitoringEventValueType {
    SnapshotImage = 'SnapshotImage',
    PreviewVideo = 'PreviewVideo',
    PersonCount = 'PersonCount',
    PersonSeen = 'PersonSeen',
    VehicleSeen = 'VehicleSeen',
    Unknown = 'Unknown',
    AnimalSeen = 'AnimalSeen',
    PreviewVideoLink = 'PreviewVideoLink',
    PreviewVideoMp4 = 'PreviewVideoMp4'
}

export enum PaymentTermType {
    None = 'NONE',
    Daysafterbilldate = 'DAYSAFTERBILLDATE',
    Daysafterbillmonth = 'DAYSAFTERBILLMONTH',
    Ofcurrentmonth = 'OFCURRENTMONTH',
    Offollowingmonth = 'OFFOLLOWINGMONTH'
}

export enum PlanAction {
    NoOp = 'NoOp',
    Create = 'Create',
    Update = 'Update',
    Delete = 'Delete'
}

export enum ResetSource {
    Portal = 'Portal',
    WatchfulGo = 'WatchfulGo'
}

export enum Roles {
    User = 'User',
    Monitoring = 'Monitoring',
    SalesPerson = 'SalesPerson',
    Installer = 'Installer',
    ProjectAdmin = 'ProjectAdmin',
    CompanyAdmin = 'CompanyAdmin',
    IntegratorAdmin = 'IntegratorAdmin',
    SuperAdmin = 'SuperAdmin',
    Nvr = 'NVR',
    Pbx = 'Pbx'
}

export enum SortOrder {
    Ascending = 'Ascending',
    Descending = 'Descending'
}

export enum StatusEnum {
    Active = 'ACTIVE',
    Archived = 'ARCHIVED',
    Deleted = 'DELETED'
}

export enum ValidationStatus {
    Pass = 'Pass',
    Error = 'Error',
    Warning = 'Warning',
    Unknown = 'Unknown'
}

export enum VideoStreamType {
    Embedded = 'Embedded',
    Mp4 = 'Mp4',
    Hls = 'Hls',
    Rtsp = 'Rtsp',
    Mjpeg = 'Mjpeg',
    MxPeg = 'MxPeg'
}

export interface AcceptSalesOrderDto {
  salesOrderId?: string;
  purchaseOrderNumber?: string | null;
}

export interface AccountBindingDto {
  id?: string | null;
  tenantId?: string;
  code?: string | null;
  xeroCode?: string | null;
  name?: string | null;
  xeroName?: string | null;
  type?: AccountType;
  xeroType?: AccountType;
  status?: StatusEnum;
  xeroStatus?: StatusEnum;
  description?: string | null;
  xeroDescription?: string | null;
  xeroId?: string | null;
}

export interface AccountCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  account?: AccountDto;
}

export interface AccountDto {
  id?: string | null;
  tenantId?: string;
  code?: string | null;
  name?: string | null;
  type?: AccountType;
  status?: StatusEnum;
  description?: string | null;
  xeroId?: string | null;
}

export interface AccountForm {
  id?: string | null;
  tenantId?: string;
  code?: string | null;
  name?: string | null;
  type?: AccountType;
  status?: StatusEnum;
  description?: string | null;
  xeroId?: string | null;
}

export interface AccountSearchDto {
  id?: string;
  xeroId?: string | null;
  code?: string | null;
  name?: string | null;
  type?: AccountType;
  status?: StatusEnum;
  description?: string | null;
}

export interface AckShift {
  requestor?: MessageRequestor;
  receivedAt?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
}

export interface ActivationZoneSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface AddAlertNoteDto {
  note?: string | null;
  author?: string | null;
  nonActioningNote?: boolean;
}

export interface AddProductToContractDto {
  fixedPrice?: number | null;
  dailyRate?: number | null;
  monthlyRate?: number | null;
  start?: string;
  end?: string | null;
  description?: string | null;
  quantity?: number;
}

export interface AddressDto {
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  postCode?: string | null;
  region?: string | null;
  country?: string | null;
  lat?: number | null;
  lon?: number | null;
}

export interface AddUserForm {
  userId?: string;
}

export interface AdminUserCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  user?: AdminUserDetails;
}

export interface AdminUserDetails {
  id?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  roles?: Array<string> | null;
  lockedOut?: boolean;
}

export interface AdminUserDto {
  tokenExpiry?: string;
  token?: string | null;
  id?: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  number?: string | null;
  smsAuthorised?: boolean;
  roles?: Array<string> | null;
  lockedOut?: boolean;
  userName?: string | null;
  tenantId?: string | null;
  availableTenants?: Array<TenantDetails> | null;
}

export interface AdminUserForm {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  roles?: Array<string> | null;
}

export interface AdminUserSearchDto {
  id?: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  roles?: Array<string> | null;
  canViewDevicePasswords?: boolean;
  smsEnabled?: boolean;
}

export interface AdminUsersSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<AdminUserSearchDto> | null;
}

export interface AiAnnotationFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  annotation?: string | null;
}

export interface AlertClosed {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  alert?: MonitoringAlertDto;
  actualStatus?: EnumAlertStatus;
}

export interface AlertDisarmed {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  alert?: MonitoringAlertDto;
}

export interface AlertDispositionWorkflowHistory {
  statusHistories?: {
        [key: string]: Array<Steps> | null;
    } | null;
}

export interface AlertDto {
  id?: string | null;
  hardwareId?: string;
  assetId?: string;
  code?: string | null;
  name?: string | null;
  description?: string | null;
  activateAfterMilliseconds?: number;
  exitBreachAfterMilliseconds?: number;
  sensorType?: EnumSensorType;
  valueOperator?: EnumAlertValueCombination;
  alertValues?: Array<DeviceAlertValueDto> | null;
  companyId?: string;
}

export interface AlertEventsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<MonitorAlertEventDto> | null;
}

export interface AlertFetchedForMonitor {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  alert?: MonitorAlertFullDto;
}

export interface AlertHeldOpen {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface AlertingActionDto {
  field?: string | null;
  key?: string | null;
  action?: PlanAction;
  currentValue?: unknown;
  proposedValue?: unknown;
  description?: string | null;
  warning?: string | null;
}

export interface AlertingChangeDto {
  groupName?: string | null;
  key?: string | null;
  description?: string | null;
  warning?: string | null;
  actions?: Array<AlertingActionDto> | null;
}

export interface AlertingChangeResultDto {
  changeId?: string | null;
  success?: boolean;
  error?: string | null;
}

export interface AlertingChangesApplied {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  scriptLog?: Array<IntegrationScriptLogDto> | null;
  results?: Array<AlertingChangeResultDto> | null;
}

export interface AlertingConfigurationFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  supportsAutoConfig?: boolean;
  scriptLog?: Array<IntegrationScriptLogDto> | null;
  plan?: AlertingConfigurationPlanDto;
}

export interface AlertingConfigurationPlanDto {
  deviceId?: string;
  groups?: Array<AlertingChangeDto> | null;
  readonly hasChanges?: boolean;
}

export interface AlertingSetupTypeDto {
  value?: string | null;
  label?: string | null;
  description?: string | null;
  recommended?: boolean | null;
}

export interface AlertingSetupTypesFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  supportsAutoConfig?: boolean;
  description?: string | null;
  setupTypes?: Array<AlertingSetupTypeDto> | null;
}

export interface AlertIntruderInfoSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface AlertLocation {
  lat?: number;
  lon?: number;
}

export interface AlertMaintainanceTask {
  alertId?: string;
  task?: EnumMaintainanceTask;
  videoProcessorId?: string | null;
}

export interface AlertMaintainanceTaskAdded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface AlertMetric {
  quantity?: number;
  status?: EnumAlertStatus;
  byCustomer?: Array<CustomerBreakdown> | null;
}

export interface AlertMonitoringOpenFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  openAlerts?: number;
  assigned?: number;
  unAssigned?: number;
  currentSlaBreach?: number;
  aboutToBreachSla?: number;
}

export interface AlertMonitoringOpenFetchedV2 {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  assigned?: number | null;
  unAssigned?: number | null;
}

export interface AlertMonitoringOverviewFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  currentLoggedInOfficers?: number;
  currentUnread?: number;
  currentPending?: number;
  missedManAlive?: number;
  slaBreached?: number;
  averageClosureTimeSeconds?: number | null;
  averageOpenTime?: number | null;
  falseAlarmPct?: number;
  metrics?: Array<AlertMetric> | null;
  alertLocations?: Array<AlertLocation> | null;
}

export interface AlertNoteAdded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface AlertNoteDto {
  id?: string;
  note?: string | null;
  author?: string | null;
  date?: string;
  metadata?: unknown;
}

export interface AlertNotesByQuillPredictionResponse {
  readonly data?: Array<AlertNotesByQuillPredictionResponseRow> | null;
  totalNotes?: number;
}

export interface AlertNotesByQuillPredictionResponseRow {
  quillPrediction?: string | null;
  noteCount?: number;
  percentage?: number;
}

export interface AlertPreviewDto {
  id?: string;
  occurred?: string;
  alertId?: string | null;
  projectId?: string;
  projectName?: string | null;
  companyId?: string;
  companyName?: string | null;
  lastEvent?: string;
  actionedBy?: string | null;
  actionedAt?: string | null;
  nextActionSlaDue?: string | null;
  hadSlaBreach?: boolean;
  closedAt?: string | null;
  isClosed?: boolean;
  status?: EnumAlertStatus;
  snapshot?: string | null;
}

export interface AlertProjectDto {
  name?: string | null;
  siteDisarmedUntil?: string | null;
  newMonitoringAlertsAfterSeconds?: number | null;
  siteDisarmedBy?: string | null;
}

export interface AlertReopened {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  alert?: MonitoringAlertDto;
}

export interface AlertStatusDto {
  status?: EnumAlertStatus;
  setBy?: string | null;
}

export interface AlertStatusSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  alert?: MonitoringAlertDto;
}

export interface AlertStatusSummary {
  totalNew?: number;
  totalFalsePositive?: number;
  totalConfirmedStaff?: number;
  totalIntruder?: number;
  totalNoThreat?: number;
  totalSuspiciousPerson?: number;
  totalPossiblyStaff?: number;
  totalOther?: number;
  grandTotal?: number;
}

export interface ApiTokenForm {
  type?: ApiType;
  url?: string | null;
  token?: string | null;
}

export interface ApplyAlertingChangesForm {
  changeIds?: Array<string> | null;
}

export interface ApprovedRentalAssetDto {
  assetId?: string;
  type?: string | null;
  ownedByCustomerId?: string | null;
  accountId?: string;
}

export interface AquiredLicenceDto {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  companyId?: string;
  projectId?: string;
  expires?: string | null;
  aquired?: string | null;
}

export interface ArmStatusFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  status?: CurrentArmState;
  causedBy?: string | null;
  extraInfo?: string | null;
}

export interface AssetActivityReportGenerated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  attributes?: string | null;
  name?: string | null;
  assets?: Array<AssetReportDto> | null;
}

export interface AssetAddedToContract {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  contractAsset?: ContractAssetDto;
}

export interface AssetCommercialsChanged {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  contractAsset?: ContractAssetDto;
}

export interface AssetComponentDto {
  id?: string;
  type?: ComponentType;
  userName?: string | null;
}

export interface AssetCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  asset?: AssetDto;
}

export interface AssetDayUtilisation {
  day?: string;
  installs?: number;
  removals?: number;
  stock?: number;
  rented?: number;
}

export interface AssetDto {
  id?: string | null;
  name?: string | null;
  externalId?: string | null;
  groupId?: string | null;
  companyId?: string;
  projectId?: string;
  hasHardware?: boolean;
  groupName?: string | null;
  groupType?: AssetType;
  zoneId?: string | null;
  siteId?: string | null;
  location?: string | null;
  lastSensorUpdate?: string | null;
  deletedAt?: string | null;
  videoProcessorConfigs?: Array<AssetVideoConfigDto> | null;
  phoneNumber?: string | null;
  address?: AddressDto;
  serialNumber?: string | null;
  components?: Array<AssetComponentDto> | null;
  relays?: Array<RelayDto> | null;
  speakers?: Array<SpeakerDto> | null;
}

export interface AssetExtendedDto {
  id?: string | null;
  name?: string | null;
  externalId?: string | null;
  groupId?: string | null;
  companyId?: string;
  projectId?: string;
  hasHardware?: boolean;
  groupName?: string | null;
  groupType?: AssetType;
  zoneId?: string | null;
  siteId?: string | null;
  location?: string | null;
  lastSensorUpdate?: string | null;
  deletedAt?: string | null;
  videoProcessorConfigs?: Array<AssetVideoConfigDto> | null;
  phoneNumber?: string | null;
  address?: AddressDto;
  serialNumber?: string | null;
  components?: Array<AssetComponentDto> | null;
  relays?: Array<RelayDto> | null;
  speakers?: Array<SpeakerDto> | null;
  integrationId?: string | null;
  nvrId?: string | null;
  routeNamespaceId?: string | null;
}

export interface AssetForm {
  name?: string | null;
  externalId?: string | null;
  groupId?: string;
  assetId?: string;
}

export interface AssetFullDto {
  id?: string | null;
  name?: string | null;
  externalId?: string | null;
  serialNumber?: string | null;
  groupId?: string | null;
  companyId?: string;
  projectId?: string;
  groupName?: string | null;
  groupType?: AssetType;
  address?: AddressDto;
  hardware?: Array<AssetHardwareFullDto> | null;
  deletedAt?: string | null;
  requiresLicences?: Array<LicenceDto> | null;
  hasLicences?: Array<AquiredLicenceDto> | null;
  inUseBy?: AssetUsageDto;
  videoProcessorConfigs?: Array<AssetVideoConfigDto> | null;
  relays?: Array<RelayDto> | null;
  speakers?: Array<SpeakerDto> | null;
}

export interface AssetFullFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  asset?: AssetFullDto;
}

export interface AssetGroupCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  assetGroup?: AssetGroupDto;
}

export interface AssetGroupDto {
  id?: string | null;
  name?: string | null;
  type?: AssetType;
  customField1?: string | null;
  companyId?: string | null;
}

export interface AssetGroupForm {
  name?: string | null;
  type?: AssetType;
  customField1?: string | null;
}

export interface AssetGroupSearchDto {
  id?: string;
  companyId?: string | null;
  name?: string | null;
  type?: AssetType;
  customField1?: string | null;
}

export interface AssetGroupsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<AssetGroupSearchDto> | null;
}

export interface AssetHardwareDto {
  hardwareId?: string;
  sensors?: Array<SensorData> | null;
  onSightId?: string | null;
  name?: string | null;
  type?: string | null;
}

export interface AssetHardwareFullDto {
  hardwareId?: string;
  type?: string | null;
  name?: string | null;
  sensors?: Array<SensorData> | null;
  alerts?: Array<AlertDto> | null;
}

export interface AssetLastSeenFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  hardwareSeen?: Array<HardwareSeenDto> | null;
}

export interface AssetLicenceGrant {
  expiry?: string | null;
}

export interface AssetLocationsFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  contractAssets?: Array<ContractAssetLocationDetails> | null;
  contracts?: Array<ContractLocationDetails> | null;
}

export interface AssetMetricDto {
  id?: string;
  name?: string | null;
  serialNumber?: string | null;
  address?: AddressDto;
  cameras?: Array<CameraMetrics> | null;
}

export interface AssetMoved {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  assetId?: string;
  newProjectId?: string;
  newCompanyId?: string;
}

export interface AssetNotificationDto {
  occurred?: string;
  id?: string;
  assetId?: string;
  assetName?: string | null;
  assetUserId?: string | null;
  assetUserName?: string | null;
  notificationType?: AssetNotificationType;
}

export interface AssetNotificationsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<AssetNotificationDto> | null;
}

export interface AssetPublicDto {
  id?: string;
  name?: string | null;
  licencesRequired?: Array<LicencePublicDto> | null;
}

export interface AssetRelocated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface AssetRemovedFromContract {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface AssetReportDto {
  assetId?: string;
  name?: string | null;
  seen?: Array<ZoneSeenDto> | null;
  deletedAt?: string | null;
  assetGroupId?: string;
  assetGroupName?: string | null;
  assetGroupType?: AssetType;
}

export interface AssetSensorHistoryFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  startDate?: string;
  endDate?: string;
  interval?: TimeSpan;
  data?: Array<DataSet> | null;
}

export interface AssetSensorsFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  hardware?: Array<AssetHardwareDto> | null;
}

export interface AssetSetNonRentable {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface AssetsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<AssetExtendedDto> | null;
}

export interface AssetSuppressionCandidatesFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  suppressionCandidates?: Array<SuppressionCandidate> | null;
}

export interface AssetTypeBillingItem {
  type?: string | null;
  total?: number | null;
  quantity?: number | null;
}

export interface AssetTypeDto {
  name?: string | null;
}

export interface AssetUsageDto {
  usedById?: string;
  assetName?: string | null;
  expires?: string;
}

export interface AssetUtilisationReportFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  utilisation?: Array<AssetDayUtilisation> | null;
}

export interface AssetVideoConfigDto {
  videoProcessor?: EnumVideoProcessor;
  videoProcessorId?: string | null;
  name?: string | null;
  description?: string | null;
  externalId?: string | null;
  aiPrimer?: string | null;
  notes?: string | null;
  id?: string;
  activationZoneWkt?: string | null;
  nvrId?: string | null;
  nvrDeviceName?: string | null;
  smtpRtsp?: SmtpRtspDto;
  smtpParsingRule?: SmtpParsingRuleDto;
  externalConnectionId?: string | null;
}

export interface AssetVideoProcessorDto {
  videoProcessor?: EnumVideoProcessor;
  assetName?: string | null;
  description?: string | null;
  nvrDeviceName?: string | null;
  assetSerial?: string | null;
  assetId?: string;
  videoProcessorId?: string | null;
  videoProcessorConfigId?: string;
}

export interface AssignedHardwareFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  asset?: HardwareAssetDto;
}

export interface AssociatedHardwareDto {
  assetId?: string;
  hardwareId?: string;
  linkedAt?: string;
  linkEnded?: string | null;
  hardwareName?: string | null;
  hardwareType?: string | null;
}

export interface AssociatedMonitoringAlert {
  id?: string;
  alertId?: string | null;
  status?: EnumAlertStatus;
  notifiedAt?: string | null;
  event?: MonitorAlertEventDto;
  companyId?: string;
  projectId?: string;
  closed?: boolean;
}

export interface AuditLogSearchDto {
  description?: string | null;
  actionedBy?: string | null;
  actionedById?: string;
  objectId?: string;
  objectType?: EnumAuditLogObject;
  actionType?: string | null;
  happenedAt?: string;
  tenantId?: string | null;
  tenant?: string | null;
  objectName?: string | null;
}

export interface AuditLogSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<AuditLogSearchDto> | null;
}

export interface AuthTokenRequested {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface AuthTokenUsed {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  user?: AdminUserDto;
}

export interface BeaconCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  beacon?: BeaconDto;
}

export interface BeaconDto {
  id?: string;
  companyId?: string;
  mac?: string | null;
  name?: string | null;
  projectId?: string;
  password?: string | null;
  type?: string | null;
  customField1?: string | null;
  onSightId?: string | null;
  retiredAt?: string | null;
}

export interface BeaconForm {
  projectid?: string;
  mac?: string | null;
  customField1?: string | null;
  password?: string | null;
  type?: string | null;
  onSightId?: string | null;
  name?: string | null;
}

export interface BillingCycleContractDto {
  year?: number;
  month?: number;
  contractId?: string;
  contract?: string | null;
  customerId?: string;
  customer?: string | null;
  contractNumber?: string | null;
  creditNoteCount?: number;
  invoiceCount?: number;
}

export interface BillingCycleContractsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<BillingCycleContractDto> | null;
}

export interface BillingCycleDto {
  id?: string;
  year?: number;
  month?: number;
  yearMonth?: number;
  contracts?: number;
}

export interface BillingCyclesSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<BillingCycleDto> | null;
}

export interface BillingSearchDto {
  type?: BillingType;
  id?: string;
  name?: string | null;
  xeroId?: string | null;
  contractId?: string;
  contractName?: string | null;
  customerId?: string;
  customerName?: string | null;
  description?: string | null;
  billingDate?: string;
}

export interface BillingSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<BillingSearchDto> | null;
}

export interface BindXeroAccounts {
  requestor?: MessageRequestor;
  receivedAt?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
  dbAccounts?: Array<AccountBindingDto> | null;
  xeroToken?: string | null;
  xeroTokenExpires?: string | null;
  xeroTenantId?: string | null;
  xeroTenantShortCode?: string | null;
  billingEnabled?: boolean;
  xeroShortCode?: string | null;
}

export interface BlockDto {
  dayOfWeek?: number;
  blockIdx?: number;
  active?: boolean;
}

export interface BridgeConnectedAssetsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  sites?: Array<ConnectedSiteDto> | null;
  devices?: Array<ConnectedDeviceDto> | null;
  totalSites?: number;
  totalDevices?: number;
}

export interface CalendarDto {
  region?: string | null;
  calendarId?: string;
  events?: Array<CalendarEventDto> | null;
}

export interface CalendarEventCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  calendarEvent?: CalendarEventDto;
}

export interface CalendarEventDto {
  id: string;
  startDate: string;
  endDate: string;
  isEnabled: boolean;
  isPreset?: boolean;
  name: string;
  description?: string | null;
  verificationId?: string | null;
  armingEventType?: EnumArmingEventType;
}

export interface CalendarEventsFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  region?: string | null;
  calendarEvents?: Array<CalendarEventDto> | null;
}

export interface CalendarIdFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  calendarId?: string;
}

export interface CalendarRegionCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  calendar?: RegionalCalendarDto;
}

export interface CalendarRegionSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface CalendarRegionsFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  regions?: Array<RegionalCalendarDto> | null;
}

export interface CallLogDto {
  created?: string;
  agent?: string | null;
  monitoringCompanyId?: string;
  contactId?: string | null;
  number?: string | null;
  callDirection?: string | null;
  isMissedCall?: boolean;
  missedCallAcknowledgedAt?: string | null;
  id?: string;
  firstName?: string | null;
  lastName?: string | null;
  company?: string | null;
}

export interface CallLogsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<CallLogDto> | null;
}

export interface CameraDto {
  id?: string;
  model?: string | null;
  name?: string | null;
  vendor?: string | null;
  videoProcessorId?: UniqueVideoProcessorId;
  externalId?: string | null;
  monitored?: boolean;
  capabilities?: Capabilities;
  relays?: Array<RelayDto> | null;
  speakers?: Array<SpeakerDto> | null;
}

export interface CameraFeedUrlFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  url?: string | null;
  urlType?: VideoStreamType;
  liveUrl?: string | null;
  liveUrlType?: VideoStreamType;
  portalUrl?: string | null;
}

export interface CameraMetrics {
  id?: string;
  status?: EnumCameraStatus;
}

export interface CameraSuppressionsSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface CameraZoneForm {
  wkt?: string | null;
}

export interface Capabilities {
  canLivestream?: boolean | null;
  canPlayback?: boolean | null;
  canGetTriggerSettings?: boolean | null;
  canSetTriggerSettings?: boolean | null;
  canTalkdown?: boolean | null;
  canTriggerRelay?: boolean | null;
}

export interface ChartOfAccountsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<AccountSearchDto> | null;
  xeroConnected?: boolean;
}

export interface ClientOptions {
  baseUrl: `${string}://schema-monitor.json` | (string & {});
}

export interface CloseAlertDto {
  alertId?: string;
  closingAuthor?: string | null;
  resolution?: string | null;
  tempDisarmMinutes?: number | null;
  expectedStatus?: EnumAlertStatus;
  forceStatus?: EnumAlertStatus;
}

export interface CloseAlertForm {
  closingAuthor: string;
  resolution: string;
}

export interface CloseComplianceForm {
  disposition?: string | null;
}

export interface CompaniesSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<CompanySearchDto> | null;
}

export interface CompanyAccessDto {
  id?: string;
  name?: string | null;
  projects?: Array<ProjectAccessDto> | null;
  tenantId?: string;
}

export interface CompanyCredentialDto {
  id?: string;
  companyId?: string | null;
  token?: string | null;
  expiry?: string | null;
  type?: ApiType;
  url?: string | null;
  onSightId?: string;
}

export interface CompanyCredentialsCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface CompanyCredentialsFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  credentials?: Array<CompanyCredentialDto> | null;
}

export interface CompanyCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  company?: CompanyDto;
}

export interface CompanyDto {
  id?: string | null;
  name?: string | null;
  onSightId?: string | null;
  credentials?: Array<LoginCredentialDto> | null;
  supportEmail?: string | null;
  supportPhone?: string | null;
  tenantId?: string;
  externalServiceOptions?: {
        [key: string]: {
            [key: string]: string;
        } | null;
    } | null;
}

export interface CompanyInfoDto {
  id?: string;
  name?: string | null;
  projects?: Array<ProjectInfoDto> | null;
  supportEmail?: string | null;
  supportPhone?: string | null;
  tenantId?: string;
}

export interface CompanyInfoFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  company?: CompanyInfoDto;
}

export interface CompanyProjectOverview {
  id?: string | null;
  name?: string | null;
  address?: AddressDto;
  sirenProfile?: EnumSirenProfile;
  armProfile?: EnumArmProfile;
  isCurrentlyArmed?: boolean;
  assets?: Array<AssetMetricDto> | null;
  armStatusReason?: string | null;
  lastStaffAlert?: ProjectAlertDto;
  lastIntruderAlert?: ProjectAlertDto;
  sirenActiveLastHour?: boolean;
}

export interface CompanySearchDto {
  id?: string;
  name?: string | null;
}

export interface CompanySystemMetricsFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  projects?: Array<CompanyProjectOverview> | null;
}

export interface ComplianceDay {
  year?: number;
  month?: number;
  day?: number;
  count?: number;
  type?: EnumComplianceEventType;
}

export interface ComplianceDayGroup {
  days?: Array<ComplianceDay> | null;
  type?: EnumComplianceEventType;
}

export interface ComplianceDayReportFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  dataSets?: Array<ComplianceDayGroup> | null;
}

export interface ComplianceEventClosed {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  disposition?: string | null;
}

export interface ComplianceEventDto {
  id?: string;
  occurred?: string;
  assetId?: string;
  assetName?: string | null;
  projectId?: string;
  companyId?: string;
  videoProcessorId?: string | null;
  values?: Array<ComplianceEventValueSearchDto> | null;
  projectName?: string | null;
  companyName?: string | null;
  videoProcessor?: EnumVideoProcessor;
  activationZone?: string | null;
  closedAt?: string | null;
}

export interface ComplianceEventsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ComplianceEventDto> | null;
}

export interface ComplianceEventValueSearchDto {
  id?: string;
  type?: EnumComplianceEventValueType;
  fetched?: boolean;
  value?: number | null;
  txtValue?: string | null;
  sourceUrl?: string | null;
}

export interface ComplianceHour {
  hour?: number;
  count?: number;
  type?: EnumComplianceEventType;
}

export interface ComplianceHourGroup {
  type?: EnumComplianceEventType;
  hours?: Array<ComplianceHour> | null;
}

export interface ComplianceHourReportFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  dataSets?: Array<ComplianceHourGroup> | null;
}

export interface ComponentAuditDto {
  id?: string;
  userEmail?: string | null;
  userId?: string;
  component?: string | null;
  componentId?: string;
  type?: EnumComponentAuditLogType;
  description?: string | null;
  componentType?: ComponentType;
  hardwareId?: string | null;
  assetId?: string;
  assetName?: string | null;
  assetSerialNumber?: string | null;
  date?: string;
}

export interface ComponentDto {
  id?: string | null;
  rentalAssetId?: string;
  type?: ComponentType;
  hardwareType?: string | null;
  hardwareId?: string | null;
  description?: string | null;
}

export interface ComponentPasswordFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  password?: string | null;
  userName?: string | null;
}

export interface ConnectedDeviceDto {
  id?: string;
  name?: string | null;
  integrationName?: string | null;
  routeNamespaceId?: string | null;
  customerId?: string;
  customerName?: string | null;
  siteId?: string | null;
  siteName?: string | null;
}

export interface ConnectedDeviceFilter {
  key?: string | null;
  displayName?: string | null;
  required?: boolean;
  allowFreeText?: boolean | null;
}

export interface ConnectedSiteDto {
  id?: string;
  name?: string | null;
  companyId?: string;
  companyName?: string | null;
  isActive?: boolean;
  defaultRouteNamespaceId?: string | null;
}

export interface ConnectNewDevice {
  requestor?: MessageRequestor;
  receivedAt?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
  id?: string | null;
  name?: string | null;
  description?: string | null;
  serialNumber?: string | null;
  integrationId?: string;
  customerId?: string;
  projectId?: string;
  address?: AddressDto;
  fields?: {
        [key: string]: unknown;
    } | null;
  routeNamespaceId?: string | null;
}

export interface ContactDto {
  id?: string;
  email?: string | null;
  phone?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  role?: string | null;
  company?: string | null;
}

export interface ContactEventAdded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface ContactEventDto {
  occurred?: string;
  to?: string | null;
  toId?: string | null;
  sentBy?: string | null;
  type?: EnumContactEventType;
  body?: string | null;
  successful?: boolean;
  parentEventId?: string | null;
  pending?: boolean;
  id?: string;
}

export interface ContactsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ContactDto> | null;
}

export interface ContractAssetChangeDto {
  id?: string;
  contractId?: string;
  effectiveFrom?: string;
  dailyRate?: number;
  monthlyRate?: number;
  damageWaverChargePercent?: number | null;
}

export interface ContractAssetDto {
  id?: string | null;
  lineItemId?: string | null;
  contractId?: string;
  assetId?: string | null;
  assetName?: string | null;
  productId?: string;
  productName?: string | null;
  description?: string | null;
  siteAccessInstructions?: string | null;
  dailyRate?: number;
  monthlyRate?: number;
  plannedStartDate?: string;
  plannedEndDate?: string;
  installationDate?: string | null;
  removalDate?: string | null;
  returnDate?: string | null;
  address?: AddressDto;
  assetIdCode?: string | null;
  installationBilled?: boolean | null;
  removalCredited?: boolean | null;
  customerOwned?: boolean;
  installationCharge?: number;
  damageWaverChargePercent?: number | null;
  contractTerms?: Array<ContractAssetTermDto> | null;
}

export interface ContractAssetInstalled {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface ContractAssetLocationDetails {
  id?: string;
  assetName?: string | null;
  address?: AddressDto;
  assetId?: string;
  contractId?: string;
  contractIdentifier?: string | null;
  customerId?: string;
  customerName?: string | null;
  salesPeople?: Array<SalesPersonDto> | null;
}

export interface ContractAssetSearchDto {
  contractId?: string;
  contractName?: string | null;
  customerId?: string;
  customerName?: string | null;
  assetId?: string;
  assetNumber?: string | null;
  assetType?: string | null;
  assetDescription?: string | null;
  siteAccessInstructions?: string | null;
  dailyRate?: number;
  monthlyRate?: number;
  plannedStartDate?: string;
  plannedEndDate?: string;
  accountNumber?: string | null;
  installationDate?: string | null;
  removalDate?: string | null;
  returnDate?: string | null;
  id?: string;
  customerContractName?: string | null;
  customerOwned?: boolean;
  processorTypes?: Array<EnumVideoProcessor> | null;
}

export interface ContractAssetsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ContractAssetSearchDto> | null;
}

export interface ContractAssetTermDto {
  startDate?: string;
  endDate?: string | null;
  damageWaverChargePercent?: number | null;
  dailyRate?: number;
  monthlyRate?: number;
}

export interface ContractAssetUninstalled {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface ContractAssetUpdated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  contractAsset?: ContractAssetDto;
}

export interface ContractAssetUpdateDto {
  id?: string;
  siteAccessInstructions?: string | null;
  dailyRate?: number;
  monthlyRate?: number;
  plannedStartDate?: string;
  plannedEndDate?: string;
  address?: AddressDto;
  installationCharge?: number;
  damageWaverChargePercent?: number | null;
  siteDescription?: string | null;
}

export interface ContractCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  contract?: ContractDto;
}

export interface ContractDto {
  id?: string | null;
  name?: string | null;
  billingCycle?: EnumBillingCycle;
  status?: EnumContractStatus;
  startDate?: string | null;
  endDate?: string | null;
  expectedEndDate?: string | null;
  billingDayOfMonth?: number;
  siteAccessInstructions?: string | null;
  damageWaverChargePct?: number;
  installationCharge?: number;
  purchaseOrderNo?: string | null;
  customerId?: string;
  address?: AddressDto;
  customerContractName?: string | null;
  contractId?: string | null;
  createdById?: string | null;
  hasBilled?: boolean;
}

export interface ContractFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  contract?: FetchContractDto;
}

export interface ContractForm {
  name?: string | null;
  customerContractName?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  expectedEndDate?: string | null;
  billingDayOfMonth?: number;
  siteAccessInstructions?: string | null;
  damageWaverChargePct?: number;
  installationCharge?: number;
  purchaseOrderNo?: string | null;
  customerId?: string;
  address?: AddressDto;
  billingCycle?: EnumBillingCycle;
}

export interface ContractLocationDetails {
  id?: string;
  name?: string | null;
  address?: AddressDto;
  contractId?: string | null;
}

export interface ContractProductDto {
  id?: string;
  contractId?: string;
  contractName?: string | null;
  contractNumber?: string | null;
  productId?: string;
  productName?: string | null;
  productType?: EnumProductType;
  quantity?: number;
  startDate?: string | null;
  endDate?: string | null;
  dailyCost?: number | null;
  monthlyCost?: number | null;
  description?: string | null;
  fixedCost?: number | null;
  isRecurring?: boolean;
  isAssetRental?: boolean;
  installationCharge?: number | null;
  damageWaiverPct?: number | null;
}

export interface ContractProductsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ContractProductDto> | null;
}

export interface ContractSearchDto {
  id?: string;
  name?: string | null;
  customer?: string | null;
  customerId?: string;
  assetCount?: number;
  customerContractName?: string | null;
  contractId?: string | null;
  status?: EnumContractStatus;
  startDate?: string | null;
  plannedEndDate?: string | null;
  deletedAt?: string | null;
  purchaseOrderNo?: string | null;
  projectId?: string | null;
}

export interface ContractsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ContractSearchDto> | null;
}

export interface CreateAssetForm {
  name?: string | null;
  externalId?: string | null;
  groupId?: string;
}

export interface CreateBridgeDto {
  name?: string | null;
  type?: ConnectionType;
  userConfig?: string | null;
  initialRouteCidr?: string | null;
}

export interface CreateCompanyForm {
  name?: string | null;
  apiKey?: string | null;
  onSightId?: string;
  url?: string | null;
  supportEmail?: string | null;
  supportPhone?: string | null;
}

export interface CreateContractForm {
  name?: string | null;
  customerContractName?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  expectedEndDate?: string | null;
  billingDayOfMonth?: number;
  siteAccessInstructions?: string | null;
  damageWaverChargePct?: number;
  installationCharge?: number;
  purchaseOrderNo?: string | null;
  customerId?: string;
  address?: AddressDto;
  ownerId?: string;
  billingCycle?: EnumBillingCycle;
}

export interface CreatedIntegration {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  id?: string;
  name?: string | null;
  integrationType?: number;
  sourceType?: number;
  brand?: string | null;
  docs?: string | null;
  description?: string | null;
  smtpSource?: boolean | null;
  webhookSource?: boolean | null;
  watchfulLifecycleTrigger?: boolean | null;
}

export interface CreateExternalConnectionDevice {
  requestor?: MessageRequestor;
  receivedAt?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
  id?: string | null;
  name?: string | null;
  description?: string | null;
  serialNumber?: string | null;
  externalConnectionId?: string;
  customerId?: string;
  projectId?: string;
  address?: AddressDto;
  deviceCreationChoices?: {
        [key: string]: string | null;
    } | null;
  routeNamespaceId?: string | null;
}

export interface CreateIntegration {
  requestor?: MessageRequestor;
  receivedAt?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
  key?: string | null;
  name?: string | null;
  integrationType?: IntegrationType;
  sourceType?: number;
  brand?: string | null;
  docs?: string | null;
  description?: string | null;
  smtpSource?: boolean | null;
  webhookSource?: boolean | null;
}

export interface CreateProjectForm {
  name?: string | null;
}

export interface CreateRentalAssetDto {
  name?: string | null;
  description?: string | null;
  assetId?: string | null;
  type?: string | null;
  xeroId?: string | null;
  customerId?: string | null;
  buildDate?: string | null;
}

export interface CreateRouteDto {
  namespaceId?: string;
  edgeAddressRangeCidr?: string | null;
  mappedAddressRange?: string | null;
}

export interface CreateUserForm {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

export interface CreateZoneForm {
  name?: string | null;
  description?: string | null;
  wkt?: string | null;
}

export interface CreateZoneFromExistingForm {
  name?: string | null;
  description?: string | null;
  wkt?: string | null;
  onSightId?: string;
}

export interface CredentialsForm {
  type?: ApiType;
  url?: string | null;
  userName?: string | null;
  password?: string | null;
}

export interface CreditNoteFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  creditNote?: FullCreditNoteDto;
}

export interface CreditNoteLineDto {
  xeroId?: string | null;
  accountId?: string;
  contractRentalAssetId?: string | null;
  description?: string | null;
  quantity?: number | null;
  unitPrice?: number | null;
  total?: number | null;
  accountCode?: string | null;
  itemCode?: string | null;
  taxAmount?: number | null;
  taxType?: string | null;
  accountName?: string | null;
}

export interface CreditNoteSearchDto {
  id?: string;
  contractId?: string;
  contractName?: string | null;
  customerId?: string;
  customerName?: string | null;
  description?: string | null;
  billingDate?: string;
  status?: EnumCreditNoteStatus;
}

export interface CreditNotesSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<CreditNoteSearchDto> | null;
}

export interface CrudPrimaryDeviceFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  device?: NvrFullDto;
}

export interface CrudProject {
  requestor?: MessageRequestor;
  receivedAt?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
  operation?: CrudOperation;
  project?: ProjectDto;
}

export interface CrudSecondaryDevicesUpdated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface CrudSmtpParserDto {
  id?: string | null;
  name?: string | null;
  datePrefix?: string | null;
  dateRegex?: string | null;
  dateFormat?: string | null;
  channelPrefix?: string | null;
  channelRegex?: string | null;
  eventTypePrefix?: string | null;
  eventTypeRegex?: string | null;
  eventParsingRules?: Array<MonitoringEventParserDto> | null;
}

export interface CrudUpdateSecondaryDevice {
  requestor?: MessageRequestor;
  receivedAt?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
  primaryDeviceId?: string;
  overrideNvrId?: string | null;
  devices?: Array<UpdateSecondaryDeviceRequest> | null;
}

export interface CurrentShiftFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  shift?: ShiftDto;
  requiresShift?: boolean;
}

export interface CurrentShiftFetchedV2 {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  shift?: ShiftDto;
  requiresShift?: boolean;
}

export interface CustomerBreakdown {
  companyId?: string;
  company?: string | null;
  total?: number;
}

export interface CustomerContactDto {
  firstName?: string | null;
  lastName?: string | null;
  isBillingContact?: boolean;
  emailAddress?: string | null;
  phoneNumber?: string | null;
  roleTitle?: string | null;
}

export interface CustomerCreated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  customerId?: string;
}

export interface CustomerCreateDto {
  name?: string | null;
  accountNumber?: string | null;
  fullName?: string | null;
  address?: AddressDto;
}

export interface CustomerDto {
  id?: string;
  name?: string | null;
  accountNumber?: string | null;
  salesDueDay?: number | null;
  salesDueType?: PaymentTermType;
  email?: string | null;
  phoneNumber?: string | null;
  xeroId?: string | null;
  contacts?: Array<CustomerContactDto> | null;
  monitoringEnabled?: boolean;
  archived?: boolean;
  address?: AddressDto;
}

export interface CustomerFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  customer?: CustomerDto;
}

export interface CustomerSearchDto {
  id?: string;
  name?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  fullName?: string | null;
  accountNumber?: string | null;
  address?: AddressDto;
  archived?: boolean;
  hasContracts?: boolean;
}

export interface CustomersSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<CustomerSearchDto> | null;
}

export interface CustomerUpdated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  customer?: CustomerDto;
}

export interface CustomerUpdateDto {
  id?: string;
  name?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  accountNumber?: string | null;
  salesDueDay?: number | null;
  salesDueType?: PaymentTermType;
  monitoringEnabled?: boolean;
  archived?: boolean;
  address?: AddressDto;
}

export interface DailyAlertsForMonthResponse {
  readonly data?: Array<DailyAlertsForMonthResponseRow> | null;
  summary?: AlertStatusSummary;
}

export interface DailyAlertsForMonthResponseRow {
  day?: string | null;
  newAlerts?: number;
  falsePositiveAlerts?: number;
  confirmedStaffAlerts?: number;
  intruderAlerts?: number;
  noThreatAlerts?: number;
  suspiciousPersonAlerts?: number;
  possiblyStaffAlerts?: number;
  otherAlerts?: number;
  totalAlerts?: number;
}

export interface DailyEventsForMonthResponse {
  readonly data?: Array<DailyEventsForMonthResponseRow> | null;
  totalEvents?: number;
}

export interface DailyEventsForMonthResponseRow {
  day?: string | null;
  eventCount?: number;
}

export interface DashboardForm {
  name?: string | null;
  widgetDefinition?: string | null;
}

export interface DashboardName {
  id?: string;
  name?: string | null;
}

export interface DataPoint {
  time?: string;
  value?: number | null;
}

export interface DataSet {
  assetId?: string;
  hardwareId?: string;
  sensorVaueType?: EnumValueType;
  aggregation?: AggregationType;
  points?: Array<DataPoint> | null;
}

export interface DaySchedule {
  day?: DayOfWeek;
  timeRanges?: Array<TimeRange> | null;
}

export interface DeleteClearDeploymentEdgeLinkDeploymentData {
  body?: never;
  path: {
        package: string;
    };
  query?: never;
  url: '/edgelinks/deployments/{package}';
}

export interface DeleteClearDeploymentEdgeLinkDeploymentResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface DeleteClearIntegrationKvStoreIntegrationData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/manage/{id}/kvstore';
}

export interface DeleteClearIntegrationKvStoreIntegrationResponses {
  /**
     * Success
     */
    200: IntegrationKvStoreCleared;
}

export interface DeleteClearIntegrationPollsIntegrationData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/manage/{id}/polls';
}

export interface DeleteClearIntegrationPollsIntegrationResponses {
  /**
     * Success
     */
    200: IntegrationPollsCleared;
}

export interface DeleteDeleteAdminEventCalendarData {
  body?: CalendarEventDto;
  path: {
        calendarId: string;
    };
  query?: never;
  url: '/Calendar/{calendarId}/admin/delete';
}

export interface DeleteDeleteAdminEventCalendarResponses {
  /**
     * Success
     */
    200: CalendarEventCrudded;
}

export interface DeleteDeleteAssetAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}';
}

export interface DeleteDeleteAssetAssetResponses {
  /**
     * Success
     */
    200: AssetCrudded;
}

export interface DeleteDeleteContractContractsData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/customer/Contracts/{id}';
}

export interface DeleteDeleteContractContractsResponses {
  /**
     * Success
     */
    200: ContractCrudded;
}

export interface DeleteDeleteDashboardProjectData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        dashboardId: string;
    };
  query?: never;
  url: '/company/{companyId}/Project/{projectId}/dashboard/{dashboardId}';
}

export interface DeleteDeleteDashboardProjectResponses {
  /**
     * Success
     */
    200: WidgetsCrudded;
}

export interface DeleteDeleteEdgeLinksData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/EdgeLinks/bridges/{id}';
}

export interface DeleteDeleteEdgeLinksResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface DeleteDeleteEventCalendarData {
  body?: CalendarEventDto;
  path: {
        calendarId: string;
    };
  query?: never;
  url: '/Calendar/{calendarId}/delete';
}

export interface DeleteDeleteEventCalendarResponses {
  /**
     * Success
     */
    200: CalendarEventCrudded;
}

export interface DeleteDeleteExternalConnectionExternalConnectionData {
  body?: never;
  path: {
        connectionId: string;
    };
  query?: never;
  url: '/Integration/ExternalConnection/{connectionId}';
}

export interface DeleteDeleteExternalConnectionExternalConnectionResponses {
  /**
     * Success
     */
    200: ExternalConnectionCrudded;
}

export interface DeleteDeleteGatewayGatewayData {
  body?: never;
  path: {
        companyId: string;
        gatewayId: string;
    };
  query?: never;
  url: '/company/{companyId}/Gateway/{gatewayId}';
}

export interface DeleteDeleteGatewayGatewayResponses {
  /**
     * Success
     */
    200: GatewayCrudded;
}

export interface DeleteDeleteIntegrationIntegrationData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/manage/{id}';
}

export interface DeleteDeleteIntegrationIntegrationResponses {
  /**
     * Success
     */
    200: IntegrationDeleted;
}

export interface DeleteDeleteLicenceLicenceData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        licenceId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Licence/{licenceId}';
}

export interface DeleteDeleteLicenceLicenceResponses {
  /**
     * Success
     */
    200: LicenceCrudded;
}

export interface DeleteDeleteMonitoringZoneMonitoringData {
  body?: ZoneForm;
  path: {
        projectId: string;
        zoneId: string;
    };
  query?: never;
  url: '/project/{projectId}/zone/{zoneId}';
}

export interface DeleteDeleteMonitoringZoneMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringZoneCrudded;
}

export interface DeleteDeleteRegionCalendarData {
  body?: never;
  path: {
        calendarId: string;
    };
  query?: never;
  url: '/Calendar/{calendarId}/create';
}

export interface DeleteDeleteRegionCalendarResponses {
  /**
     * Success
     */
    200: CalendarRegionCrudded;
}

export interface DeleteDeleteRelayRelayData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/Relay/{id}';
}

export interface DeleteDeleteRelayRelayResponses {
  /**
     * Success
     */
    200: RelayCrudded;
}

export interface DeleteDeleteReportReportData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        reportId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Report/{reportId}';
}

export interface DeleteDeleteReportReportResponses {
  /**
     * Success
     */
    200: ReportCrudded;
}

export interface DeleteDeleteRouteEdgeLinksData {
  body?: never;
  path: {
        bridgeId: string;
        routeId: string;
    };
  query?: never;
  url: '/EdgeLinks/bridges/{bridgeId}/routes/{routeId}';
}

export interface DeleteDeleteRouteEdgeLinksResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface DeleteDeleteSalesOrderLineOrderData {
  body?: never;
  path: {
        id: string;
        lineId: string;
    };
  query?: never;
  url: '/Order/{id}/line/{lineId}';
}

export interface DeleteDeleteSalesOrderLineOrderResponses {
  /**
     * Success
     */
    200: SalesOrderLineCrudded;
}

export interface DeleteDeleteSalesOrderLogOrderData {
  body?: never;
  path: {
        id: string;
        logId: string;
    };
  query?: never;
  url: '/Order/{id}/log/{logId}';
}

export interface DeleteDeleteSalesOrderLogOrderResponses {
  /**
     * Success
     */
    200: SalesOrderLogCrudded;
}

export interface DeleteDeleteSiteSiteData {
  body?: never;
  path: {
        companyId: string;
        siteId: string;
    };
  query?: never;
  url: '/company/{companyId}/Site/{siteId}';
}

export interface DeleteDeleteSiteSiteResponses {
  /**
     * Success
     */
    200: SiteCrudded;
}

export interface DeleteDeleteSmtpParserMonitoringData {
  body?: never;
  path: {
        smtpParserId: string;
    };
  query?: never;
  url: '/Monitoring/smtp/parsers/{smtpParserId}';
}

export interface DeleteDeleteSmtpParserMonitoringResponses {
  /**
     * Success
     */
    200: NvRecorderCrudded;
}

export interface DeleteDeleteSpeakerSpeakerData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/Speaker/{id}';
}

export interface DeleteDeleteSpeakerSpeakerResponses {
  /**
     * Success
     */
    200: SpeakerCrudded;
}

export interface DeleteDeleteUserCompanyData {
  body?: never;
  path: {
        companyId: string;
        userId: string;
    };
  query?: never;
  url: '/Company/{companyId}/user/{userId}';
}

export interface DeleteDeleteUserCompanyResponses {
  /**
     * Success
     */
    200: UserCruded;
}

export interface DeleteDeleteUserUsersData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Users/{id}';
}

export interface DeleteDeleteUserUsersResponses {
  /**
     * Success
     */
    200: AdminUserCrudded;
}

export interface DeleteDeleteZoneSiteData {
  body?: never;
  path: {
        companyId: string;
        siteId: string;
        zoneId: string;
    };
  query?: never;
  url: '/company/{companyId}/Site/{siteId}/zone/{zoneId}';
}

export interface DeleteDeleteZoneSiteResponses {
  /**
     * Success
     */
    200: ZoneCrudded;
}

export interface DeleteModifySimCardNetworkData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Network/simcard/{id}';
}

export interface DeleteModifySimCardNetworkResponses {
  /**
     * Success
     */
    200: SimConfigCrudded;
}

export interface DeleteRemoveAssetFromContractContractsData {
  body?: never;
  path: {
        contractId: string;
        contractAssetId: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/contractasset/{contractAssetId}/remove';
}

export interface DeleteRemoveAssetFromContractContractsResponses {
  /**
     * Success
     */
    200: AssetRemovedFromContract;
}

export interface DeleteRemoveComponentRentalAssetsData {
  body?: never;
  path: {
        assetId: string;
        componentId: string;
    };
  query?: never;
  url: '/RentalAssets/components/{assetId}/{componentId}';
}

export interface DeleteRemoveComponentRentalAssetsResponses {
  /**
     * Success
     */
    200: RentalAssetComponentCrudded;
}

export interface DeleteRemoveItemContractsData {
  body?: RemoveItemForm;
  path: {
        contractId: string;
        itemId: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/products/{itemId}';
}

export interface DeleteRemoveItemContractsResponses {
  /**
     * Success
     */
    200: ProductRemovedFromContract;
}

export interface DeleteRemoveLicenceGrantAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        grantedLicenceId: string;
        assetId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}/licencegrant/{grantedLicenceId}';
}

export interface DeleteRemoveLicenceGrantAssetResponses {
  /**
     * Success
     */
    200: LicenceGrantCrudded;
}

export interface DeleteRemoveLicenceRequirementAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
        licenceId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}/removelicencerequirement/{licenceId}';
}

export interface DeleteRemoveLicenceRequirementAssetResponses {
  /**
     * Success
     */
    200: LicenceRequirementCrudded;
}

export interface DeleteRemoveMonitoringOfficerMonitoringData {
  body?: never;
  path: {
        companyId: string;
        userId: string;
    };
  query?: never;
  url: '/Monitoring/companies/{companyId}/users/{userId}';
}

export interface DeleteRemoveMonitoringOfficerMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringOfficerCrudded;
}

export interface DeleteRemoveOrderOrderData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Order/{id}';
}

export interface DeleteRemoveOrderOrderResponses {
  /**
     * Success
     */
    200: SalesOrderCrudded;
}

export interface DeleteRemoveProjectContactCustomerData {
  body?: never;
  path: {
        customerId: string;
        projectId: string;
        contactId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}/contact/{contactId}';
}

export interface DeleteRemoveProjectContactCustomerResponses {
  /**
     * Success
     */
    200: ProjectContactCrudded;
}

export interface DeleteRemoveProjectMemberCustomerData {
  body?: never;
  path: {
        customerId: string;
        projectId: string;
        userId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}/user/{userId}';
}

export interface DeleteRemoveProjectMemberCustomerResponses {
  /**
     * Success
     */
    200: ProjectCrudded;
}

export interface DeleteRemoveProjectMonitoringCompanyCustomerData {
  body?: never;
  path: {
        customerId: string;
        projectId: string;
        monitoringCompanyId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}/monitoringcompany/{monitoringCompanyId}';
}

export interface DeleteRemoveProjectMonitoringCompanyCustomerResponses {
  /**
     * Success
     */
    200: ProjectMonitoringCompanySet;
}

export interface DeleteRemoveSalesPersonContractsData {
  body?: never;
  path: {
        contractId: string;
        salesPersonId: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/salesperson/{salesPersonId}';
}

export interface DeleteRemoveSalesPersonContractsResponses {
  /**
     * Success
     */
    200: SalesPersonCrudded;
}

export interface DeleteRemoveSystemMonitorTenantData {
  body?: never;
  path: {
        tenantId: string;
        monitorId: string;
    };
  query?: never;
  url: '/Tenant/{tenantId}/monitors/{monitorId}';
}

export interface DeleteRemoveSystemMonitorTenantResponses {
  /**
     * Success
     */
    200: TenantMonitoringCompanyCrudded;
}

export interface DeleteRemoveUserTenantData {
  body?: never;
  path: {
        tenantId: string;
        userId: string;
    };
  query?: never;
  url: '/Tenant/{tenantId}/users/{userId}';
}

export interface DeleteRemoveUserTenantResponses {
  /**
     * Success
     */
    200: TenantUserCrudded;
}

export interface DeleteRemoveVideoProcessorConfigRentalAssetsData {
  body?: never;
  path: {
        assetId: string;
        configId: string;
    };
  query?: never;
  url: '/RentalAssets/{assetId}/videoprocessor/{configId}';
}

export interface DeleteRemoveVideoProcessorConfigRentalAssetsResponses {
  /**
     * Success
     */
    200: VideoProcessorConfigCrudded;
}

export interface DeleteSkipTrainingEventAlertMonitoringData {
  body?: never;
  path: {
        eventId: string;
    };
  query?: never;
  url: '/AlertMonitoring/training/event/{eventId}/skip';
}

export interface DeleteSkipTrainingEventAlertMonitoringResponses {
  /**
     * Success
     */
    200: TrainingEventSkipped;
}

export interface DescribePeopleResponse {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  descriptions?: Array<PersonDescription> | null;
}

export interface Device {
  timezone?: TimeZoneInfo;
  name?: string | null;
  manufacturer?: string | null;
  brand?: string | null;
  family?: string | null;
  model?: string | null;
  modelId?: string | null;
  architecture?: string | null;
  batteryLevel?: number | null;
  isCharging?: boolean | null;
  isOnline?: boolean | null;
  orientation?: DeviceOrientation;
  simulator?: boolean | null;
  memorySize?: number | null;
  freeMemory?: number | null;
  usableMemory?: number | null;
  lowMemory?: boolean | null;
  storageSize?: number | null;
  freeStorage?: number | null;
  externalStorageSize?: number | null;
  externalFreeStorage?: number | null;
  screenResolution?: string | null;
  screenDensity?: number | null;
  screenDpi?: number | null;
  bootTime?: string | null;
  processorCount?: number | null;
  cpuDescription?: string | null;
  processorFrequency?: number | null;
  deviceType?: string | null;
  batteryStatus?: string | null;
  deviceUniqueIdentifier?: string | null;
  supportsVibration?: boolean | null;
  supportsAccelerometer?: boolean | null;
  supportsGyroscope?: boolean | null;
  supportsAudio?: boolean | null;
  supportsLocationService?: boolean | null;
}

export interface DeviceAlertValueDto {
  comparison?: EnumAlertOperation;
  valueType?: EnumValueType;
  level?: number;
}

export interface DeviceBundle {
  device?: NvrDto;
  cameras?: Array<CameraDto> | null;
}

export interface DeviceConfigurationValidated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  scriptLog?: Array<IntegrationScriptLogDto> | null;
  validationResults?: Array<ValidationResultDto> | null;
}

export interface DeviceDto {
  nvr?: NvrDto;
  customer?: CustomerDto;
  integration?: IntegrationLimitedDto;
  parentExternalServiceId?: string | null;
  routeNamespaceId?: string | null;
}

export interface DeviceSnapshotFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  timestamp?: string;
  b64Img?: string | null;
  deviceId?: string;
  mimeType?: string | null;
}

export interface DevicesSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  devices?: Array<DeviceDto> | null;
  totalRows?: number;
}

export interface DimensionValueDto {
  attributes?: {
        [key: string]: string | null;
    } | null;
}

export interface DimensionValuesResultDto {
  meta?: MetricMetaDto;
  values?: Array<DimensionValueDto> | null;
}

export interface DisarmDto {
  alertId?: string;
  disarmedBy?: string | null;
  reason?: string | null;
}

export interface DisarmProjectDto {
  projectId?: string;
  until?: string | null;
  disarmedBy?: string | null;
}

export interface DispositionWorkflowStepsSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface EmailHashResponse {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  userHash?: string | null;
  email?: string | null;
}

export interface EmailImageUploaded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  url?: string | null;
}

export interface EmailTemplateCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  email?: EmailTemplateDto;
}

export interface EmailTemplateDto {
  templateId?: string;
  from?: string | null;
  fromName?: string | null;
  subject?: string | null;
  emailType?: EnumEmailType;
  templateName?: string | null;
  body?: string | null;
  emailSystem?: EmailSystem;
  properties?: Array<string> | null;
}

export interface EmailTemplateRentalsCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  email?: EmailTemplateDto;
}

export interface EmailTemplatesFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  emailTemplates?: Array<EmailTemplateDto> | null;
}

export interface EncryptionKeySet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface EndShiftV2 {
  requestor?: MessageRequestor;
  receivedAt?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
}

export interface EntityLocation {
  type?: string | null;
  id?: string;
  name?: string | null;
  address?: AddressDto;
}

export interface EntityLocationReport {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  objects?: Array<EntityLocation> | null;
}

export interface EventViewedSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface ExtendedTenantDto {
  id?: string | null;
  name?: string | null;
  themePath?: string | null;
  urlBase?: string | null;
  themeVersion?: number;
  ingressEnabled?: boolean;
  primaryColour?: string | null;
  secondaryColour?: string | null;
}

export interface ExternalConnectionCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  externalConnection?: ExternalConnectionDto;
  devices?: Array<DeviceBundle> | null;
}

export interface ExternalConnectionDto {
  id?: string | null;
  tenantId?: string;
  authUserId?: string;
  type?: ExternalConnectionType;
  name?: string | null;
  description?: string | null;
  integrationId?: string;
  integration?: IntegrationFullDto;
  webhookAuthCredDto?: WebhookAuthCredDto;
  smtpUsername?: string | null;
  smtpPassword?: string | null;
  lastScanTime?: string | null;
  created?: string;
  updated?: string;
  availableDeviceCount?: number;
  routeNamespaceId?: string | null;
  integrationFields?: {
        [key: string]: unknown;
    } | null;
  deviceCreationKeyValues?: Array<ConnectedDeviceFilter> | null;
  deviceCreationChoices?: Array<{
        [key: string]: string;
    }> | null;
}

export interface ExternalConnectionIndexed {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  deviceCreationKeyValues?: Array<ConnectedDeviceFilter> | null;
  deviceCreationChoices?: Array<{
        [key: string]: string;
    }> | null;
  scriptLog?: Array<IntegrationScriptLogDto> | null;
}

export interface ExternalConnectionLimitedDto {
  id?: string | null;
  tenantId?: string;
  authUserId?: string;
  type?: ExternalConnectionType;
  name?: string | null;
  description?: string | null;
  integrationId?: string;
  integration?: IntegrationLimitedDto;
  webhookAuthCredDto?: WebhookAuthCredDto;
  smtpUsername?: string | null;
  smtpPassword?: string | null;
  lastScanTime?: string | null;
  created?: string;
  updated?: string;
  availableDeviceCount?: number;
  routeNamespaceId?: string | null;
}

export interface ExternalConnectionsListed {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  externalConnections?: Array<ExternalConnectionLimitedDto> | null;
}

export interface ExtServiceOption {
  id?: string;
  name?: string | null;
  description?: string | null;
  integrationId?: string;
  lastScanTime?: string | null;
  created?: string;
  updated?: string;
  deviceCreationKeyValues?: Array<ConnectedDeviceFilter> | null;
  deviceCreationChoices?: Array<{
        [key: string]: string;
    }> | null;
}

export interface ExtServiceOptionsFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  externalOptions?: Array<ExtServiceOption> | null;
}

export interface FailedWebhooksSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<InactiveCameraDto> | null;
  cameras?: Array<InactiveCameraDto> | null;
}

export interface FetchContractDto {
  name?: string | null;
  id?: string;
  startDate?: string | null;
  endDate?: string | null;
  expectedEndDate?: string | null;
  status?: EnumContractStatus;
  billingDayOfMonth?: number;
  siteAccessInstructions?: string | null;
  damageWaverChargePct?: number;
  installationCharge?: number;
  purchaseOrderNo?: string | null;
  customerId?: string;
  customerName?: string | null;
  address?: AddressDto;
  accountNumber?: string | null;
  assets?: Array<ContractAssetDto> | null;
  customerContractName?: string | null;
  contractId?: string | null;
  projectId?: string | null;
  salesPeople?: Array<SalesPersonDto> | null;
  billingCycle?: EnumBillingCycle;
  pendingAssets?: Array<ContractAssetDto> | null;
  salesOrderId?: string | null;
  hasBilled?: boolean;
}

export interface Filter {
  field?: string | null;
  value?: string | null;
  action?: Comparator;
}

export interface FilterGroup {
  operator?: FilterOperator;
  filters?: Array<Filter> | null;
  filterGroups?: Array<FilterGroup> | null;
}

export interface FullCreditNoteDto {
  id?: string;
  contractId?: string;
  billingDate?: string;
  xeroId?: string | null;
  description?: string | null;
  cnNumber?: string | null;
  status?: EnumCreditNoteStatus;
  lines?: Array<CreditNoteLineDto> | null;
  customerName?: string | null;
}

export interface FullInvoiceDto {
  id?: string;
  contractId?: string;
  billingDate?: string;
  xeroId?: string | null;
  description?: string | null;
  invoiceNumber?: string | null;
  status?: EnumInvoiceStatus;
  lines?: Array<InvoiceLineDto> | null;
  customerName?: string | null;
  xeroFailed?: boolean;
  xeroFailedMessage?: string | null;
}

export interface GatewayCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  gateway?: GatewayDto;
}

export interface GatewayDto {
  id?: string | null;
  onSightGatewayId?: string | null;
  onSightDeviceId?: string | null;
  type?: string | null;
  mqttUser?: string | null;
  mqttPassword?: string | null;
  zoneId?: string;
  mac?: string | null;
  name?: string | null;
  wkt?: string | null;
  customField1?: string | null;
}

export interface GatewayForm {
  mac?: string | null;
  zoneId?: string;
  name?: string | null;
  wkt?: string | null;
  customField1?: string | null;
  onSightGatewayId?: string | null;
}

export interface GatewayMinDto {
  zoneId?: string;
  id?: string;
  name?: string | null;
  companyId?: string;
  retired?: boolean;
}

export interface GatewaysSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<GatewayMinDto> | null;
}

export interface GenerateShareLinkRequest {
  expiryDays?: number | null;
}

export interface GetAlertFullAlertMonitoringData {
  body?: never;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/AlertMonitoring/{alertId}/full';
}

export interface GetAlertFullAlertMonitoringResponses {
  /**
     * Success
     */
    200: AlertFetchedForMonitor;
}

export interface GetAnnotateSnapshotAlertMonitoringData {
  body?: never;
  path: {
        alertId: string;
        eventValueId: string;
    };
  query?: never;
  url: '/AlertMonitoring/{alertId}/annotate/{eventValueId}';
}

export interface GetAnnotateSnapshotAlertMonitoringResponses {
  /**
     * Success
     */
    200: AiAnnotationFetched;
}

export interface GetAssetUtilisationReportData {
  body?: never;
  path: {
        start: string;
        end: string;
    };
  query?: never;
  url: '/Report/asset/utilisation/{start}/{end}';
}

export interface GetAssetUtilisationReportResponses {
  /**
     * Success
     */
    200: AssetUtilisationReportFetched;
}

export interface GetBillingSearchAccountingData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Accounting/billing/search';
}

export interface GetBillingSearchAccountingResponses {
  /**
     * Success
     */
    200: BillingSearched;
}

export interface GetByDayComplianceData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Compliance/report/byday';
}

export interface GetByDayComplianceResponses {
  /**
     * Success
     */
    200: ComplianceDayReportFetched;
}

export interface GetByHourComplianceData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Compliance/report/byhour';
}

export interface GetByHourComplianceResponses {
  /**
     * Success
     */
    200: ComplianceHourReportFetched;
}

export interface GetComplianceEventsSearchComplianceData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Compliance/events/search';
}

export interface GetComplianceEventsSearchComplianceResponses {
  /**
     * Success
     */
    200: ComplianceEventsSearched;
}

export interface GetCurrentShiftAlertMonitoringData {
  body?: never;
  path?: never;
  query?: never;
  url: '/AlertMonitoring/shift-v2';
}

export interface GetCurrentShiftAlertMonitoringResponses {
  /**
     * Success
     */
    200: CurrentShiftFetchedV2;
}

export interface GetDashboardAlertMonitoringData {
  body?: never;
  path?: never;
  query?: never;
  url: '/AlertMonitoring/dashboard';
}

export interface GetDashboardAlertMonitoringResponses {
  /**
     * Success
     */
    200: AlertMonitoringOpenFetched;
}

export interface GetDashboardEdgeLinkDeploymentData {
  body?: never;
  path?: never;
  query?: never;
  url: '/edgelinks/deployments/dashboard';
}

export interface GetDashboardEdgeLinkDeploymentResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetDashboardV2AlertMonitoringData {
  body?: never;
  path?: never;
  query?: {
        type?: string;
    };
  url: '/AlertMonitoring/dashboard-v2';
}

export interface GetDashboardV2AlertMonitoringResponses {
  /**
     * Success
     */
    200: AlertMonitoringOpenFetchedV2;
}

export interface GetDetermineTenantPublicData {
  body?: never;
  path?: never;
  query?: {
        urlBase?: string;
    };
  url: '/Public/determinetenant';
}

export interface GetDetermineTenantPublicResponses {
  /**
     * Success
     */
    200: TenantResolvedFromUrl;
}

export interface GetEnableMonitoringCustomerData {
  body?: never;
  path: {
        customerId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/monitoring/enable';
}

export interface GetEnableMonitoringCustomerResponses {
  /**
     * Success
     */
    200: MonitoringEnabled;
}

export interface GetFetchActiveAssetLocationsRentalAssetsData {
  body?: never;
  path?: never;
  query?: {
        assetId?: string;
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/RentalAssets/installed';
}

export interface GetFetchActiveAssetLocationsRentalAssetsResponses {
  /**
     * Success
     */
    200: AssetLocationsFetched;
}

export interface GetFetchAdminEventsCalendarData {
  body?: never;
  path: {
        calendarId: string;
    };
  query?: never;
  url: '/Calendar/{calendarId}/admin/events';
}

export interface GetFetchAdminEventsCalendarResponses {
  /**
     * Success
     */
    200: CalendarEventsFetched;
}

export interface GetFetchAdminRegionsCalendarData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Calendar/admin/regions';
}

export interface GetFetchAdminRegionsCalendarResponses {
  /**
     * Success
     */
    200: CalendarRegionsFetched;
}

export interface GetFetchAlertFullMonitoringData {
  body?: never;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/Monitoring/alerts/{alertId}/full';
}

export interface GetFetchAlertFullMonitoringLimitedData {
  body?: never;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/MonitoringLimited/alerts/{alertId}/full';
}

export interface GetFetchAlertFullMonitoringLimitedResponses {
  /**
     * Success
     */
    200: AlertFetchedForMonitor;
}

export interface GetFetchAlertFullMonitoringResponses {
  /**
     * Success
     */
    200: AlertFetchedForMonitor;
}

export interface GetFetchAlertMonitoringData {
  body?: never;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/monitoring/alerts/{alertId}';
}

export interface GetFetchAlertMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringAlertFetched;
}

export interface GetFetchAlertsMonitoringData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        alertId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/alerts/{alertId}';
}

export interface GetFetchAlertsMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringAlertFetched;
}

export interface GetFetchAlertSuppressionCandidatesMonitoringData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        alertId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/alerts/{alertId}/suppressions';
}

export interface GetFetchAlertSuppressionCandidatesMonitoringResponses {
  /**
     * Success
     */
    200: AssetSuppressionCandidatesFetched;
}

export interface GetFetchArmStatusCustomerData {
  body?: never;
  path: {
        customerId: string;
        projectId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}/armstatus';
}

export interface GetFetchArmStatusCustomerResponses {
  /**
     * Success
     */
    200: ArmStatusFetched;
}

export interface GetFetchArmStatusProjectData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/Project/{projectId}/armstatus';
}

export interface GetFetchArmStatusProjectResponses {
  /**
     * Success
     */
    200: ArmStatusFetched;
}

export interface GetFetchAssetAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}';
}

export interface GetFetchAssetAssetResponses {
  /**
     * Success
     */
    200: AssetCrudded;
}

export interface GetFetchAssetDataAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        startDate: string;
        endDate: string;
        intervalSeconds: number;
    };
  query?: {
        assetIds?: Array<string>;
        sensorTypes?: Array<EnumValueType>;
        aggregations?: Array<AggregationType>;
    };
  url: '/company/{companyId}/project/{projectId}/Asset/report/{startDate}/{endDate}/{intervalSeconds}';
}

export interface GetFetchAssetDataAssetResponses {
  /**
     * Success
     */
    200: AssetSensorHistoryFetched;
}

export interface GetFetchAssetFullAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}/full';
}

export interface GetFetchAssetFullAssetResponses {
  /**
     * Success
     */
    200: AssetFullFetched;
}

export interface GetFetchAssetSensorsProjectData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
    };
  query?: never;
  url: '/company/{companyId}/Project/{projectId}/assets/{assetId}/sensors';
}

export interface GetFetchAssetSensorsProjectResponses {
  /**
     * Success
     */
    200: AssetSensorsFetched;
}

export interface GetFetchAvailableHardwareProjectData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        q?: string;
    };
  url: '/company/{companyId}/Project/{projectId}/hardware/available';
}

export interface GetFetchAvailableHardwareProjectResponses {
  /**
     * Success
     */
    200: OnSightHardwareSearchResult;
}

export interface GetFetchAvailableZonesSiteData {
  body?: never;
  path: {
        companyId: string;
        siteId: string;
    };
  query?: {
        q?: string;
    };
  url: '/company/{companyId}/Site/{siteId}/zone/available';
}

export interface GetFetchAvailableZonesSiteResponses {
  /**
     * Success
     */
    200: OnSightZoneSearchResult;
}

export interface GetFetchBeaconHardwareData {
  body?: never;
  path: {
        companyId: string;
        beaconId: string;
    };
  query?: never;
  url: '/company/{companyId}/Hardware/beacon/{beaconId}';
}

export interface GetFetchBeaconHardwareResponses {
  /**
     * Success
     */
    200: BeaconCrudded;
}

export interface GetFetchCalendarIdCalendarData {
  body?: never;
  path: {
        projectId: string;
    };
  query?: never;
  url: '/Calendar/{projectId}/calendar';
}

export interface GetFetchCalendarIdCalendarResponses {
  /**
     * Success
     */
    200: CalendarIdFetched;
}

export interface GetFetchCameraFeedUrlMonitoringData {
  body?: never;
  path: {
        cameraId: string;
        atTime: string;
        companyId: string;
        projectId: string;
    };
  query?: {
        endTime?: string;
    };
  url: '/company/{companyId}/project/{projectId}/Monitoring/camera/{cameraId}/feed/{atTime}';
}

export interface GetFetchCameraFeedUrlMonitoringResponses {
  /**
     * Success
     */
    200: CameraFeedUrlFetched;
}

export interface GetFetchCameraHealthMonitoringData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Monitoring/camera/health';
}

export interface GetFetchCameraHealthMonitoringResponses {
  /**
     * Success
     */
    200: VideoFeedHealthFetched;
}

export interface GetFetchCameraSnapshotImgMonitoringData {
  body?: never;
  path: {
        cameraId: string;
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/camera/{cameraId}/snapshot/image';
}

export interface GetFetchCameraSnapshotImgMonitoringResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetFetchCameraSnapshotMonitoringData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        cameraId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/camera/{cameraId}/snapshot';
}

export interface GetFetchCameraSnapshotMonitoringResponses {
  /**
     * Success
     */
    200: ImageUrlDto;
}

export interface GetFetchCompanyInfoCompanyData {
  body?: never;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/Company/{companyId}';
}

export interface GetFetchCompanyInfoCompanyResponses {
  /**
     * Success
     */
    200: CompanyInfoFetched;
}

export interface GetFetchCompanyMonitoringData {
  body?: never;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/Monitoring/companies/{companyId}';
}

export interface GetFetchCompanyMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringCompanyCrudded;
}

export interface GetFetchCompanyTenantMonitoringData {
  body?: never;
  path: {
        tenantId: string;
        companyId: string;
    };
  query?: never;
  url: '/tenants/{tenantId}/TenantMonitoring/companies/{companyId}';
}

export interface GetFetchCompanyTenantMonitoringResponses {
  /**
     * Success
     */
    200: TenantMonitoringCompanyCrudded;
}

export interface GetFetchContractContractsData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/customer/Contracts/{id}';
}

export interface GetFetchContractContractsResponses {
  /**
     * Success
     */
    200: ContractCrudded;
}

export interface GetFetchCredentialsCompanyData {
  body?: never;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/Company/{companyId}/credentials';
}

export interface GetFetchCredentialsCompanyResponses {
  /**
     * Success
     */
    200: CompanyCredentialsFetched;
}

export interface GetFetchDashboardProjectData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        dashboardId: string;
    };
  query?: never;
  url: '/company/{companyId}/Project/{projectId}/dashboard/{dashboardId}';
}

export interface GetFetchDashboardProjectResponses {
  /**
     * Success
     */
    200: WidgetsCrudded;
}

export interface GetFetchDetailedContractContractsData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/customer/Contracts/{id}/detailed';
}

export interface GetFetchDetailedContractContractsResponses {
  /**
     * Success
     */
    200: ContractFetched;
}

export interface GetFetchDeviceDeviceData {
  body?: never;
  path: {
        deviceId: string;
    };
  query?: never;
  url: '/Integration/Device/{deviceId}';
}

export interface GetFetchDeviceDeviceResponses {
  /**
     * Success
     */
    200: CrudPrimaryDeviceFetched;
}

export interface GetFetchDeviceSnapshotDeviceData {
  body?: never;
  path: {
        deviceId: string;
    };
  query?: never;
  url: '/Integration/Device/{deviceId}/snapshot';
}

export interface GetFetchDeviceSnapshotDeviceResponses {
  /**
     * Success
     */
    200: DeviceSnapshotFetched;
}

export interface GetFetchEmailTemplatesAdminData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Admin/emails/templates/rentals';
}

export interface GetFetchEmailTemplatesAdminResponses {
  /**
     * Success
     */
    200: RentalEmailTemplatesFetched;
}

export interface GetFetchEventsCalendarData {
  body?: never;
  path: {
        calendarId: string;
    };
  query?: never;
  url: '/Calendar/{calendarId}/events';
}

export interface GetFetchEventsCalendarResponses {
  /**
     * Success
     */
    200: CalendarEventsFetched;
}

export interface GetFetchGatewayGatewayData {
  body?: never;
  path: {
        companyId: string;
        gatewayId: string;
    };
  query?: never;
  url: '/company/{companyId}/Gateway/{gatewayId}';
}

export interface GetFetchGatewayGatewayResponses {
  /**
     * Success
     */
    200: GatewayCrudded;
}

export interface GetFetchHardwareAssociatedAssetHardwareData {
  body?: never;
  path: {
        companyId: string;
        hardwareId: string;
    };
  query?: never;
  url: '/company/{companyId}/Hardware/{hardwareId}/assignedAsset';
}

export interface GetFetchHardwareAssociatedAssetHardwareResponses {
  /**
     * Success
     */
    200: AssignedHardwareFetched;
}

export interface GetFetchIntegrationLibraryIntegrationData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/manage/{id}/library';
}

export interface GetFetchIntegrationLibraryIntegrationResponses {
  /**
     * Success
     */
    200: IntegrationLibraryFetched;
}

export interface GetFetchLicenceLicenceData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        licenceId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Licence/{licenceId}';
}

export interface GetFetchLicenceLicenceResponses {
  /**
     * Success
     */
    200: LicenceCrudded;
}

export interface GetFetchMonitoringEmailTemplatesAdminData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Admin/emails/templates/monitoring';
}

export interface GetFetchMonitoringEmailTemplatesAdminResponses {
  /**
     * Success
     */
    200: EmailTemplatesFetched;
}

export interface GetFetchMonitoringZoneMonitoringData {
  body?: never;
  path: {
        projectId: string;
        zoneId: string;
    };
  query?: never;
  url: '/project/{projectId}/zone/{zoneId}';
}

export interface GetFetchMonitoringZoneMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringZoneCrudded;
}

export interface GetFetchOrderOrderData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Order/{id}';
}

export interface GetFetchOrderOrderResponses {
  /**
     * Success
     */
    200: SalesOrderCrudded;
}

export interface GetFetchOverviewMonitoringData {
  body?: never;
  path: {
        start: string;
        end: string;
    };
  query?: {
        CompanyId?: string;
        MonitorId?: string;
        MonitoringCompanyId?: string;
    };
  url: '/Monitoring/overview/{start}/{end}';
}

export interface GetFetchOverviewMonitoringResponses {
  /**
     * Success
     */
    200: AlertMonitoringOverviewFetched;
}

export interface GetFetchProjectInfoProjectData {
  body?: never;
  path: {
        projectId: string;
        companyId: string;
    };
  query?: never;
  url: '/company/{companyId}/Project/{projectId}';
}

export interface GetFetchProjectInfoProjectResponses {
  /**
     * Success
     */
    200: ProjectInfoFetched;
}

export interface GetFetchRegionsCalendarData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Calendar/regions';
}

export interface GetFetchRegionsCalendarResponses {
  /**
     * Success
     */
    200: CalendarRegionsFetched;
}

export interface GetFetchRelayRelayData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/Relay/{id}';
}

export interface GetFetchRelayRelayResponses {
  /**
     * Success
     */
    200: RelayCrudded;
}

export interface GetFetchRentalAssetRentalAssetsData {
  body?: never;
  path: {
        assetId: string;
    };
  query?: never;
  url: '/RentalAssets/{assetId}';
}

export interface GetFetchRentalAssetRentalAssetsResponses {
  /**
     * Success
     */
    200: RentalAssetFetched;
}

export interface GetFetchReportData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Report/objectlocation';
}

export interface GetFetchReportReportData {
  body?: never;
  path: {
        companyId: string;
        reportId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Report/{reportId}';
}

export interface GetFetchReportReportResponses {
  /**
     * Success
     */
    200: ReportCrudded;
}

export interface GetFetchReportResponses {
  /**
     * Success
     */
    200: EntityLocationReport;
}

export interface GetFetchRfidHardwareData {
  body?: never;
  path: {
        companyId: string;
        id: string;
    };
  query?: never;
  url: '/company/{companyId}/Hardware/rfid/{id}';
}

export interface GetFetchRfidHardwareResponses {
  /**
     * Success
     */
    200: RfidCrudded;
}

export interface GetFetchSiteSecondaryDevicesMonitoringData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/devices';
}

export interface GetFetchSiteSecondaryDevicesMonitoringResponses {
  /**
     * Success
     */
    200: SiteSecondaryDevicesFetched;
}

export interface GetFetchSiteSiteData {
  body?: never;
  path: {
        companyId: string;
        siteId: string;
    };
  query?: never;
  url: '/company/{companyId}/Site/{siteId}';
}

export interface GetFetchSiteSiteResponses {
  /**
     * Success
     */
    200: SiteCrudded;
}

export interface GetFetchSmtpParserMonitoringData {
  body?: never;
  path: {
        smtpParserId: string;
    };
  query?: never;
  url: '/Monitoring/smtp/parsers/{smtpParserId}';
}

export interface GetFetchSmtpParserMonitoringResponses {
  /**
     * Success
     */
    200: NvRecorderCrudded;
}

export interface GetFetchSpeakerSpeakerData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/Speaker/{id}';
}

export interface GetFetchSpeakerSpeakerResponses {
  /**
     * Success
     */
    200: SpeakerCrudded;
}

export interface GetFetchTenantLogosAdminData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Admin/tenaat/logos';
}

export interface GetFetchTenantLogosAdminResponses {
  /**
     * Success
     */
    200: TenantLogosFetched;
}

export interface GetFetchTenantTenantData {
  body?: never;
  path: {
        tenantId: string;
    };
  query?: never;
  url: '/Tenant/{tenantId}';
}

export interface GetFetchTenantTenantResponses {
  /**
     * Success
     */
    200: TenantCrudded;
}

export interface GetFetchTrainingEventAlertMonitoringData {
  body?: never;
  path?: never;
  query?: never;
  url: '/AlertMonitoring/training/event';
}

export interface GetFetchTrainingEventAlertMonitoringResponses {
  /**
     * Success
     */
    200: TrainingEventFetched;
}

export interface GetFetchTrainingMetricsAlertMonitoringData {
  body?: never;
  path?: never;
  query?: {
        startDate?: string;
        endDate?: string;
    };
  url: '/AlertMonitoring/training/metrics';
}

export interface GetFetchTrainingMetricsAlertMonitoringResponses {
  /**
     * Success
     */
    200: TrainingMetricsFetched;
}

export interface GetFetchXeroLoginUrlXeroData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Xero/auth/loginurl';
}

export interface GetFetchXeroLoginUrlXeroResponses {
  /**
     * Success
     */
    200: XeroLoginFetched;
}

export interface GetFetchZoneSiteData {
  body?: never;
  path: {
        companyId: string;
        siteId: string;
        zoneId: string;
    };
  query?: never;
  url: '/company/{companyId}/Site/{siteId}/zone/{zoneId}';
}

export interface GetFetchZoneSiteResponses {
  /**
     * Success
     */
    200: ZoneCrudded;
}

export interface GetFindContactAlertMonitoringData {
  body?: never;
  path?: never;
  query?: {
        number?: string;
        email?: string;
    };
  url: '/AlertMonitoring/contacts/find';
}

export interface GetFindContactAlertMonitoringResponses {
  /**
     * Success
     */
    200: ProjectContactsSearched;
}

export interface GetGenerateAssetActivityReportReportData {
  body?: never;
  path: {
        companyId: string;
        reportId: string;
        start: string;
        end: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Report/{reportId}/generate/{start}/{end}';
}

export interface GetGenerateAssetActivityReportReportResponses {
  /**
     * Success
     */
    200: AssetActivityReportGenerated;
}

export interface GetGetAlertingConfigurationDeviceData {
  body?: never;
  path: {
        nvrId: string;
    };
  query?: {
        setupType?: string;
    };
  url: '/Integration/Device/{nvrId}/alerting-configuration';
}

export interface GetGetAlertingConfigurationDeviceResponses {
  /**
     * Success
     */
    200: AlertingConfigurationFetched;
}

export interface GetGetAlertingSetupTypesDeviceData {
  body?: never;
  path: {
        nvrId: string;
    };
  query?: never;
  url: '/Integration/Device/{nvrId}/alerting-setup-types';
}

export interface GetGetAlertingSetupTypesDeviceResponses {
  /**
     * Success
     */
    200: AlertingSetupTypesFetched;
}

export interface GetGetAlertNotesByQuillPredictionAlertReportingData {
  body?: never;
  path: {
        tenantId: string;
    };
  query?: {
        start?: string;
        end?: string;
        tz?: string;
    };
  url: '/AlertReporting/tenant/{tenantId}/notes/quill';
}

export interface GetGetAlertNotesByQuillPredictionAlertReportingResponses {
  /**
     * Success
     */
    200: AlertNotesByQuillPredictionResponse;
}

export interface GetGetAllEdgeLinkDeploymentData {
  body?: never;
  path?: never;
  query?: never;
  url: '/edgelinks/deployments';
}

export interface GetGetAllEdgeLinkDeploymentResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetGetAllEdgeLinksData {
  body?: never;
  path?: never;
  query?: {
        page?: number;
        pageSize?: number;
    };
  url: '/EdgeLinks/bridges';
}

export interface GetGetAllEdgeLinksResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetGetAssetSensorsAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}/sensors';
}

export interface GetGetAssetSensorsAssetResponses {
  /**
     * Success
     */
    200: AssetSensorsFetched;
}

export interface GetGetBridgeStatsEdgeLinkDeploymentData {
  body?: never;
  path?: never;
  query?: never;
  url: '/edgelinks/deployments/bridge-stats';
}

export interface GetGetBridgeStatsEdgeLinkDeploymentResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetGetByIdEdgeLinksData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/EdgeLinks/bridges/{id}';
}

export interface GetGetByIdEdgeLinksResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetGetCompanyMetricsCompanyData {
  body?: never;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/Company/{companyId}/metrics';
}

export interface GetGetCompanyMetricsCompanyResponses {
  /**
     * Success
     */
    200: CompanySystemMetricsFetched;
}

export interface GetGetConnectedAssetsEdgeLinksData {
  body?: never;
  path: {
        id: string;
    };
  query?: {
        page?: number;
        pageSize?: number;
    };
  url: '/EdgeLinks/bridges/{id}/connected-assets';
}

export interface GetGetConnectedAssetsEdgeLinksResponses {
  /**
     * Success
     */
    200: BridgeConnectedAssetsSearched;
}

export interface GetGetConnectedDevicesExternalConnectionData {
  body?: never;
  path: {
        connectionId: string;
    };
  query?: never;
  url: '/Integration/ExternalConnection/{connectionId}/devices';
}

export interface GetGetConnectedDevicesExternalConnectionResponses {
  /**
     * Success
     */
    200: DevicesSearched;
}

export interface GetGetConnectionOptionsExternalConnectionData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Integration/ExternalConnection/services/options';
}

export interface GetGetConnectionOptionsExternalConnectionResponses {
  /**
     * Success
     */
    200: ExtServiceOptionsFetched;
}

export interface GetGetCreditNoteAccountingData {
  body?: never;
  path: {
        creditnoteId: string;
    };
  query?: never;
  url: '/Accounting/creditnote/{creditnoteId}';
}

export interface GetGetCreditNoteAccountingResponses {
  /**
     * Success
     */
    200: CreditNoteFetched;
}

export interface GetGetCustomerCustomerData {
  body?: never;
  path: {
        customerId: string;
    };
  query?: never;
  url: '/Customer/{customerId}';
}

export interface GetGetCustomerCustomerResponses {
  /**
     * Success
     */
    200: CustomerFetched;
}

export interface GetGetDailyAlertReportAlertReportingData {
  body?: never;
  path: {
        tenantId: string;
        month: string;
    };
  query?: {
        tz?: string;
    };
  url: '/AlertReporting/tenant/{tenantId}/daily/{month}';
}

export interface GetGetDailyAlertReportAlertReportingResponses {
  /**
     * Success
     */
    200: DailyAlertsForMonthResponse;
}

export interface GetGetDailyEventReportEventReportingData {
  body?: never;
  path: {
        tenantId: string;
        month: string;
    };
  query?: {
        tz?: string;
    };
  url: '/EventReporting/tenant/{tenantId}/daily/{month}';
}

export interface GetGetDailyEventReportEventReportingResponses {
  /**
     * Success
     */
    200: DailyEventsForMonthResponse;
}

export interface GetGetDevicesDeviceData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Integration/Device/search';
}

export interface GetGetDevicesDeviceResponses {
  /**
     * Success
     */
    200: Array<Device>;
}

export interface GetGetDimensionValuesMetricsData {
  body?: never;
  path: {
        tenantId: string;
        cube: MetricCube;
        breakdown: MetricBreakdown;
    };
  query?: {
        SortBy?: MetricSortField;
        SortDirection?: MetricSortDirection;
        Limit?: number;
        Offset?: number;
        IncludeTotalCount?: boolean;
        DateStart?: string;
        DateEnd?: string;
        Timezone?: string;
        CustomerId?: string;
        SiteId?: string;
        CreatedOnOrBefore?: string;
        NotDeletedBefore?: string;
        SortByDimension?: string;
        customerId?: string;
        siteId?: string;
    };
  url: '/tenants/{tenantId}/metrics/{cube}/dimensions/{breakdown}';
}

export interface GetGetDimensionValuesMetricsResponses {
  /**
     * Success
     */
    200: DimensionValuesResultDto;
}

export interface GetGetEventTraceIngestionLogData {
  body?: never;
  path: {
        tenantId: string;
        correlationId: string;
    };
  query?: {
        timestampHint?: string;
    };
  url: '/tenants/{tenantId}/ingestion/trace/{correlationId}';
}

export interface GetGetEventTraceIngestionLogResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetGetEventValueImgUrlComplianceData {
  body?: never;
  path: {
        eventValueId: string;
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Compliance/event/value/{eventValueId}/url';
}

export interface GetGetEventValueImgUrlComplianceResponses {
  /**
     * Success
     */
    200: ImageUrlDto;
}

export interface GetGetExternalConnectionExternalConnectionData {
  body?: never;
  path: {
        connectionId: string;
    };
  query?: never;
  url: '/Integration/ExternalConnection/{connectionId}';
}

export interface GetGetExternalConnectionExternalConnectionResponses {
  /**
     * Success
     */
    200: ExternalConnectionCrudded;
}

export interface GetGetExternalConnectionsExternalConnectionData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Integration/ExternalConnection';
}

export interface GetGetExternalConnectionsExternalConnectionResponses {
  /**
     * Success
     */
    200: ExternalConnectionsListed;
}

export interface GetGetIntegrationIntegrationData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/manage/{id}';
}

export interface GetGetIntegrationIntegrationResponses {
  /**
     * Success
     */
    200: IntegrationFetched;
}

export interface GetGetIntegrationsIntegrationData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Integration/manage';
}

export interface GetGetIntegrationsIntegrationResponses {
  /**
     * Success
     */
    200: IntegrationsListed;
}

export interface GetGetInvoiceAccountingData {
  body?: never;
  path: {
        invoiceId: string;
    };
  query?: never;
  url: '/Accounting/invoice/{invoiceId}';
}

export interface GetGetInvoiceAccountingResponses {
  /**
     * Success
     */
    200: InvoiceFetched;
}

export interface GetGetManifestIngestionLogData {
  body?: never;
  path: {
        tenantId: string;
    };
  query?: never;
  url: '/tenants/{tenantId}/ingestion/manifest';
}

export interface GetGetManifestIngestionLogResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetGetMonitoringEventsMonitoringData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/company/{companyId}/project/{projectId}/Monitoring/event/search';
}

export interface GetGetMonitoringEventsMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringEventsSearched;
}

export interface GetGetMonitoringEventsRentalAssetsData {
  body?: never;
  path: {
        assetId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/RentalAssets/{assetId}/monitoring/search';
}

export interface GetGetMonitoringEventsRentalAssetsResponses {
  /**
     * Success
     */
    200: MonitoringEventsSearched;
}

export interface GetGetMonitoringEventValueImgComplianceData {
  body?: never;
  path: {
        valueId: string;
    };
  query?: never;
  url: '/Compliance/events/value/{valueId}';
}

export interface GetGetMonitoringEventValueImgComplianceResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetGetMonitoringEventValueImgMonitoringData {
  body?: never;
  path: {
        monitoringEventValueId: string;
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/event/value/{monitoringEventValueId}';
}

export interface GetGetMonitoringEventValueImgMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringEventsSearched;
}

export interface GetGetMonitoringEventValueImgUrlMonitoringData {
  body?: never;
  path: {
        monitoringEventValueId: string;
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/event/value/{monitoringEventValueId}/url';
}

export interface GetGetMonitoringEventValueImgUrlMonitoringResponses {
  /**
     * Success
     */
    200: ImageUrlDto;
}

export interface GetGetMonitoringEventValueUrlComplianceData {
  body?: never;
  path: {
        valueId: string;
    };
  query?: never;
  url: '/Compliance/events/value/{valueId}/url';
}

export interface GetGetMonitoringEventValueUrlComplianceResponses {
  /**
     * Success
     */
    200: ImageUrlDto;
}

export interface GetGetMonitoringEventValueUrlMonitoringData {
  body?: never;
  path: {
        monitoringEventValueId: string;
    };
  query?: never;
  url: '/Monitoring/event/value/{monitoringEventValueId}/url';
}

export interface GetGetMonitoringEventValueUrlMonitoringResponses {
  /**
     * Success
     */
    200: ImageUrlDto;
}

export interface GetGetMonitoringLoginsAlertingData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Alerting/logins';
}

export interface GetGetMonitoringLoginsAlertingResponses {
  /**
     * Success
     */
    200: MonitoringCompanyVideoLoginsFetched;
}

export interface GetGetMonthlyEventsByCameraEventReportingData {
  body?: never;
  path: {
        tenantId: string;
        month: string;
    };
  query?: {
        tz?: string;
    };
  url: '/EventReporting/tenant/{tenantId}/monthly/{month}/camera';
}

export interface GetGetMonthlyEventsByCameraEventReportingResponses {
  /**
     * Success
     */
    200: MonthlyEventsByCameraResponse;
}

export interface GetGetMonthlyEventsBySiteEventReportingData {
  body?: never;
  path: {
        tenantId: string;
        month: string;
    };
  query?: {
        tz?: string;
    };
  url: '/EventReporting/tenant/{tenantId}monthly/{month}/site';
}

export interface GetGetMonthlyEventsBySiteEventReportingResponses {
  /**
     * Success
     */
    200: MonthlyEventsBySiteResponse;
}

export interface GetGetNvRecorderMonitoringData {
  body?: never;
  path: {
        customerId: string;
        nvrId: string;
    };
  query?: never;
  url: '/Monitoring/customers/{customerId}/nvrecorders/{nvrId}';
}

export interface GetGetNvRecorderMonitoringResponses {
  /**
     * Success
     */
    200: NvRecorderCrudded;
}

export interface GetGetPreferenceUserPreferencesData {
  body?: never;
  path: {
        key: string;
    };
  query?: never;
  url: '/api/UserPreferences/{key}';
}

export interface GetGetPreferenceUserPreferencesResponses {
  /**
     * Success
     */
    200: UserPreferenceFetched;
}

export interface GetGetProductProductsData {
  body?: never;
  path: {
        productId: string;
    };
  query?: never;
  url: '/Products/{productId}';
}

export interface GetGetProductProductsResponses {
  /**
     * Success
     */
    200: ProductCrudded;
}

export interface GetGetPublicStatusEdgeLinkShareData {
  body?: never;
  path: {
        token: string;
    };
  query?: never;
  url: '/edgelink-share/{token}';
}

export interface GetGetPublicStatusEdgeLinkShareResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetGetQueueLengthsAdminData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Admin/status/queues';
}

export interface GetGetQueueLengthsAdminResponses {
  /**
     * Success
     */
    200: QueueStates;
}

export interface GetGetRecentAlertDataMonitoringData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/metrics';
}

export interface GetGetRecentAlertDataMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringMetricsFetched;
}

export interface GetGetSalesPersonDashboardSalesPersonData {
  body?: never;
  path: {
        salesPersonId: string;
    };
  query?: never;
  url: '/SalesPerson/overview/{salesPersonId}';
}

export interface GetGetSalesPersonDashboardSalesPersonResponses {
  /**
     * Success
     */
    200: SalesPersonDashboardFetched;
}

export interface GetGetSecondaryDevicesDeviceData {
  body?: never;
  path: {
        deviceId: string;
    };
  query?: never;
  url: '/Integration/Device/{deviceId}/secondary';
}

export interface GetGetSecondaryDevicesDeviceResponses {
  /**
     * Success
     */
    200: SecondaryDevicesFetched;
}

export interface GetGetSettingsAdminData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Admin/settings';
}

export interface GetGetSettingsAdminResponses {
  /**
     * Success
     */
    200: SettingsFetched;
}

export interface GetGetSmtpWebhooksRentalAssetsData {
  body?: never;
  path: {
        assetId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/RentalAssets/{assetId}/monitoring/webhooks';
}

export interface GetGetSmtpWebhooksRentalAssetsResponses {
  /**
     * Success
     */
    200: InboundWebhooksSearched;
}

export interface GetGetSnapshotPublicData {
  body?: never;
  path: {
        snapshotId: string;
    };
  query?: {
        annotate?: boolean;
    };
  url: '/Public/event/snapshot/{snapshotId}';
}

export interface GetGetSnapshotPublicResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetGetStatusEdgeLinksData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/EdgeLinks/bridges/{id}/status';
}

export interface GetGetStatusEdgeLinksResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetGetStatusPollingData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Integration/Polling/status';
}

export interface GetGetStatusPollingResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetGetTenantAdminData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Admin/tenant';
}

export interface GetGetTenantAdminResponses {
  /**
     * Success
     */
    200: TenantInfoFetched;
}

export interface GetGetTimeZonesAccountingData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Accounting/timezones';
}

export interface GetGetTimeZonesAccountingResponses {
  /**
     * Success
     */
    200: TimeZonesResponse;
}

export interface GetGetUsersAuthData {
  body?: never;
  path?: never;
  query?: {
        email?: string;
        password?: string;
    };
  url: '/Auth/tenants';
}

export interface GetGetUsersAuthResponses {
  /**
     * Success
     */
    200: UserTenantsFetched;
}

export interface GetGeValueImgComplianceData {
  body?: never;
  path: {
        eventValueId: string;
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Compliance/event/value/{eventValueId}';
}

export interface GetGeValueImgComplianceResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetHandleEntraAdminConsentOidcData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Oidc/entra/consent';
}

export interface GetHandleEntraIdCallbackOidcData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Oidc/entra/callback';
}

export interface GetLastSeenAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}/lastSeen';
}

export interface GetLastSeenAssetResponses {
  /**
     * Success
     */
    200: AssetLastSeenFetched;
}

export interface GetLastSeenInRangeAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
        start: string;
        end: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}/lastSeen/{start}/{end}';
}

export interface GetLastSeenInRangeAssetResponses {
  /**
     * Success
     */
    200: AssetLastSeenFetched;
}

export interface GetLastSeenTakexAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
        numToReturn: number;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}/lastSeen/{numToReturn}';
}

export interface GetLastSeenTakexAssetResponses {
  /**
     * Success
     */
    200: AssetLastSeenFetched;
}

export interface GetLineSearchOrderData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Order/lines/search';
}

export interface GetLineSearchOrderResponses {
  /**
     * Success
     */
    200: SalesOrderLinesSearched;
}

export interface GetListAvailableVersionsEdgeLinkDeploymentData {
  body?: never;
  path: {
        package: string;
    };
  query?: never;
  url: '/edgelinks/deployments/available/{package}';
}

export interface GetListAvailableVersionsEdgeLinkDeploymentResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetLoginWithEntraIdOidcData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Oidc/entra/login';
}

export interface GetLogSearchOrderData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Order/logs/search';
}

export interface GetLogSearchOrderResponses {
  /**
     * Success
     */
    200: SalesOrderLogsSearched;
}

export interface GetMissedCallsAlertMonitoringData {
  body?: never;
  path: {
        mcId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/AlertMonitoring/monitoringcompany/{mcId}/calllog/missed';
}

export interface GetMissedCallsAlertMonitoringResponses {
  /**
     * Success
     */
    200: CallLogsSearched;
}

export interface GetMonitoringSearchAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        assetId?: string;
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/company/{companyId}/project/{projectId}/Asset/monitoring/search';
}

export interface GetMonitoringSearchAssetResponses {
  /**
     * Success
     */
    200: AssetsSearched;
}

export interface GetNetworkProviderNetworkData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Network/{id}';
}

export interface GetNetworkProviderNetworkResponses {
  /**
     * Success
     */
    200: NetworkProviderCrudded;
}

export interface GetOpenAlertsAlerting2Data {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Alerting/open/search';
}

export interface GetOpenAlertsAlerting2Responses {
  /**
     * Success
     */
    200: MonitoringAlertsSearched;
}

export interface GetOpenAlertsAlertingData {
  body?: never;
  path: {
        page: number;
    };
  query?: never;
  url: '/Alerting/open/{page}';
}

export interface GetOpenAlertsAlertingResponses {
  /**
     * Success
     */
    200: MonitoringAlertsSearched;
}

export interface GetProfileAuthData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Auth/profile';
}

export interface GetProfileAuthResponses {
  /**
     * Success
     */
    200: LoggedInUserResponse;
}

export interface GetProjectCustomerData {
  body?: never;
  path: {
        customerId: string;
        projectId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}';
}

export interface GetProjectCustomerResponses {
  /**
     * Success
     */
    200: ProjectInfoFetched;
}

export interface GetProxyRequestPublicData {
  body?: never;
  path: {
        token: string;
        path: string;
    };
  query?: never;
  url: '/Public/proxy/{token}/{path}';
}

export interface GetProxyRequestPublicResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetProxyVideoFeedMonitoringData {
  body?: never;
  path: {
        token: string;
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/camera/videoproxy/{token}';
}

export interface GetProxyVideoFeedMonitoringResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetProxyVideoFeedNextPublicData {
  body?: never;
  path: {
        token: string;
        next: string;
    };
  query?: never;
  url: '/Public/proxy/{token}/{next}';
}

export interface GetProxyVideoFeedNextPublicResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetProxyVideoFeedPublicData {
  body?: never;
  path: {
        token: string;
    };
  query?: never;
  url: '/Public/proxy/{token}/start';
}

export interface GetProxyVideoFeedPublicResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetProxyVideoFeedVideoData {
  body?: never;
  path: {
        token: string;
    };
  query?: never;
  url: '/Video/proxy/{token}';
}

export interface GetProxyVideoFeedVideoResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetPublicFetchAssetInfoPublicData {
  body?: never;
  path: {
        assetId: string;
    };
  query?: never;
  url: '/Public/asset/{assetId}';
}

export interface GetPublicFetchAssetInfoPublicResponses {
  /**
     * Success
     */
    200: PublicAssetInfoFetched;
}

export interface GetPublicFetchUserAssetInfoPublicData {
  body?: never;
  path: {
        externalId: string;
        assetId: string;
    };
  query?: never;
  url: '/Public/asset/{assetId}/userstatus/{externalId}';
}

export interface GetPublicFetchUserAssetInfoPublicResponses {
  /**
     * Success
     */
    200: PublicAssetUserStatus;
}

export interface GetQueryMetricMetricsData {
  body?: never;
  path: {
        tenantId: string;
        cube: MetricCube;
        measure: MetricMeasure;
        breakdown: MetricBreakdown;
    };
  query?: {
        DateStart?: string;
        DateEnd?: string;
        Granularity?: MetricGranularity;
        Timezone?: string;
        SortBy?: MetricSortField;
        SortDirection?: MetricSortDirection;
        Limit?: number;
        Offset?: number;
        IncludeTotalCount?: boolean;
        CameraId?: string;
        SiteId?: string;
        CustomerId?: string;
        Disposition?: string;
        EventType?: string;
        ViewerType?: string;
        FirstViewedById?: string;
        PredictionAttempted?: boolean;
        TimeToViewMinutesGte?: number;
        TimeToViewMinutesLte?: number;
        Segments?: Array<MetricSegment>;
    };
  url: '/tenants/{tenantId}/metrics/{cube}/{measure}/{breakdown}';
}

export interface GetQueryMetricMetricsResponses {
  /**
     * Success
     */
    200: MetricResultDto;
}

export interface GetReRunInvoicingAccountingData {
  body?: never;
  path: {
        date: string;
    };
  query?: never;
  url: '/Accounting/billing/month/execute/{date}';
}

export interface GetReRunInvoicingAccountingResponses {
  /**
     * Success
     */
    200: MonthInvoicingRan;
}

export interface GetSalesCommissionReportReportData {
  body?: never;
  path: {
        start: string;
        end: string;
    };
  query?: never;
  url: '/Report/sales/commission/{start}/{end}';
}

export interface GetSalesCommissionReportReportResponses {
  /**
     * Success
     */
    200: SalesPersonCommissionReportGenerated;
}

export interface GetSalesReportReportData {
  body?: never;
  path: {
        start: string;
        end: string;
    };
  query?: never;
  url: '/Report/sales/{start}/{end}';
}

export interface GetSalesReportReportResponses {
  /**
     * Success
     */
    200: SalesPersonReportGenerated;
}

export interface GetSearchAccountsAccountingData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Accounting/accounts/search';
}

export interface GetSearchAccountsAccountingResponses {
  /**
     * Success
     */
    200: ChartOfAccountsSearched;
}

export interface GetSearchAlertEventsAlertMonitoringData {
  body?: never;
  path: {
        alertId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/AlertMonitoring/{alertId}/event/search';
}

export interface GetSearchAlertEventsAlertMonitoringResponses {
  /**
     * Success
     */
    200: AlertEventsSearched;
}

export interface GetSearchAlertMonitoringData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/AlertMonitoring/search';
}

export interface GetSearchAlertMonitoringResponses {
  /**
     * Success
     */
    200: MonitorAlertsSearched;
}

export interface GetSearchAlertsMonitoringData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/company/{companyId}/project/{projectId}/Monitoring/alerts/search';
}

export interface GetSearchAlertsMonitoringLimitedData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/MonitoringLimited/alerts/search';
}

export interface GetSearchAlertsMonitoringLimitedResponses {
  /**
     * Success
     */
    200: MonitoringAlertsSearched;
}

export interface GetSearchAlertsMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringAlertsSearched;
}

export interface GetSearchAssetHardwareLogAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
    };
  query?: {
        q?: string;
    };
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}/hardwarelog/search';
}

export interface GetSearchAssetHardwareLogAssetResponses {
  /**
     * Success
     */
    200: HardwareAssociationsSearched;
}

export interface GetSearchAssetNotificationsNotificationsData {
  body?: never;
  path: {
        companyId: string;
    };
  query?: {
        q?: string;
    };
  url: '/Notifications/{companyId}/search';
}

export interface GetSearchAssetNotificationsNotificationsResponses {
  /**
     * Success
     */
    200: AssetNotificationsSearched;
}

export interface GetSearchAssetsAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/company/{companyId}/project/{projectId}/Asset/search';
}

export interface GetSearchAssetsAssetResponses {
  /**
     * Success
     */
    200: AssetsSearched;
}

export interface GetSearchAssetsCustomerData {
  body?: never;
  path: {
        customerId: string;
        projectId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Customer/{customerId}/project/{projectId}/assets';
}

export interface GetSearchAssetsCustomerResponses {
  /**
     * Success
     */
    200: AssetsSearched;
}

export interface GetSearchAssetsV2CustomerData {
  body?: never;
  path: {
        customerId: string;
        projectId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Customer/{customerId}/project/{projectId}/assets/v2';
}

export interface GetSearchAssetsV2CustomerResponses {
  /**
     * Success
     */
    200: AssetsSearched;
}

export interface GetSearchAuditLogsAdminData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Admin/audit/search';
}

export interface GetSearchAuditLogsAdminResponses {
  /**
     * Success
     */
    200: AuditLogSearched;
}

export interface GetSearchBillingCycleContractsAccountingData {
  body?: never;
  path: {
        year: number;
        month: number;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Accounting/billing/cycle/{year}/{month}/contract/search';
}

export interface GetSearchBillingCycleContractsAccountingResponses {
  /**
     * Success
     */
    200: BillingCycleContractsSearched;
}

export interface GetSearchBillingCycleEndedContractsAccountingData {
  body?: never;
  path: {
        year: number;
        month: number;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Accounting/billing/cycle/{year}/{month}/endedcontract/search';
}

export interface GetSearchBillingCycleEndedContractsAccountingResponses {
  /**
     * Success
     */
    200: BillingCycleContractsSearched;
}

export interface GetSearchBillingCycleNewContractsAccountingData {
  body?: never;
  path: {
        year: number;
        month: number;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Accounting/billing/cycle/{year}/{month}/newcontract/search';
}

export interface GetSearchBillingCycleNewContractsAccountingResponses {
  /**
     * Success
     */
    200: BillingCycleContractsSearched;
}

export interface GetSearchBillingCyclesAccountingData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Accounting/billing/cycle/search';
}

export interface GetSearchBillingCyclesAccountingResponses {
  /**
     * Success
     */
    200: BillingCyclesSearched;
}

export interface GetSearchCompaniesMonitoringData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Monitoring/companies/search';
}

export interface GetSearchCompaniesMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringCompaniesSearched;
}

export interface GetSearchComplianceEventsComplianceData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/company/{companyId}/project/{projectId}/Compliance/search';
}

export interface GetSearchComplianceEventsComplianceResponses {
  /**
     * Success
     */
    200: ComplianceEventsSearched;
}

export interface GetSearchComponentAuditsRentalAssetsData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/RentalAssets/components/audit/search';
}

export interface GetSearchComponentAuditsRentalAssetsResponses {
  /**
     * Success
     */
    200: RentalAssetComponentAuditLogsSearched;
}

export interface GetSearchComponentsRentalAssetsData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/RentalAssets/components/search';
}

export interface GetSearchComponentsRentalAssetsResponses {
  /**
     * Success
     */
    200: RentalAssetComponentsSearched;
}

export interface GetSearchContactsCustomerData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Customer/contacts/search';
}

export interface GetSearchContactsCustomerResponses {
  /**
     * Success
     */
    200: ContactsSearched;
}

export interface GetSearchContractAssetsContractsData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/customer/Contracts/assets/search';
}

export interface GetSearchContractAssetsContractsResponses {
  /**
     * Success
     */
    200: ContractAssetsSearched;
}

export interface GetSearchContractLogsContractsData {
  body?: never;
  path: {
        contractId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/customer/Contracts/{contractId}/audit/search';
}

export interface GetSearchContractLogsContractsResponses {
  /**
     * Success
     */
    200: ContractsSearched;
}

export interface GetSearchContractProductsContractsData {
  body?: never;
  path: {
        contractId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/customer/Contracts/{contractId}/products/search';
}

export interface GetSearchContractProductsContractsResponses {
  /**
     * Success
     */
    200: ContractProductsSearched;
}

export interface GetSearchContractSalesPeopleContractsData {
  body?: never;
  path: {
        contractId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/customer/Contracts/{contractId}/salesperson/search';
}

export interface GetSearchContractSalesPeopleContractsResponses {
  /**
     * Success
     */
    200: ContractsSearched;
}

export interface GetSearchContractsContractsData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/customer/Contracts/search';
}

export interface GetSearchContractsContractsResponses {
  /**
     * Success
     */
    200: ContractsSearched;
}

export interface GetSearchCreditNotesAccountingData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Accounting/creditnote/search';
}

export interface GetSearchCreditNotesAccountingResponses {
  /**
     * Success
     */
    200: CreditNotesSearched;
}

export interface GetSearchCustomersCustomerData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Customer/search';
}

export interface GetSearchCustomersCustomerResponses {
  /**
     * Success
     */
    200: CustomersSearched;
}

export interface GetSearchCustomersProductsData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Products/search';
}

export interface GetSearchCustomersProductsResponses {
  /**
     * Success
     */
    200: ProductsSearched;
}

export interface GetSearchDashboardsProjectData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        q?: string;
    };
  url: '/company/{companyId}/Project/{projectId}/dashboard/search';
}

export interface GetSearchDashboardsProjectResponses {
  /**
     * Success
     */
    200: WidgetsSearched;
}

export interface GetSearchGatewayData {
  body?: never;
  path: {
        companyId: string;
        zoneId: string;
    };
  query?: {
        q?: string;
    };
  url: '/company/{companyId}/Gateway/zone/{zoneId}/search';
}

export interface GetSearchGatewayResponses {
  /**
     * Success
     */
    200: GatewaysSearched;
}

export interface GetSearchHardwareData {
  body?: never;
  path: {
        companyId: string;
    };
  query?: {
        q?: string;
    };
  url: '/company/{companyId}/Hardware/search';
}

export interface GetSearchHardwareResponses {
  /**
     * Success
     */
    200: HardwareSearched;
}

export interface GetSearchInactiveTenantCamerasTenantData {
  body?: never;
  path: {
        tenantId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Tenant/{tenantId}/cameras/inactive/search';
}

export interface GetSearchInactiveTenantCamerasTenantResponses {
  /**
     * Success
     */
    200: InactiveCamerasSearched;
}

export interface GetSearchIncidentsIncidentReportingData {
  body?: never;
  path: {
        tenantId: string;
    };
  query?: {
        start?: string;
        end?: string;
        companyId?: string;
        projectId?: string;
        page?: number;
        pageSize?: number;
    };
  url: '/IncidentReporting/tenant/{tenantId}/incidents';
}

export interface GetSearchIncidentsIncidentReportingResponses {
  /**
     * Success
     */
    200: SearchIncidentsResponse;
}

export interface GetSearchInvoicesAccountingData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Accounting/invoice/search';
}

export interface GetSearchInvoicesAccountingResponses {
  /**
     * Success
     */
    200: InvoicesSearched;
}

export interface GetSearchJourneysIngestionLogData {
  body?: never;
  path: {
        tenantId: string;
    };
  query?: {
        DateStart?: string;
        DateEnd?: string;
        FinalOutcome?: string;
        ProjectId?: string;
        VideoProcessorConfigId?: string;
        CompanyId?: string;
        PageSize?: number;
        Page?: number;
    };
  url: '/tenants/{tenantId}/ingestion/journeys';
}

export interface GetSearchJourneysIngestionLogResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetSearchMonitoringOfficerShiftsMonitoringData {
  body?: never;
  path?: never;
  query?: {
        monitoringCompanyId?: string;
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Monitoring/users/shifts/search';
}

export interface GetSearchMonitoringOfficerShiftsMonitoringResponses {
  /**
     * Success
     */
    200: ShiftsSearched;
}

export interface GetSearchNetworkProvidersNetworkData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Network/search';
}

export interface GetSearchNetworkProvidersNetworkResponses {
  /**
     * Success
     */
    200: NetworkProvidersSearched;
}

export interface GetSearchNvrDevicesMonitoringData {
  body?: never;
  path: {
        customerId: string;
        nvrId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Monitoring/customers/{customerId}/nvrecorders/{nvrId}/devices';
}

export interface GetSearchNvrDevicesMonitoringResponses {
  /**
     * Success
     */
    200: NvrDevicesSearched;
}

export interface GetSearchOrderData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Order/search';
}

export interface GetSearchOrderResponses {
  /**
     * Success
     */
    200: SalesOrdersSearched;
}

export interface GetSearchProjectAuditLogMonitoringData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Monitoring/project/audit/search';
}

export interface GetSearchProjectAuditLogMonitoringResponses {
  /**
     * Success
     */
    200: ProjectAuditLogSearched;
}

export interface GetSearchProjectContactsCustomerData {
  body?: never;
  path: {
        customerId: string;
        projectId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Customer/{customerId}/project/{projectId}/contacts';
}

export interface GetSearchProjectContactsCustomerResponses {
  /**
     * Success
     */
    200: ProjectContactsSearched;
}

export interface GetSearchProjectContactsProjectData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/company/{companyId}/Project/{projectId}/contacts';
}

export interface GetSearchProjectContactsProjectResponses {
  /**
     * Success
     */
    200: ProjectContactsSearched;
}

export interface GetSearchProjectMemberCustomerData {
  body?: never;
  path: {
        customerId: string;
        projectId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Customer/{customerId}/project/{projectId}/user/search';
}

export interface GetSearchProjectMemberCustomerResponses {
  /**
     * Success
     */
    200: ProjectUsersSearched;
}

export interface GetSearchProjectsCustomerData {
  body?: never;
  path: {
        customerId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Customer/{customerId}/project/search';
}

export interface GetSearchProjectsCustomerResponses {
  /**
     * Success
     */
    200: ProjectsSearched;
}

export interface GetSearchProjectsMonitoringData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Monitoring/projects/search';
}

export interface GetSearchProjectsMonitoringResponses {
  /**
     * Success
     */
    200: ProjectsSearched;
}

export interface GetSearchRawLogsIngestionLogData {
  body?: never;
  path: {
        tenantId: string;
    };
  query?: {
        Since?: string;
        Until?: string;
        Stage?: string;
        Outcome?: string;
        Type?: string;
        CorrelationId?: string;
        ProjectId?: string;
        VideoProcessorConfigId?: string;
        Limit?: number;
    };
  url: '/tenants/{tenantId}/ingestion/logs/raw';
}

export interface GetSearchRawLogsIngestionLogResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface GetSearchRentalAssetsRentalAssetsData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/RentalAssets/search';
}

export interface GetSearchRentalAssetsRentalAssetsResponses {
  /**
     * Success
     */
    200: RentalAssetsSearched;
}

export interface GetSearchReportsReportData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        q?: string;
    };
  url: '/company/{companyId}/project/{projectId}/Report/search';
}

export interface GetSearchReportsReportResponses {
  /**
     * Success
     */
    200: ReportsSearched;
}

export interface GetSearchSimCardNetworkData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Network/simcard/search';
}

export interface GetSearchSimCardNetworkResponses {
  /**
     * Success
     */
    200: SimConfigsSearched;
}

export interface GetSearchSitesInstallerData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Installer/sites/search';
}

export interface GetSearchSitesInstallerResponses {
  /**
     * Success
     */
    200: ContractsSearched;
}

export interface GetSearchTenantAvailableMonitorsTenantData {
  body?: never;
  path: {
        tenantId: string;
    };
  query?: never;
  url: '/Tenant/{tenantId}/monitors/available';
}

export interface GetSearchTenantAvailableMonitorsTenantResponses {
  /**
     * Success
     */
    200: MonitoringCompaniesSearched;
}

export interface GetSearchTenantsFailedWebhooksTenantData {
  body?: never;
  path: {
        tenantId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Tenant/{tenantId}/cameras/failed/search';
}

export interface GetSearchTenantsFailedWebhooksTenantResponses {
  /**
     * Success
     */
    200: FailedWebhooksSearched;
}

export interface GetSearchTenantsTenantData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Tenant/search';
}

export interface GetSearchTenantsTenantMonitoringData {
  body?: never;
  path: {
        tenantId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/tenants/{tenantId}/TenantMonitoring/companies/search';
}

export interface GetSearchTenantsTenantMonitoringResponses {
  /**
     * Success
     */
    200: TenantMonitoringCompaniesSearched;
}

export interface GetSearchTenantsTenantResponses {
  /**
     * Success
     */
    200: TenantsSearched;
}

export interface GetSearchTenantsUsersTenantData {
  body?: never;
  path: {
        tenantId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Tenant/{tenantId}/users';
}

export interface GetSearchTenantsUsersTenantResponses {
  /**
     * Success
     */
    200: AdminUsersSearched;
}

export interface GetSearchUsersUsersData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Users';
}

export interface GetSearchUsersUsersResponses {
  /**
     * Success
     */
    200: AdminUsersSearched;
}

export interface GetSearchv2AlertMonitoringData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/AlertMonitoring/searchv2';
}

export interface GetSearchv2AlertMonitoringResponses {
  /**
     * Success
     */
    200: MonitorAlertsSearched;
}

export interface GetSearchWebhooksMonitoringData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Monitoring/webhooks/search';
}

export interface GetSearchWebhooksMonitoringResponses {
  /**
     * Success
     */
    200: InboundWebhooksSearched;
}

export interface GetShiftInformationAlertMonitoringData {
  body?: never;
  path?: never;
  query?: never;
  url: '/AlertMonitoring/shift';
}

export interface GetShiftInformationAlertMonitoringResponses {
  /**
     * Success
     */
    200: CurrentShiftFetched;
}

export interface GetSimCardNetworkData {
  body?: never;
  path: {
        id: string;
    };
  query?: never;
  url: '/Network/simcard/{id}';
}

export interface GetSimCardNetworkResponses {
  /**
     * Success
     */
    200: SimConfigCrudded;
}

export interface GetTenantAuthData {
  body?: never;
  path: {
        tenantId: string;
    };
  query?: never;
  url: '/Auth/tenant/{tenantId}';
}

export interface GetTenantAuthResponses {
  /**
     * Success
     */
    200: TenantInfo;
}

export interface GetValidateConfigurationDeviceData {
  body?: never;
  path: {
        deviceId: string;
    };
  query?: never;
  url: '/Integration/Device/{deviceId}/configuration-validate';
}

export interface GetValidateConfigurationDeviceResponses {
  /**
     * Success
     */
    200: DeviceConfigurationValidated;
}

export interface HardwareAssetDto {
  assetId?: string;
  name?: string | null;
  type?: AssetType;
  groupId?: string | null;
  groupName?: string | null;
}

export interface HardwareAssociationsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<AssociatedHardwareDto> | null;
}

export interface HardwareMinDto {
  id?: string;
  type?: string | null;
  hardwareType?: string | null;
  companyId?: string;
  projectId?: string;
  name?: string | null;
  inUse?: boolean;
  retiredAt?: string | null;
}

export interface HardwareRetired {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface HardwareSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<HardwareMinDto> | null;
}

export interface HardwareSeenDto {
  hardwareId?: string;
  start?: string | null;
  end?: string | null;
  zoneId?: string | null;
  zoneName?: string | null;
  siteId?: string | null;
  siteName?: string | null;
}

export interface HostReachabilityTested {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  isReachable?: boolean;
  host?: string | null;
  port?: number;
  latencyMs?: number;
  errorMessage?: string | null;
  usedEdgeLink?: boolean;
  untestableReason?: string | null;
}

export interface IdentifySiteInstructionsResponse {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  applicableInstructions?: Array<string> | null;
  actionItems?: Array<string> | null;
}

export interface ImageUrlDto {
  url?: string | null;
}

export interface InactiveCameraDto {
  videoProcessorId?: string | null;
  videoProcessorType?: EnumVideoProcessor;
  videoProcessorGuid?: string;
  projectId?: string;
  projectName?: string | null;
  assetId?: string;
  customerId?: string;
  assetName?: string | null;
  latestWebhookBody?: string | null;
  latestWebhookKeywords?: string | null;
  latestWebhookFailure?: string | null;
  latestWebhook?: InboundWebhookDto;
  serialNumber?: string | null;
}

export interface InactiveCamerasSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<InactiveCameraDto> | null;
  cameras?: Array<InactiveCameraDto> | null;
}

export interface InboundWebhookDto {
  created?: string;
  body?: string | null;
  keywords?: string | null;
  failure?: string | null;
}

export interface InboundWebhookSearchDto {
  id?: string;
  received?: string;
  type?: EnumWebhookType;
  keywords?: string | null;
  failure?: string | null;
  processedAt?: string | null;
}

export interface InboundWebhooksSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<InboundWebhookSearchDto> | null;
}

export interface Incident {
  id?: string | null;
  alertId?: string | null;
  title?: string | null;
  occurred?: string | null;
  severity?: IncidentSeverity;
  status?: string | null;
  siteId?: string | null;
  siteName?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  hadSlaBreach?: boolean;
  isClosed?: boolean;
  readonly events?: Array<IncidentEvent> | null;
}

export interface IncidentEvent {
  id?: string | null;
  occurred?: string | null;
  snapshotUrl?: string | null;
  readonly hasSnapshotUrl?: boolean;
  predictedDisposition?: string | null;
  readonly hasPredictedDisposition?: boolean;
  predictionDescription?: string | null;
  readonly hasPredictionDescription?: boolean;
  cameraName?: string | null;
  readonly hasCameraName?: boolean;
}

export interface IntegrationCodeCompiled {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  compileLog?: string | null;
  compiledCode?: string | null;
  integration?: IntegrationFullDto;
}

export interface IntegrationDeleted {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface IntegrationFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  integration?: IntegrationFullDto;
}

export interface IntegrationFieldDto {
  id?: string;
  name?: string | null;
  key?: string | null;
  dataType?: string | null;
  description?: string | null;
  documentation?: string | null;
  options?: Array<string> | null;
  optional?: boolean | null;
  deletedAt?: string | null;
}

export interface IntegrationFieldsUpdated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface IntegrationFullDto {
  id?: string;
  key?: string | null;
  name?: string | null;
  integrationType?: IntegrationType;
  sourceType?: number;
  brand?: string | null;
  docs?: string | null;
  description?: string | null;
  smtpSource?: boolean;
  webhookSource?: boolean;
  watchfulLifecycleTrigger?: boolean;
  syncedVersion?: string | null;
  updated?: string;
  created?: string;
  integrationFields?: Array<IntegrationFieldDto> | null;
  sourceCode?: string | null;
  compiledCode?: string | null;
  syncedCompiledCode?: string | null;
}

export interface IntegrationKeyUpdated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface IntegrationKvStoreCleared {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface IntegrationLibraryFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  watchfulLibrary?: string | null;
  integrationLibrary?: string | null;
}

export interface IntegrationLimitedDto {
  id?: string;
  key?: string | null;
  name?: string | null;
  integrationType?: IntegrationType;
  sourceType?: number;
  brand?: string | null;
  docs?: string | null;
  description?: string | null;
  smtpSource?: boolean;
  webhookSource?: boolean;
  watchfulLifecycleTrigger?: boolean;
  syncedVersion?: string | null;
  updated?: string;
  created?: string;
  integrationFields?: Array<IntegrationFieldDto> | null;
}

export interface IntegrationPollsCleared {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface IntegrationScriptLogDto {
  message?: string | null;
  timestamp?: string;
  level?: IntegrationLogLevel;
}

export interface IntegrationsListed {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  integrations?: Array<IntegrationLimitedDto> | null;
}

export interface IntruderEventData {
  policeId?: string | null;
  weapons?: string | null;
  notes?: string | null;
  intruders?: Array<IntruderProfile> | null;
  eventOverview?: string | null;
  closureResult?: string | null;
  offenceType?: string | null;
  policeResponded?: boolean | null;
}

export interface IntruderProfile {
  images?: Array<IntruderSnapshot> | null;
  number?: number | null;
  sex?: string | null;
  age?: string | null;
  build?: string | null;
  height?: string | null;
  ethnicity?: string | null;
  hair?: string | null;
  description?: string | null;
  clothing?: string | null;
  clothingShoes?: string | null;
  clothingPants?: string | null;
  clothingTop?: string | null;
  otherInfo?: string | null;
}

export interface IntruderSnapshot {
  eventValueId?: string;
  topPct?: number;
  leftPct?: number;
  widthPct?: number;
  heightPct?: number;
}

export interface InvoiceFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  invoice?: FullInvoiceDto;
}

export interface InvoiceLineDto {
  xeroId?: string | null;
  accountId?: string;
  contractRentalAssetId?: string | null;
  description?: string | null;
  quantity?: number | null;
  unitPrice?: number | null;
  total?: number | null;
  accountCode?: string | null;
  itemCode?: string | null;
  taxAmount?: number | null;
  taxType?: string | null;
  accountName?: string | null;
}

export interface InvoiceSearchDto {
  id?: string;
  contractId?: string;
  contractName?: string | null;
  customerId?: string;
  customerName?: string | null;
  description?: string | null;
  billingDate?: string;
  status?: EnumInvoiceStatus;
  xeroFailed?: boolean;
  xeroId?: string | null;
  invoiceNumber?: string | null;
}

export interface InvoicesSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<InvoiceSearchDto> | null;
}

export interface LatestEvent {
  id?: string;
  occurred?: string;
  type?: EnumMonitoringEventType;
  alertId?: string | null;
  values?: Array<MonitoringEventValueSearchDto> | null;
}

export interface LatestSnapshotValue {
  occurred?: string;
  id?: string;
}

export interface LicenceCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  licence?: LicenceDto;
}

export interface LicenceDto {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  projectId?: string;
  expiresAfter?: TimeSpan;
  companyId?: string;
}

export interface LicenceForm {
  name?: string | null;
  description?: string | null;
  expiresAfterHours?: number | null;
}

export interface LicenceGrantCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  licenceGrant?: LicenceGrantDto;
}

export interface LicenceGrantDto {
  id?: string | null;
  assetId?: string;
  licenceId?: string;
  expiry?: string | null;
}

export interface LicencePublicDto {
  name?: string | null;
}

export interface LicenceRequirementCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  licenceRequirement?: LicenceRequirementDto;
}

export interface LicenceRequirementDto {
  assetId?: string;
  licenceId?: string;
}

export interface LicencesSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<LicenceDto> | null;
}

export interface LoggedInUserResponse {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  user?: AdminUserDto;
  companies?: Array<CompanyAccessDto> | null;
}

export interface LoginCredentialDto {
  url?: string | null;
  token?: string | null;
  username?: string | null;
  password?: string | null;
}

export interface LoginForm {
  email?: string | null;
  password?: string | null;
}

export interface MessageRequestor {
  isInternal?: boolean;
  claims?: Array<RequestorClaim> | null;
  sentBy?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
}

export interface MessageReturnBase {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface MetricDataPointDto {
  value?: number;
  key?: string | null;
  attributes?: {
        [key: string]: string | null;
    } | null;
}

export interface MetricMetaDto {
  lastRefresh?: string | null;
  slowQuery?: boolean;
  preAggregated?: boolean;
  totalCount?: number | null;
  queued?: boolean;
}

export interface MetricResultDto {
  meta?: MetricMetaDto;
  data?: Array<MetricDataPointDto> | null;
}

export interface MonitorAlertEventDto {
  id?: string;
  occurred?: string;
  type?: EnumMonitoringEventType;
  videoProcessorId?: string | null;
  videoProcessorDescription?: string | null;
  videoProcessorIdentifier?: string;
  videoProcessor?: EnumVideoProcessor;
  activationZone?: string | null;
  values?: Array<MonitoringEventValueSearchDto> | null;
  nvrId?: string | null;
  nvrDeviceName?: string | null;
  firstViewedAt?: string | null;
  firstViewedByType?: EnumViewerType;
}

export interface MonitorAlertFullDto {
  id?: string;
  projectId?: string;
  projectName?: string | null;
  notified?: boolean;
  notifiedAt?: string | null;
  lastEvent?: string;
  actionedBy?: string | null;
  disarmedAt?: string | null;
  disarmedBy?: string | null;
  actionedAt?: string | null;
  closedAt?: string | null;
  recentNotes?: Array<AlertNoteDto> | null;
  occurred?: string;
  companyId?: string;
  companyName?: string | null;
  status?: EnumAlertStatus;
  project?: MonitorAlertProjectDto;
  contactEvents?: Array<ContactEventDto> | null;
  alertId?: string | null;
  events?: Array<MonitorAlertEventDto> | null;
  recentAlerts?: Array<AssociatedMonitoringAlert> | null;
  intruderEventData?: IntruderEventData;
  nextActionSlaDue?: string | null;
  noThreatDisarmMinutes?: number | null;
  dispositionWorkflowConfig?: {
        [key: string]: Array<WorkflowConfig>;
    } | null;
  disabledDispositions?: Array<EnumAlertStatus> | null;
  dispositionWorkflowHistory?: AlertDispositionWorkflowHistory;
}

export interface MonitorAlertProjectDto {
  name?: string | null;
  siteDisarmedUntil?: string | null;
  newMonitoringAlertsAfterSeconds?: number | null;
  siteDisarmedBy?: string | null;
  siteNotes?: string | null;
  assets?: Array<MonitorAssetDto> | null;
  contacts?: Array<ProjectContactDto> | null;
  guardResponseRequired?: boolean;
  monitoredBy?: Array<ProjectMonitoringDto> | null;
  guardResponseDispatchCode?: string | null;
  address?: AddressDto;
  aiPrimed?: boolean;
  timeZone?: string | null;
  aiAutomationLevel?: EnumAiAutomationLevel;
}

export interface MonitorAlertsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<AlertPreviewDto> | null;
}

export interface MonitorAssetCamera {
  id?: string | null;
  videoProcessor?: EnumVideoProcessor;
  videoProcessorId?: string | null;
  notes?: string | null;
}

export interface MonitorAssetDto {
  id?: string;
  name?: string | null;
  serialNumber?: string | null;
  address?: AddressDto;
  cameras?: Array<MonitorAssetCamera> | null;
  deletedAt?: string | null;
}

export interface MonitoringAlertDto {
  id?: string;
  projectId?: string;
  projectName?: string | null;
  notified?: boolean;
  notifiedAt?: string | null;
  lastEvent?: string;
  actionedBy?: string | null;
  disarmedAt?: string | null;
  disarmedBy?: string | null;
  actionedAt?: string | null;
  closedAt?: string | null;
  recentNotes?: Array<AlertNoteDto> | null;
  occurred?: string;
  companyId?: string;
  companyName?: string | null;
  status?: EnumAlertStatus;
  project?: AlertProjectDto;
  contactEvents?: Array<ContactEventDto> | null;
  alertId?: string | null;
  events?: Array<MonitoringEventSearchDto> | null;
  intruderEventData?: IntruderEventData;
}

export interface MonitoringAlertFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  alert?: MonitoringAlertDto;
}

export interface MonitoringAlertSearchDto {
  id?: string;
  projectId?: string;
  alertId?: string | null;
  projectName?: string | null;
  notified?: boolean;
  notifiedAt?: string | null;
  lastEvent?: string;
  actionedBy?: string | null;
  actionedAt?: string | null;
  actioned?: boolean;
  closedAt?: string | null;
  nextActionSlaDue?: string | null;
  companyId?: string;
  companyName?: string | null;
  occurred?: string;
  status?: EnumAlertStatus;
  isClosed?: boolean;
  hadSlaBreach?: boolean;
  snapshot?: string | null;
  events?: Array<MonitoringEventSearchDto> | null;
  snapshotValueId?: string | null;
  snapshotVideoProcessorConfigId?: string | null;
  snapshotFileType?: string | null;
  snapshotStorageUri?: string | null;
}

export interface MonitoringAlertsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<MonitoringAlertSearchDto> | null;
}

export interface MonitoringCompaniesSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<MonitoringCompanySearchDto> | null;
}

export interface MonitoringCompanyCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  monitoringCompany?: MonitoringCompanyDto;
}

export interface MonitoringCompanyDto {
  id?: string | null;
  primaryEmail?: string | null;
  name?: string | null;
  domain?: string | null;
  deletedAt?: string | null;
  userId?: string;
  isDefault?: boolean;
  defaultOrder?: number | null;
  ownedById?: string | null;
  ownedBy?: string | null;
  videoProcessorLogins?: Array<MonitoringCompanyVideoProcessorLoginDto> | null;
}

export interface MonitoringCompanySearchDto {
  id?: string;
  name?: string | null;
  domain?: string | null;
  deletedAt?: string | null;
  primaryEmail?: string | null;
  userId?: string;
  isDefault?: boolean;
  defaultOrder?: number | null;
  ownedById?: string | null;
  ownedBy?: string | null;
}

export interface MonitoringCompanyVideoLoginsFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  videoProcessorLogins?: Array<MonitoringCompanyVideoProcessorLoginDto> | null;
}

export interface MonitoringCompanyVideoProcessorLoginDto {
  videoProcessor?: EnumVideoProcessor;
  loginUrl?: string | null;
  loginUser?: string | null;
  loginPassword?: string | null;
  cameraUrl?: string | null;
}

export interface MonitoringEnabled {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface MonitoringEventParserDto {
  monitoringEventPrefix?: string | null;
  monitoringEventValueType?: MonitoringEventValueType;
}

export interface MonitoringEventParsingRuleDto {
  monitoringEventPrefix?: string | null;
  monitoringEventValueType?: MonitoringEventValueType;
  id?: string;
}

export interface MonitoringEventSearchDto {
  id?: string;
  occurred?: string;
  type?: EnumMonitoringEventType;
  assetId?: string;
  assetDto?: AssetDto;
  assetName?: string | null;
  projectId?: string;
  companyId?: string;
  videoProcessorId?: string | null;
  videoProcessorConfigId?: string;
  values?: Array<MonitoringEventValueSearchDto> | null;
  projectName?: string | null;
  companyName?: string | null;
  alertId?: string | null;
  alertStart?: string | null;
  alertClosedAt?: string | null;
  videoProcessor?: EnumVideoProcessor;
  activationZone?: string | null;
  alertNumber?: string | null;
}

export interface MonitoringEventsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<MonitoringEventSearchDto> | null;
}

export interface MonitoringEventValueSearchDto {
  id?: string;
  type?: MonitoringEventValueType;
  fetched?: boolean;
  value?: number | null;
  txtValue?: string | null;
  sourceUrl?: string | null;
  videoProcessorConfigId?: string | null;
  fileType?: string | null;
  probability?: number | null;
  storageUri?: string | null;
}

export interface MonitoringLoginRequestForm {
  emailAddress: string;
  userName: string;
  redirectContext?: string | null;
}

export interface MonitoringLoginTokenForm {
  token: string;
}

export interface MonitoringMetricsFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface MonitoringOfficerCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  officer?: MonitoringOfficerDto;
}

export interface MonitoringOfficerDto {
  id?: string | null;
  userId?: string;
  name?: string | null;
  email?: string | null;
  monitoringCompanyId?: string;
  deletedAt?: string | null;
}

export interface MonitoringOfficersSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<MonitoringOfficerDto> | null;
}

export interface MonitoringZoneCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  zone?: MonitoringZoneDto;
}

export interface MonitoringZoneDto {
  id?: string | null;
  projectId?: string;
  description?: string | null;
  videoProcessors?: Array<AssetVideoProcessorDto> | null;
  schedule?: ProjectScheduleDto;
}

export interface MonthInvoicingRan {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface MonthlyEventsByCameraResponse {
  readonly data?: Array<MonthlyEventsByCameraResponseRow> | null;
  totalEvents?: number;
}

export interface MonthlyEventsByCameraResponseRow {
  cameraName?: string | null;
  cameraId?: string | null;
  eventCount?: number;
}

export interface MonthlyEventsBySiteResponse {
  readonly data?: Array<MonthlyEventsBySiteResponseRow> | null;
  totalEvents?: number;
}

export interface MonthlyEventsBySiteResponseRow {
  siteName?: string | null;
  siteId?: string | null;
  eventCount?: number;
}

export interface MoveDeviceForm {
  targetProjectId?: string;
}

export interface NetworkProviderCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  networkProvider?: NetworkProviderDto;
}

export interface NetworkProviderDto {
  id?: string | null;
  providerName?: string | null;
  customerId?: string | null;
}

export interface NetworkProvidersSearchDto {
  id?: string;
  providerName?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  simCount?: number;
}

export interface NetworkProvidersSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<NetworkProvidersSearchDto> | null;
}

export interface NetworkVideoRecorderDeviceDto {
  id?: string | null;
  networkVideoRecorderId?: string;
  deviceId?: string | null;
  name?: string | null;
  type?: string | null;
  vendor?: string | null;
  model?: string | null;
}

export interface NewDeviceConnected {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  id?: string;
  scriptLog?: Array<IntegrationScriptLogDto> | null;
  primaryDevice?: NvrDto;
  subDevices?: Array<CameraDto> | null;
}

export interface NoThreatSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface NotificationDto {
  id?: string;
  createdAt?: string;
  acknowledgedAt?: string | null;
  actionedAt?: string | null;
  completed?: boolean;
  forUser?: UserDto;
  byUser?: UserDto;
  type?: string | null;
  body?: string | null;
  title?: string | null;
}

export interface NotificationSetting {
  forMemberId?: string;
  projectId?: string;
  setting?: string | null;
  email?: boolean;
  sms?: boolean;
  push?: boolean;
}

export interface NotificationSettingSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface NvrAssetDto {
  id?: string;
  name?: string | null;
  assetNumber?: string | null;
  description?: string | null;
  projectId?: string | null;
  contractName?: string | null;
  contractId?: string;
}

export interface NvrConnected {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  devices?: Array<NvrDeviceDto> | null;
  description?: string | null;
  connectError?: string | null;
}

export interface NvrDeviceDto {
  id?: string;
  deviceId?: string | null;
  lastSeen?: string | null;
  monitored?: boolean;
  name?: string | null;
  vendor?: string | null;
  model?: string | null;
  type?: string | null;
}

export interface NvrDevicesCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  devices?: Array<NetworkVideoRecorderDeviceDto> | null;
}

export interface NvrDeviceSearchDto {
  id?: string;
  deviceId?: string | null;
  lastSeen?: string | null;
  monitored?: boolean;
  name?: string | null;
  vendor?: string | null;
  model?: string | null;
  type?: string | null;
  nvrId?: string;
  customerId?: string;
}

export interface NvrDevicesSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<NvrDeviceSearchDto> | null;
}

export interface NvrDto {
  id?: string;
  name?: string | null;
  description?: string | null;
  externalId?: string | null;
  relays?: Array<RelayDto> | null;
  speakers?: Array<SpeakerDto> | null;
  integrationId?: string | null;
  routeNamespaceId?: string | null;
}

export interface NvRecorderCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  nvRecorder?: NvRecorderDto;
}

export interface NvRecorderDto {
  id?: string | null;
  customerId?: string | null;
  authUserId?: string | null;
  videoProcessorType?: EnumVideoProcessor;
  authToken?: string | null;
  userName?: string | null;
  password?: string | null;
  description?: string | null;
  nvrId?: string | null;
  nvrIpAddress?: string | null;
  nvrPort?: number | null;
  nvrStreamPort?: number | null;
  timeZone?: string | null;
  canConnect?: boolean;
  lastError?: string | null;
  nvrParentId?: string | null;
  nvrDeviceId?: string | null;
  integrationId?: string | null;
  externalConnectionId?: string | null;
  integrationKeyValue?: {
        [key: string]: unknown;
    } | null;
  deviceCreationChoices?: {
        [key: string]: string | null;
    } | null;
  routeNamespaceId?: string | null;
}

export interface NvRecorderSearchDto {
  id?: string;
  customerId?: string;
  authUserId?: string | null;
  description?: string | null;
  customerName?: string | null;
  videoProcessor?: EnumVideoProcessor;
  monitoredAssets?: Array<NvrAssetDto> | null;
}

export interface NvRecordersSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<NvRecorderSearchDto> | null;
}

export interface NvrFullDto {
  address?: AddressDto;
  name?: string | null;
  id?: string;
  customerId?: string;
  description?: string | null;
  nvrId?: string | null;
  model?: string | null;
  smtpPassword?: string | null;
  smtpUsername?: string | null;
  webhookAuthCredDto?: WebhookAuthCredDto;
  integration?: IntegrationLimitedDto;
  integrationKeyValue?: {
        [key: string]: unknown;
    } | null;
  deviceCreationChoices?: {
        [key: string]: string | null;
    } | null;
  updated?: string | null;
  externalConnectionLimitedDto?: ExternalConnectionLimitedDto;
  projectId?: string | null;
  routeNamespaceId?: string | null;
}

export interface OidcRedeemTokenRequest {
  requestor?: MessageRequestor;
  receivedAt?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
  token?: string | null;
}

export interface OidcRedeemTokenResponse {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  monitoringToken?: string | null;
  adminToken?: string | null;
  user?: AdminUserDto;
  tenant?: TenantDetails;
}

export interface OnSightHardware {
  id?: string;
  mac?: string | null;
}

export interface OnSightHardwareSearchResult {
  rows?: Array<OnSightHardware> | null;
  totalRows?: number;
}

export interface OnSightZone {
  id?: string;
  name?: string | null;
}

export interface OnSightZoneSearchResult {
  rows?: Array<OnSightZone> | null;
  totalRows?: number;
}

export interface PartialIntegrationFieldDto {
  id?: string | null;
  name?: string | null;
  key?: string | null;
  dataType?: string | null;
  description?: string | null;
  documentation?: string | null;
  options?: Array<string> | null;
  optional?: boolean | null;
  deletedAt?: string | null;
}

export interface PatchEndShiftV2AlertMonitoringData {
  body?: never;
  path?: never;
  query?: never;
  url: '/AlertMonitoring/shift/end';
}

export interface PatchEndShiftV2AlertMonitoringResponses {
  /**
     * Success
     */
    200: EndShiftV2;
}

export interface PersonDescription {
  height?: string | null;
  age?: string | null;
  clothingTop?: string | null;
  clothingBottom?: string | null;
  clothingShoes?: string | null;
  clothingAccessories?: string | null;
  hair?: string | null;
  build?: string | null;
  otherClothing?: string | null;
  observedActions?: string | null;
  sex?: string | null;
}

export interface PostAcknowledgeMissedCallsAlertMonitoringData {
  body?: never;
  path: {
        mcId: string;
        number: string;
    };
  query?: never;
  url: '/AlertMonitoring/monitoringcompany/{mcId}/calllog/{number}/acknowledge';
}

export interface PostAcknowledgeMissedCallsAlertMonitoringResponses {
  /**
     * Success
     */
    200: CallLogsSearched;
}

export interface PostAddAccountAccountingData {
  body?: AccountForm;
  path?: never;
  query?: never;
  url: '/Accounting/accounts/add';
}

export interface PostAddAccountAccountingResponses {
  /**
     * Success
     */
    200: AccountCrudded;
}

export interface PostAddAssetToContractContractsData {
  body?: ContractAssetDto;
  path: {
        contractId: string;
        assetId: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/asset/{assetId}/add';
}

export interface PostAddAssetToContractContractsResponses {
  /**
     * Success
     */
    200: AssetAddedToContract;
}

export interface PostAddCompanyAdminData {
  body?: CreateCompanyForm;
  path?: never;
  query?: never;
  url: '/Admin/companies';
}

export interface PostAddCompanyAdminResponses {
  /**
     * Success
     */
    200: CompanyCrudded;
}

export interface PostAddComponentRentalAssetsData {
  body?: ComponentDto;
  path: {
        assetId: string;
    };
  query?: never;
  url: '/RentalAssets/components/{assetId}';
}

export interface PostAddComponentRentalAssetsResponses {
  /**
     * Success
     */
    200: RentalAssetComponentCrudded;
}

export interface PostAddContactEventMonitoringData {
  body?: ContactEventDto;
  path: {
        companyId: string;
        projectId: string;
        alertId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/alerts/{alertId}/contact/event';
}

export interface PostAddContactEventMonitoringResponses {
  /**
     * Success
     */
    200: ContactEventAdded;
}

export interface PostAddMonitoringOfficerMonitoringData {
  body?: never;
  path: {
        companyId: string;
        userId: string;
    };
  query?: never;
  url: '/Monitoring/companies/{companyId}/users/{userId}';
}

export interface PostAddMonitoringOfficerMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringOfficerCrudded;
}

export interface PostAddNoteMonitoringData {
  body?: AddAlertNoteDto;
  path: {
        companyId: string;
        projectId: string;
        alertId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/alerts/{alertId}/note';
}

export interface PostAddNoteMonitoringResponses {
  /**
     * Success
     */
    200: AlertNoteAdded;
}

export interface PostAddProductContractsData {
  body?: AddProductToContractDto;
  path: {
        contractId: string;
        productId: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/products/{productId}';
}

export interface PostAddProductContractsResponses {
  /**
     * Success
     */
    200: ProductAddedToContract;
}

export interface PostAddProjectContactCustomerData {
  body?: ProjectContactDto;
  path: {
        customerId: string;
        projectId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}/contact';
}

export interface PostAddProjectContactCustomerResponses {
  /**
     * Success
     */
    200: ProjectContactCrudded;
}

export interface PostAddProjectMemberCustomerData {
  body?: never;
  path: {
        customerId: string;
        projectId: string;
        userId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}/user/{userId}';
}

export interface PostAddProjectMemberCustomerResponses {
  /**
     * Success
     */
    200: ProjectCrudded;
}

export interface PostAddProjectNvRecorderCustomerData {
  body?: never;
  path: {
        customerId: string;
        projectId: string;
        userId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}/user/{userId}/nvr';
}

export interface PostAddProjectNvRecorderCustomerResponses {
  /**
     * Success
     */
    200: ProjectCrudded;
}

export interface PostAddSalesOrderLineOrderData {
  body?: SalesOrderLineDto;
  path: {
        id: string;
    };
  query?: never;
  url: '/Order/{id}/line';
}

export interface PostAddSalesOrderLineOrderResponses {
  /**
     * Success
     */
    200: SalesOrderLineCrudded;
}

export interface PostAddSalesOrderLogOrderData {
  body?: {
        File?: Blob | File;
        Id?: string;
        SalesOrderId?: string;
        Note?: string;
        FilePath?: string;
        Created?: string;
    };
  path: {
        id: string;
    };
  query?: never;
  url: '/Order/{id}/log';
}

export interface PostAddSalesOrderLogOrderResponses {
  /**
     * Success
     */
    200: SalesOrderLogCrudded;
}

export interface PostAddSalesPersonContractsData {
  body?: never;
  path: {
        contractId: string;
        salesPersonId: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/salesperson/{salesPersonId}';
}

export interface PostAddSalesPersonContractsResponses {
  /**
     * Success
     */
    200: SalesPersonCrudded;
}

export interface PostAddUserCompanyData {
  body?: CreateUserForm;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/Company/{companyId}/user';
}

export interface PostAddUserCompanyResponses {
  /**
     * Success
     */
    200: UserCruded;
}

export interface PostAddUserProjectData {
  body?: AddUserForm;
  path: {
        projectId: string;
        companyId: string;
    };
  query?: never;
  url: '/company/{companyId}/Project/{projectId}/user';
}

export interface PostAddUserProjectResponses {
  /**
     * Success
     */
    200: UserCruded;
}

export interface PostAddUserTenantData {
  body?: never;
  path: {
        tenantId: string;
        userId: string;
    };
  query?: never;
  url: '/Tenant/{tenantId}/users/{userId}';
}

export interface PostAddUserTenantResponses {
  /**
     * Success
     */
    200: TenantUserCrudded;
}

export interface PostAddVideoProcessorConfigRentalAssetsData {
  body?: VideoProcessorConfigDto;
  path: {
        assetId: string;
    };
  query?: never;
  url: '/RentalAssets/{assetId}/videoprocessor';
}

export interface PostAddVideoProcessorConfigRentalAssetsResponses {
  /**
     * Success
     */
    200: VideoProcessorConfigCrudded;
}

export interface PostApplyAlertingChangesDeviceData {
  body?: ApplyAlertingChangesForm;
  path: {
        nvrId: string;
    };
  query?: never;
  url: '/Integration/Device/{nvrId}/alerting-configuration/apply';
}

export interface PostApplyAlertingChangesDeviceResponses {
  /**
     * Success
     */
    200: AlertingChangesApplied;
}

export interface PostApproveRentalAssetRentalAssetsData {
  body?: ApprovedRentalAssetDto;
  path: {
        assetId: string;
    };
  query?: never;
  url: '/RentalAssets/{assetId}/approve';
}

export interface PostApproveRentalAssetRentalAssetsResponses {
  /**
     * Success
     */
    200: RentalAssetApproved;
}

export interface PostAssignAssetToAssetPublicData {
  body?: never;
  path: {
        userId: string;
        assetId: string;
        endTime: string;
    };
  query?: never;
  url: '/Public/asset/{assetId}/takeby/{userId}/till/{endTime}';
}

export interface PostAssignAssetToAssetPublicResponses {
  /**
     * Success
     */
    200: PublicAssociateAssetResult;
}

export interface PostAssignHardwareAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
        hardwareId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/assignHardware/{assetId}/{hardwareId}';
}

export interface PostAssignHardwareAssetResponses {
  /**
     * Success
     */
    200: AssetsSearched;
}

export interface PostBindToProjectContractsData {
  body?: never;
  path: {
        contractId: string;
        projectId: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/project/{projectId}';
}

export interface PostBindToProjectContractsResponses {
  /**
     * Success
     */
    200: ContractProductsSearched;
}

export interface PostBindXeroAccountsAccountingData {
  body?: BindXeroAccounts;
  path?: never;
  query?: never;
  url: '/Accounting/accounts/bind';
}

export interface PostBindXeroAccountsAccountingResponses {
  /**
     * Success
     */
    200: XeroAccountsBound;
}

export interface PostCallbackXeroConnectXeroData {
  body?: XeroConnectForm;
  path?: never;
  query?: never;
  url: '/Xero/auth/callback';
}

export interface PostCallbackXeroConnectXeroResponses {
  /**
     * Success
     */
    200: XeroConnected;
}

export interface PostCloseAlertAlertingData {
  body?: CloseAlertDto;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/Alerting/{alertId}/close';
}

export interface PostCloseAlertAlertingResponses {
  /**
     * Success
     */
    200: AlertClosed;
}

export interface PostCloseAlertMonitoringData {
  body?: CloseAlertForm;
  path: {
        companyId: string;
        projectId: string;
        alertId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/alerts/{alertId}/close';
}

export interface PostCloseAlertMonitoringResponses {
  /**
     * Success
     */
    200: AlertClosed;
}

export interface PostCloseComplianceEventComplianceData {
  body?: CloseComplianceForm;
  path: {
        companyId: string;
        projectId: string;
        eventId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Compliance/{eventId}/close';
}

export interface PostCloseComplianceEventComplianceResponses {
  /**
     * Success
     */
    200: ComplianceEventClosed;
}

export interface PostConvertSalesOrderToContractOrderData {
  body?: AcceptSalesOrderDto;
  path: {
        id: string;
    };
  query?: never;
  url: '/Order/{id}/accept';
}

export interface PostConvertSalesOrderToContractOrderResponses {
  /**
     * Success
     */
    200: SalesOrderAccepted;
}

export interface PostCreateAdminEventCalendarData {
  body?: CalendarEventDto;
  path: {
        calendarId: string;
    };
  query?: never;
  url: '/Calendar/{calendarId}/admin/create';
}

export interface PostCreateAdminEventCalendarResponses {
  /**
     * Success
     */
    200: CalendarEventCrudded;
}

export interface PostCreateAssetAssetData {
  body?: CreateAssetForm;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset';
}

export interface PostCreateAssetAssetResponses {
  /**
     * Success
     */
    200: AssetCrudded;
}

export interface PostCreateAssetGroupCompanyData {
  body?: AssetGroupForm;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/Company/{companyId}/assetgroup';
}

export interface PostCreateAssetGroupCompanyResponses {
  /**
     * Success
     */
    200: AssetGroupCrudded;
}

export interface PostCreateBeaconHardwareData {
  body?: BeaconForm;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/company/{companyId}/Hardware/beacon';
}

export interface PostCreateBeaconHardwareResponses {
  /**
     * Success
     */
    200: BeaconCrudded;
}

export interface PostCreateCompanyMonitoringData {
  body?: MonitoringCompanyDto;
  path?: never;
  query?: never;
  url: '/Monitoring/companies';
}

export interface PostCreateCompanyMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringCompanyCrudded;
}

export interface PostCreateCompanyTenantMonitoringData {
  body?: TenantMonitoringCompanyDto;
  path: {
        tenantId: string;
    };
  query?: never;
  url: '/tenants/{tenantId}/TenantMonitoring/companies';
}

export interface PostCreateCompanyTenantMonitoringResponses {
  /**
     * Success
     */
    200: TenantMonitoringCompanyCrudded;
}

export interface PostCreateContractContractsData {
  body?: CreateContractForm;
  path?: never;
  query?: never;
  url: '/customer/Contracts';
}

export interface PostCreateContractContractsResponses {
  /**
     * Success
     */
    200: ContractCrudded;
}

export interface PostCreateCustomerCustomerData {
  body?: CustomerCreateDto;
  path?: never;
  query?: never;
  url: '/Customer';
}

export interface PostCreateCustomerCustomerResponses {
  /**
     * Success
     */
    200: CustomerCreated;
}

export interface PostCreateDeviceDeviceData {
  body?: ConnectNewDevice;
  path?: never;
  query?: never;
  url: '/Integration/Device/connect';
}

export interface PostCreateDeviceDeviceResponses {
  /**
     * Success
     */
    200: NewDeviceConnected;
}

export interface PostCreateDeviceExternalConnectionData {
  body?: CreateExternalConnectionDevice;
  path?: never;
  query?: never;
  url: '/Integration/ExternalConnection/create-device';
}

export interface PostCreateDeviceExternalConnectionResponses {
  /**
     * Success
     */
    200: NewDeviceConnected;
}

export interface PostCreateEdgeLinksData {
  body?: CreateBridgeDto;
  path?: never;
  query?: never;
  url: '/EdgeLinks/bridges';
}

export interface PostCreateEdgeLinksResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PostCreateEventCalendarData {
  body?: CalendarEventDto;
  path: {
        calendarId: string;
    };
  query?: never;
  url: '/Calendar/{calendarId}/create';
}

export interface PostCreateEventCalendarResponses {
  /**
     * Success
     */
    200: CalendarEventCrudded;
}

export interface PostCreateGatewayGatewayData {
  body?: GatewayForm;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/company/{companyId}/Gateway';
}

export interface PostCreateGatewayGatewayResponses {
  /**
     * Success
     */
    200: GatewayCrudded;
}

export interface PostCreateIntegrationIntegrationData {
  body?: CreateIntegration;
  path?: never;
  query?: never;
  url: '/Integration/manage';
}

export interface PostCreateIntegrationIntegrationResponses {
  /**
     * Success
     */
    200: CreatedIntegration;
}

export interface PostCreateLicenceLicenceData {
  body?: LicenceForm;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Licence';
}

export interface PostCreateLicenceLicenceResponses {
  /**
     * Success
     */
    200: LicenceCrudded;
}

export interface PostCreateMonitoringZoneMonitoringData {
  body?: ZoneForm;
  path: {
        projectId: string;
    };
  query?: never;
  url: '/project/{projectId}/zone/create';
}

export interface PostCreateMonitoringZoneMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringZoneCrudded;
}

export interface PostCreateNetworkProviderNetworkData {
  body?: NetworkProviderDto;
  path?: never;
  query?: never;
  url: '/Network';
}

export interface PostCreateNetworkProviderNetworkResponses {
  /**
     * Success
     */
    200: NetworkProviderCrudded;
}

export interface PostCreateNotificationUsersData {
  body?: NotificationDto;
  path?: never;
  query?: never;
  url: '/Users/notifications/add';
}

export interface PostCreateNotificationUsersResponses {
  /**
     * Success
     */
    200: UserNotificationCrudded;
}

export interface PostCreateNvrDeviceMonitoringData {
  body?: Array<NetworkVideoRecorderDeviceDto>;
  path: {
        customerId: string;
        nvrId: string;
    };
  query?: never;
  url: '/Monitoring/customers/{customerId}/nvrecorders/{nvrId}/devices';
}

export interface PostCreateNvrDeviceMonitoringResponses {
  /**
     * Success
     */
    200: NvrDevicesCrudded;
}

export interface PostCreateNvRecorderMonitoringData {
  body?: NvRecorderDto;
  path: {
        customerId: string;
    };
  query?: never;
  url: '/Monitoring/customers/{customerId}/nvrecorders';
}

export interface PostCreateNvRecorderMonitoringResponses {
  /**
     * Success
     */
    200: NvRecorderCrudded;
}

export interface PostCreateOrderOrderData {
  body?: SalesOrderDto;
  path?: never;
  query?: never;
  url: '/Order';
}

export interface PostCreateOrderOrderResponses {
  /**
     * Success
     */
    200: SalesOrderCrudded;
}

export interface PostCreateProductProductsData {
  body?: ProductDto;
  path?: never;
  query?: never;
  url: '/Products';
}

export interface PostCreateProductProductsResponses {
  /**
     * Success
     */
    200: ProductCrudded;
}

export interface PostCreateProjectCustomerData {
  body?: CreateProjectForm;
  path: {
        customerId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project';
}

export interface PostCreateProjectCustomerResponses {
  /**
     * Success
     */
    200: ProjectCrudded;
}

export interface PostCreateRegionCalendarData {
  body?: never;
  path: {
        region: string;
    };
  query?: never;
  url: '/Calendar/{region}/createRegion';
}

export interface PostCreateRegionCalendarResponses {
  /**
     * Success
     */
    200: CalendarRegionCrudded;
}

export interface PostCreateRelayRelayData {
  body?: RelayDto;
  path?: never;
  query?: never;
  url: '/Integration/Relay';
}

export interface PostCreateRelayRelayResponses {
  /**
     * Success
     */
    200: RelayCrudded;
}

export interface PostCreateRentalAssetRentalAssetsData {
  body?: CreateRentalAssetDto;
  path?: never;
  query?: never;
  url: '/RentalAssets';
}

export interface PostCreateRentalAssetRentalAssetsResponses {
  /**
     * Success
     */
    200: RentalAssetCreated;
}

export interface PostCreateReportReportData {
  body?: ReportForm;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        reportId?: string;
    };
  url: '/company/{companyId}/project/{projectId}/Report';
}

export interface PostCreateReportReportResponses {
  /**
     * Success
     */
    200: ReportCrudded;
}

export interface PostCreateRfidHardwareData {
  body?: RfidForm;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/company/{companyId}/Hardware/rfid';
}

export interface PostCreateRfidHardwareResponses {
  /**
     * Success
     */
    200: RfidCrudded;
}

export interface PostCreateRouteEdgeLinksData {
  body?: CreateRouteDto;
  path: {
        bridgeId: string;
    };
  query?: never;
  url: '/EdgeLinks/bridges/{bridgeId}/routes';
}

export interface PostCreateRouteEdgeLinksResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PostCreateSimCardNetworkData {
  body?: SimConfigDto;
  path?: never;
  query?: never;
  url: '/Network/simcard';
}

export interface PostCreateSimCardNetworkResponses {
  /**
     * Success
     */
    200: SimConfigCrudded;
}

export interface PostCreateSiteSiteData {
  body?: SiteForm;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/company/{companyId}/Site';
}

export interface PostCreateSiteSiteResponses {
  /**
     * Success
     */
    200: SiteCrudded;
}

export interface PostCreateSmtpParserMonitoringData {
  body?: CrudSmtpParserDto;
  path?: never;
  query?: never;
  url: '/Monitoring/smtp/parsers';
}

export interface PostCreateSmtpParserMonitoringResponses {
  /**
     * Success
     */
    200: NvRecorderCrudded;
}

export interface PostCreateSpeakerSpeakerData {
  body?: SpeakerDto;
  path?: never;
  query?: never;
  url: '/Integration/Speaker';
}

export interface PostCreateSpeakerSpeakerResponses {
  /**
     * Success
     */
    200: SpeakerCrudded;
}

export interface PostCreateTenantTenantData {
  body?: TenantDto;
  path?: never;
  query?: never;
  url: '/Tenant';
}

export interface PostCreateTenantTenantResponses {
  /**
     * Success
     */
    200: TenantCrudded;
}

export interface PostCreateUserUsersData {
  body?: AdminUserForm;
  path?: never;
  query?: never;
  url: '/Users';
}

export interface PostCreateUserUsersResponses {
  /**
     * Success
     */
    200: AdminUserCrudded;
}

export interface PostCreateZoneFromExistingSiteData {
  body?: CreateZoneFromExistingForm;
  path: {
        companyId: string;
        siteId: string;
    };
  query?: never;
  url: '/company/{companyId}/Site/{siteId}/zone/existing';
}

export interface PostCreateZoneFromExistingSiteResponses {
  /**
     * Success
     */
    200: ZoneCrudded;
}

export interface PostCreateZoneSiteData {
  body?: CreateZoneForm;
  path: {
        companyId: string;
        siteId: string;
    };
  query?: never;
  url: '/company/{companyId}/Site/{siteId}/zone';
}

export interface PostCreateZoneSiteResponses {
  /**
     * Success
     */
    200: ZoneCrudded;
}

export interface PostDeleteDeviceDeviceData {
  body?: SaveDeviceForm;
  path: {
        deviceId: string;
    };
  query?: never;
  url: '/Integration/Device/{deviceId}/delete';
}

export interface PostDeleteDeviceDeviceResponses {
  /**
     * Success
     */
    200: PrimaryDeviceCrudded;
}

export interface PostDescribePeopleAlertMonitoringData {
  body?: Array<string>;
  path?: never;
  query?: never;
  url: '/AlertMonitoring/describe-people';
}

export interface PostDescribePeopleAlertMonitoringResponses {
  /**
     * Success
     */
    200: DescribePeopleResponse;
}

export interface PostDisarmAlertAlertingData {
  body?: DisarmDto;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/Alerting/{alertId}/disarm';
}

export interface PostDisarmAlertAlertingResponses {
  /**
     * Success
     */
    200: AlertDisarmed;
}

export interface PostDisarmAlertMonitoringData {
  body?: DisarmDto;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/Monitoring/alerts/{alertId}/disarm';
}

export interface PostDisarmAlertMonitoringResponses {
  /**
     * Success
     */
    200: AlertDisarmed;
}

export interface PostDisarmProjectCustomerData {
  body?: DisarmProjectDto;
  path: {
        customerId: string;
        projectId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}/disarm';
}

export interface PostDisarmProjectCustomerResponses {
  /**
     * Success
     */
    200: ProjectAlertingDisarmed;
}

export interface PostDisarmProjectProjectData {
  body?: DisarmProjectDto;
  path: {
        projectId: string;
        companyId: string;
    };
  query?: {
        customerId?: string;
    };
  url: '/company/{companyId}/Project/{projectId}/disarm';
}

export interface PostDisarmProjectProjectResponses {
  /**
     * Success
     */
    200: ProjectAlertingDisarmed;
}

export interface PostDoTokenResetAuthData {
  body?: TokenResetForm;
  path?: never;
  query?: never;
  url: '/Auth/DoTokenReset';
}

export interface PostDoTokenResetAuthResponses {
  /**
     * Success
     */
    200: MessageReturnBase;
}

export interface PostEncryptionKeyAdminData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Admin/encryptionKey';
}

export interface PostEncryptionKeyAdminResponses {
  /**
     * Success
     */
    200: EncryptionKeySet;
}

export interface PostEndShiftAlertMonitoringData {
  body?: never;
  path?: never;
  query?: never;
  url: '/AlertMonitoring/shift/end';
}

export interface PostEndShiftAlertMonitoringResponses {
  /**
     * Success
     */
    200: ShiftEnded;
}

export interface PostFetchAssetTypesRentalAssetsData {
  body?: never;
  path?: never;
  query?: never;
  url: '/RentalAssets/assettypes';
}

export interface PostFetchAssetTypesRentalAssetsResponses {
  /**
     * Success
     */
    200: RentalAssetTypesFetched;
}

export interface PostFetchComponentCredentialsRentalAssetsData {
  body?: never;
  path: {
        assetId: string;
        componentId: string;
    };
  query?: never;
  url: '/RentalAssets/components/{assetId}/{componentId}/credentials';
}

export interface PostFetchComponentCredentialsRentalAssetsResponses {
  /**
     * Success
     */
    200: ComponentPasswordFetched;
}

export interface PostFetchXeroInvoiceXeroData {
  body?: never;
  path: {
        xeroInvoiceId: string;
    };
  query?: never;
  url: '/Xero/invoice/{xeroInvoiceId}/fetch';
}

export interface PostFetchXeroInvoiceXeroResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PostGenerateShareLinkEdgeLinksData {
  body?: GenerateShareLinkRequest;
  path: {
        id: string;
    };
  query?: never;
  url: '/EdgeLinks/bridges/{id}/share-link';
}

export interface PostGenerateShareLinkEdgeLinksResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PostGetJobStatusPreaggAdminData {
  body?: PreaggJobStatusRequestDto;
  path?: never;
  query?: never;
  url: '/pre-aggregations/jobs/status';
}

export interface PostGetJobStatusPreaggAdminResponses {
  /**
     * Success
     */
    200: PreaggJobStatusResponseDto;
}

export interface PostGrantLicenceAssetData {
  body?: AssetLicenceGrant;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
        licenceId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}/licencegrant/{licenceId}';
}

export interface PostGrantLicenceAssetResponses {
  /**
     * Success
     */
    200: LicenceGrantCrudded;
}

export interface PostHashEmailAuthData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Auth/hash-email';
}

export interface PostHashEmailAuthResponses {
  /**
     * Success
     */
    200: EmailHashResponse;
}

export interface PostHideNonRentableAssetRentalAssetsData {
  body?: never;
  path: {
        assetId: string;
    };
  query?: never;
  url: '/RentalAssets/{assetId}/hide';
}

export interface PostHideNonRentableAssetRentalAssetsResponses {
  /**
     * Success
     */
    200: AssetSetNonRentable;
}

export interface PostIdentifySiteInstructionsAlertMonitoringData {
  body?: never;
  path: {
        projectId: string;
        alertNoteId: string;
    };
  query?: never;
  url: '/AlertMonitoring/project/{projectId}/alertnote/{alertNoteId}/identify-site-instructions';
}

export interface PostIdentifySiteInstructionsAlertMonitoringResponses {
  /**
     * Success
     */
    200: IdentifySiteInstructionsResponse;
}

export interface PostLoginAuthData {
  body?: LoginForm;
  path?: never;
  query?: never;
  url: '/Auth/Login';
}

export interface PostLoginAuthResponses {
  /**
     * Success
     */
    200: LoggedInUserResponse;
}

export interface PostModifyAssetOnContractContractsData {
  body?: ContractAssetChangeDto;
  path: {
        contractId: string;
        contractAssetId: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/contractasset/{contractAssetId}/modify';
}

export interface PostModifyAssetOnContractContractsResponses {
  /**
     * Success
     */
    200: AssetCommercialsChanged;
}

export interface PostMonitoringLoginAuthData {
  body?: LoginForm;
  path?: never;
  query?: never;
  url: '/Auth/monitoring/Login';
}

export interface PostMonitoringLoginAuthResponses {
  /**
     * Success
     */
    200: LoggedInUserResponse;
}

export interface PostMoveDeviceDeviceData {
  body?: MoveDeviceForm;
  path: {
        deviceId: string;
    };
  query?: never;
  url: '/Integration/Device/{deviceId}/move';
}

export interface PostMoveDeviceDeviceResponses {
  /**
     * Success
     */
    200: AssetMoved;
}

export interface PostMyNotificationsUsersData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Users/notifications/mine';
}

export interface PostMyNotificationsUsersResponses {
  /**
     * Success
     */
    200: UserNotificationsSearched;
}

export interface PostNotificationAcknowledgedUsersData {
  body?: never;
  path: {
        notificationId: string;
    };
  query?: never;
  url: '/Users/notifications/{notificationId}/acknowledge';
}

export interface PostNotificationAcknowledgedUsersResponses {
  /**
     * Success
     */
    200: UserNotificationCrudded;
}

export interface PostNotificationActionedUsersData {
  body?: never;
  path: {
        notificationId: string;
    };
  query?: never;
  url: '/Users/notifications/{notificationId}/actioned';
}

export interface PostNotificationActionedUsersResponses {
  /**
     * Success
     */
    200: UserNotificationCrudded;
}

export interface PostNvRecorderConnectMonitoringData {
  body?: never;
  path: {
        customerId: string;
        nvrId: string;
    };
  query?: never;
  url: '/Monitoring/customers/{customerId}/nvrecorders/{nvrId}/connect';
}

export interface PostNvRecorderConnectMonitoringResponses {
  /**
     * Success
     */
    200: NvrConnected;
}

export interface PostRedeemTokenOidcData {
  body?: OidcRedeemTokenRequest;
  path?: never;
  query?: never;
  url: '/Oidc/redeem';
}

export interface PostRedeemTokenOidcResponses {
  /**
     * Success
     */
    200: OidcRedeemTokenResponse;
}

export interface PostReindexExternalConnectionExternalConnectionData {
  body?: ExternalConnectionDto;
  path: {
        connectionId: string;
    };
  query?: never;
  url: '/Integration/ExternalConnection/{connectionId}/reindex';
}

export interface PostReindexExternalConnectionExternalConnectionResponses {
  /**
     * Success
     */
    200: ExternalConnectionIndexed;
}

export interface PostRelocateAssetContractsData {
  body?: Relocation;
  path: {
        contractId: string;
        contractAssetId: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/contractasset/{contractAssetId}/relocate';
}

export interface PostRelocateAssetContractsResponses {
  /**
     * Success
     */
    200: AssetRelocated;
}

export interface PostReopenAlertAlertingData {
  body?: ReopenAlertDto;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/Alerting/{alertId}/reopen';
}

export interface PostReopenAlertAlertingResponses {
  /**
     * Success
     */
    200: AlertReopened;
}

export interface PostRequestMonitoringLoginAuthData {
  body?: MonitoringLoginRequestForm;
  path?: never;
  query?: never;
  url: '/Auth/monitoring/loginrequest';
}

export interface PostRequestMonitoringLoginAuthResponses {
  /**
     * Success
     */
    200: AuthTokenRequested;
}

export interface PostRequestResetPasswordAuthData {
  body?: ResetForm;
  path?: never;
  query?: never;
  url: '/Auth/Reset';
}

export interface PostRequestResetPasswordAuthResponses {
  /**
     * Success
     */
    200: MessageReturnBase;
}

export interface PostRequireLicenceAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
        licenceId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}/requirelicence/{licenceId}';
}

export interface PostRequireLicenceAssetResponses {
  /**
     * Success
     */
    200: LicenceRequirementCrudded;
}

export interface PostRetireRentalAssetRentalAssetsData {
  body?: never;
  path: {
        assetId: string;
    };
  query?: never;
  url: '/RentalAssets/{assetId}/retire';
}

export interface PostRetireRentalAssetRentalAssetsResponses {
  /**
     * Success
     */
    200: AssetSetNonRentable;
}

export interface PostSaveIntegrationCodeIntegrationData {
  body?: SaveCodeForm;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/manage/{id}/code';
}

export interface PostSaveIntegrationCodeIntegrationResponses {
  /**
     * Success
     */
    200: IntegrationCodeCompiled;
}

export interface PostSearchAssetGroupsCompanyData {
  body?: never;
  path: {
        companyId: string;
    };
  query?: {
        q?: string;
    };
  url: '/Company/{companyId}/assetgroup/search';
}

export interface PostSearchAssetGroupsCompanyResponses {
  /**
     * Success
     */
    200: AssetGroupsSearched;
}

export interface PostSearchCompaniesAdminData {
  body?: never;
  path?: never;
  query?: {
        q?: string;
    };
  url: '/Admin/companies/search';
}

export interface PostSearchCompaniesAdminResponses {
  /**
     * Success
     */
    200: CompaniesSearched;
}

export interface PostSearchLicencesLicenceData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        q?: string;
    };
  url: '/company/{companyId}/project/{projectId}/Licence/search';
}

export interface PostSearchLicencesLicenceResponses {
  /**
     * Success
     */
    200: LicencesSearched;
}

export interface PostSearchMonitoringOfficersMonitoringData {
  body?: never;
  path: {
        companyId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Monitoring/companies/{companyId}/users/search';
}

export interface PostSearchMonitoringOfficersMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringOfficersSearched;
}

export interface PostSearchNvRecordersMonitoringData {
  body?: never;
  path: {
        customerId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Monitoring/customers/{customerId}/nvrecorders/search';
}

export interface PostSearchNvRecordersMonitoringResponses {
  /**
     * Success
     */
    200: NvRecordersSearched;
}

export interface PostSearchSitesSiteData {
  body?: never;
  path: {
        companyId: string;
    };
  query?: {
        q?: string;
    };
  url: '/company/{companyId}/Site/search';
}

export interface PostSearchSitesSiteResponses {
  /**
     * Success
     */
    200: SitesSearched;
}

export interface PostSearchSmtpParsersMonitoringData {
  body?: never;
  path?: never;
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Monitoring/smtp/parsers/search';
}

export interface PostSearchSmtpParsersMonitoringResponses {
  /**
     * Success
     */
    200: SmtpParsersSearched;
}

export interface PostSearchUserProjectsUsersData {
  body?: never;
  path: {
        userId: string;
    };
  query?: {
        PageNumber?: number;
        PageSize?: number;
        SortBy?: string;
        SortDir?: SortOrder;
        'Filter.Operator'?: FilterOperator;
        'Filter.Filters'?: Array<Filter>;
        'Filter.FilterGroups'?: Array<FilterGroup>;
    };
  url: '/Users/{userId}/project/search';
}

export interface PostSearchUserProjectsUsersResponses {
  /**
     * Success
     */
    200: ProjectUsersSearched;
}

export interface PostSearchUsersCompanyData {
  body?: never;
  path: {
        companyId: string;
    };
  query?: {
        q?: string;
    };
  url: '/Company/{companyId}/users/search';
}

export interface PostSearchUsersCompanyResponses {
  /**
     * Success
     */
    200: UsersSearched;
}

export interface PostSearchUsersProjectData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        q?: string;
    };
  url: '/company/{companyId}/Project/{projectId}/user/search';
}

export interface PostSearchUsersProjectResponses {
  /**
     * Success
     */
    200: UsersSearched;
}

export interface PostSearchZonesSiteData {
  body?: never;
  path: {
        companyId: string;
        siteId: string;
    };
  query?: {
        q?: string;
    };
  url: '/company/{companyId}/Site/{siteId}/zone/search';
}

export interface PostSearchZonesSiteResponses {
  /**
     * Success
     */
    200: ZonesSearched;
}

export interface PostSendContactSmsMonitoringData {
  body?: SendSmsForm;
  path: {
        companyId: string;
        projectId: string;
        alertId: string;
        contactId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/alerts/{alertId}/sms/{contactId}';
}

export interface PostSendContactSmsMonitoringResponses {
  /**
     * Success
     */
    200: SmsSentToProjectMember;
}

export interface PostSendSiteTalkdownMonitoringData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: {
        cameraIds?: Array<string>;
    };
  url: '/company/{companyId}/project/{projectId}/Monitoring/talkdown';
}

export interface PostSendSiteTalkdownMonitoringResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PostSetAlertOnHoldAlertMonitoringData {
  body?: AddAlertNoteDto;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/AlertMonitoring/{alertId}/hold';
}

export interface PostSetAlertOnHoldAlertMonitoringResponses {
  /**
     * Success
     */
    200: AlertHeldOpen;
}

export interface PostSetAlertSuppressionCandidatesMonitoringData {
  body?: SetSuppressionDto;
  path: {
        companyId: string;
        projectId: string;
        alertId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Monitoring/alerts/{alertId}/suppressions';
}

export interface PostSetAlertSuppressionCandidatesMonitoringResponses {
  /**
     * Success
     */
    200: CameraSuppressionsSet;
}

export interface PostSetAssetContractEndDateContractsData {
  body?: ContractAssetUpdateDto;
  path: {
        contractId: string;
        contractAssetId: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/contractasset/{contractAssetId}/update';
}

export interface PostSetAssetContractEndDateContractsResponses {
  /**
     * Success
     */
    200: ContractAssetUpdated;
}

export interface PostSetAssetInstalledContractsData {
  body?: never;
  path: {
        contractId: string;
        contractAssetId: string;
        date: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/contractasset/{contractAssetId}/installed/{date}';
}

export interface PostSetAssetInstalledContractsResponses {
  /**
     * Success
     */
    200: ContractAssetInstalled;
}

export interface PostSetAssetRemovedContractsData {
  body?: never;
  path: {
        contractId: string;
        contractAssetId: string;
        date: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/contractasset/{contractAssetId}/removed/{date}';
}

export interface PostSetAssetRemovedContractsResponses {
  /**
     * Success
     */
    200: ContractAssetUninstalled;
}

export interface PostSetAssetReturnedContractsData {
  body?: never;
  path: {
        contractId: string;
        contractAssetId: string;
        date: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/contractasset/{contractAssetId}/returned/{date}';
}

export interface PostSetAssetReturnedContractsResponses {
  /**
     * Success
     */
    200: ContractAssetUninstalled;
}

export interface PostSetCameraActivationZoneMonitoringData {
  body?: CameraZoneForm;
  path: {
        cameraId: string;
    };
  query?: never;
  url: '/Monitoring/camera/{cameraId}/zone';
}

export interface PostSetCameraActivationZoneMonitoringResponses {
  /**
     * Success
     */
    200: ActivationZoneSet;
}

export interface PostSetEventViewedAlertMonitoringData {
  body?: never;
  path: {
        alertId: string;
        eventId: string;
    };
  query?: never;
  url: '/AlertMonitoring/{alertId}/event/{eventId}/viewed';
}

export interface PostSetEventViewedAlertMonitoringResponses {
  /**
     * Success
     */
    200: EventViewedSet;
}

export interface PostSetLineItemAssetContractsData {
  body?: never;
  path: {
        contractId: string;
        lineItemId: string;
        assetId: string;
    };
  query?: never;
  url: '/customer/Contracts/{contractId}/line/{lineItemId}/setasset/{assetId}';
}

export interface PostSetLineItemAssetContractsResponses {
  /**
     * Success
     */
    200: ContractAssetInstalled;
}

export interface PostSetMaintainanceTaskAlertMonitoringData {
  body?: AlertMaintainanceTask;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/AlertMonitoring/{alertId}/maintainance';
}

export interface PostSetMaintainanceTaskAlertMonitoringResponses {
  /**
     * Success
     */
    200: AlertMaintainanceTaskAdded;
}

export interface PostSetPreferenceUserPreferencesData {
  body?: SetUserPreference;
  path?: never;
  query?: never;
  url: '/api/UserPreferences';
}

export interface PostSetPreferenceUserPreferencesResponses {
  /**
     * Success
     */
    200: UserPreferenceSet;
}

export interface PostSetProjectMonitoringCompanyCustomerData {
  body?: SetMonitoringCompanyForm;
  path: {
        customerId: string;
        projectId: string;
        monitoringCompanyId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}/monitoringcompany/{monitoringCompanyId}';
}

export interface PostSetProjectMonitoringCompanyCustomerResponses {
  /**
     * Success
     */
    200: ProjectMonitoringCompanySet;
}

export interface PostSetProjectNoThreatDispositionCustomerData {
  body?: SetNoThreatForm;
  path: {
        customerId: string;
        projectId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}/nothreat';
}

export interface PostSetProjectNoThreatDispositionCustomerResponses {
  /**
     * Success
     */
    200: NoThreatSet;
}

export interface PostSetRegionCalendarData {
  body?: never;
  path: {
        calendarId: string;
        region: string;
    };
  query?: never;
  url: '/Calendar/{calendarId}/region/{region}';
}

export interface PostSetRegionCalendarResponses {
  /**
     * Success
     */
    200: CalendarRegionSet;
}

export interface PostSetSettingAdminData {
  body?: {
        Value?: string;
    };
  path: {
        setting: string;
    };
  query?: never;
  url: '/Admin/settings/{setting}';
}

export interface PostSetSettingAdminResponses {
  /**
     * Success
     */
    200: SettingSet;
}

export interface PostSetVideoProcessorDebugModeRentalAssetsData {
  body?: never;
  path: {
        configId: string;
        assetId: string;
    };
  query?: never;
  url: '/RentalAssets/{assetId}/videoprocessor/{configId}/debug';
}

export interface PostSetVideoProcessorDebugModeRentalAssetsResponses {
  /**
     * Success
     */
    200: VideoProcessorConfigDebugSet;
}

export interface PostShiftStartAlertMonitoringData {
  body?: never;
  path?: never;
  query?: never;
  url: '/AlertMonitoring/shift';
}

export interface PostShiftStartAlertMonitoringResponses {
  /**
     * Success
     */
    200: ShiftCreated;
}

export interface PostStartTalkdownDeviceData {
  body?: never;
  path: {
        nvrId: string;
        deviceId: string;
    };
  query?: never;
  url: '/Integration/Device/{nvrId}/secondary/{deviceId}/talkdown';
}

export interface PostStartTalkdownDeviceResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PostSubmitTrainingEventAlertMonitoringData {
  body?: SubmitTrainingEvent;
  path?: never;
  query?: never;
  url: '/AlertMonitoring/training/event/submit';
}

export interface PostSubmitTrainingEventAlertMonitoringResponses {
  /**
     * Success
     */
    200: TrainingEventSubmitted;
}

export interface PostSyncAssetsXeroData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Xero/sync/assets';
}

export interface PostSyncAssetsXeroResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PostSyncCustomersXeroData {
  body?: never;
  path?: never;
  query?: never;
  url: '/Xero/sync/customers';
}

export interface PostSyncCustomersXeroResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PostTakeAlertAlertMonitoringData {
  body?: never;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/AlertMonitoring/{alertId}/take';
}

export interface PostTakeAlertAlertMonitoringResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PostTestExternalConnectionExternalConnectionData {
  body?: TestExternalConnection;
  path?: never;
  query?: never;
  url: '/Integration/ExternalConnection/test-connection';
}

export interface PostTestExternalConnectionExternalConnectionResponses {
  /**
     * Success
     */
    200: ExternalConnectionIndexed;
}

export interface PostTestHostReachabilityDeviceData {
  body?: TestHostReachabilityRequest;
  path?: never;
  query?: never;
  url: '/Integration/Device/test-reachability';
}

export interface PostTestHostReachabilityDeviceResponses {
  /**
     * Success
     */
    200: HostReachabilityTested;
}

export interface PostTogglePermissionUsersData {
  body?: never;
  path: {
        userId: string;
        role: Roles;
        toggle: boolean;
    };
  query?: never;
  url: '/Users/permission/{userId}/{role}/{toggle}';
}

export interface PostTogglePermissionUsersResponses {
  /**
     * Success
     */
    200: UserPermissionToggled;
}

export interface PostTokenLoginAuthData {
  body?: MonitoringLoginTokenForm;
  path?: never;
  query?: never;
  url: '/Auth/monitoring/tokenlogin';
}

export interface PostTokenLoginAuthResponses {
  /**
     * Success
     */
    200: AuthTokenUsed;
}

export interface PostTriggerRebuildPreaggAdminData {
  body?: PreaggRebuildRequestDto;
  path?: never;
  query?: never;
  url: '/pre-aggregations/rebuild';
}

export interface PostTriggerRebuildPreaggAdminResponses {
  /**
     * Success
     */
    200: PreaggRebuildResponseDto;
}

export interface PostTriggerRelayMonitoringData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        relayId: string;
    };
  query?: {
        turnOn?: boolean;
    };
  url: '/company/{companyId}/project/{projectId}/Monitoring/relays/{relayId}';
}

export interface PostTriggerRelayMonitoringResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PostUnAssignHardwareAssetData {
  body?: never;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
        hardwareId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/unassignHardware/{assetId}/{hardwareId}';
}

export interface PostUnAssignHardwareAssetResponses {
  /**
     * Success
     */
    200: AssetsSearched;
}

export interface PostUpdateAccountAccountingData {
  body?: AccountForm;
  path?: never;
  query?: never;
  url: '/Accounting/accounts/update';
}

export interface PostUpdateAccountAccountingResponses {
  /**
     * Success
     */
    200: AccountCrudded;
}

export interface PostUpdateAdminEventCalendarData {
  body?: CalendarEventDto;
  path: {
        calendarId: string;
    };
  query?: never;
  url: '/Calendar/{calendarId}/admin/updateEvent';
}

export interface PostUpdateAdminEventCalendarResponses {
  /**
     * Success
     */
    200: CalendarEventCrudded;
}

export interface PostUpdateAssetAssetData {
  body?: AssetForm;
  path: {
        companyId: string;
        projectId: string;
        assetId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Asset/{assetId}';
}

export interface PostUpdateAssetAssetResponses {
  /**
     * Success
     */
    200: AssetCrudded;
}

export interface PostUpdateAssetMonitoringGroupData {
  body?: AssetDto;
  path: {
        monitoringGroupId: string;
        assetId: string;
    };
  query?: never;
  url: '/MonitoringGroup/{monitoringGroupId}/assets/{assetId}/update';
}

export interface PostUpdateAssetMonitoringGroupResponses {
  /**
     * Success
     */
    200: AssetCrudded;
}

export interface PostUpdateCompanyMonitoringData {
  body?: MonitoringCompanyDto;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/Monitoring/companies/{companyId}';
}

export interface PostUpdateCompanyMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringCompanyCrudded;
}

export interface PostUpdateCompanyTenantMonitoringData {
  body?: TenantMonitoringCompanyDto;
  path: {
        tenantId: string;
        companyId: string;
    };
  query?: never;
  url: '/tenants/{tenantId}/TenantMonitoring/companies/{companyId}';
}

export interface PostUpdateCompanyTenantMonitoringResponses {
  /**
     * Success
     */
    200: TenantMonitoringCompanyCrudded;
}

export interface PostUpdateDashboardProjectData {
  body?: DashboardForm;
  path: {
        companyId: string;
        projectId: string;
        dashboardId: string;
    };
  query?: never;
  url: '/company/{companyId}/Project/{projectId}/dashboard/{dashboardId}';
}

export interface PostUpdateDashboardProjectResponses {
  /**
     * Success
     */
    200: WidgetsCrudded;
}

export interface PostUpdateEmailTemplateAdminData {
  body?: EmailTemplateDto;
  path?: never;
  query?: never;
  url: '/Admin/emails/templates/rentals/update';
}

export interface PostUpdateEmailTemplateAdminResponses {
  /**
     * Success
     */
    200: EmailTemplateRentalsCrudded;
}

export interface PostUpdateEventCalendarData {
  body?: CalendarEventDto;
  path: {
        calendarId: string;
    };
  query?: never;
  url: '/Calendar/{calendarId}/updateEvent';
}

export interface PostUpdateEventCalendarResponses {
  /**
     * Success
     */
    200: CalendarEventCrudded;
}

export interface PostUpdateExternalConnectionExternalConnectionData {
  body?: ExternalConnectionDto;
  path: {
        connectionId: string;
    };
  query?: never;
  url: '/Integration/ExternalConnection/{connectionId}';
}

export interface PostUpdateExternalConnectionExternalConnectionResponses {
  /**
     * Success
     */
    200: ExternalConnectionCrudded;
}

export interface PostUpdateGatewayGatewayData {
  body?: GatewayForm;
  path: {
        companyId: string;
        gatewayId: string;
    };
  query?: never;
  url: '/company/{companyId}/Gateway/{gatewayId}';
}

export interface PostUpdateGatewayGatewayResponses {
  /**
     * Success
     */
    200: GatewayCrudded;
}

export interface PostUpdateInformationAuthData {
  body?: UserInfoDto;
  path?: never;
  query?: never;
  url: '/Auth/account';
}

export interface PostUpdateInformationAuthResponses {
  /**
     * Success
     */
    200: UserInfoUpdated;
}

export interface PostUpdateIntegrationFieldsIntegrationData {
  body?: UpdateIntegrationFieldsForm;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/manage/{id}/fields';
}

export interface PostUpdateIntegrationFieldsIntegrationResponses {
  /**
     * Success
     */
    200: IntegrationFieldsUpdated;
}

export interface PostUpdateIntruderInfoAlertMonitoringData {
  body?: IntruderEventData;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/AlertMonitoring/{alertId}/intruder';
}

export interface PostUpdateIntruderInfoAlertMonitoringResponses {
  /**
     * Success
     */
    200: AlertIntruderInfoSet;
}

export interface PostUpdateIntruderInfoMonitoringData {
  body?: IntruderEventData;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/Monitoring/alerts/{alertId}/intruder';
}

export interface PostUpdateIntruderInfoMonitoringResponses {
  /**
     * Success
     */
    200: AlertIntruderInfoSet;
}

export interface PostUpdateMonitoringEmailTemplateAdminData {
  body?: EmailTemplateDto;
  path?: never;
  query?: never;
  url: '/Admin/emails/templates/monitoring/update';
}

export interface PostUpdateMonitoringEmailTemplateAdminResponses {
  /**
     * Success
     */
    200: EmailTemplateCrudded;
}

export interface PostUpdateMonitoringZoneMonitoringData {
  body?: ZoneForm;
  path: {
        projectId: string;
        zoneId: string;
    };
  query?: never;
  url: '/project/{projectId}/zone/{zoneId}';
}

export interface PostUpdateMonitoringZoneMonitoringResponses {
  /**
     * Success
     */
    200: MonitoringZoneCrudded;
}

export interface PostUpdateNvRecorderMonitoringData {
  body?: UpdateNvRecorder;
  path: {
        customerId: string;
    };
  query?: never;
  url: '/Monitoring/customers/{customerId}/nvrecorders/update';
}

export interface PostUpdateNvRecorderMonitoringResponses {
  /**
     * Success
     */
    200: NvRecorderCrudded;
}

export interface PostUpdateOrderOrderData {
  body?: SalesOrderDto;
  path: {
        id: string;
    };
  query?: never;
  url: '/Order/{id}';
}

export interface PostUpdateOrderOrderResponses {
  /**
     * Success
     */
    200: SalesOrderCrudded;
}

export interface PostUpdateProductProductsData {
  body?: ProductDto;
  path: {
        productId: string;
    };
  query?: never;
  url: '/Products/{productId}';
}

export interface PostUpdateProductProductsResponses {
  /**
     * Success
     */
    200: ProductCrudded;
}

export interface PostUpdateProjectContactCustomerData {
  body?: ProjectContactDto;
  path: {
        customerId: string;
        projectId: string;
        contactId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}/contact/{contactId}';
}

export interface PostUpdateProjectContactCustomerResponses {
  /**
     * Success
     */
    200: ProjectContactCrudded;
}

export interface PostUpdateProjectCustomerData {
  body?: ProjectUpdateForm;
  path: {
        customerId: string;
        projectId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}';
}

export interface PostUpdateProjectCustomerResponses {
  /**
     * Success
     */
    200: ProjectCrudded;
}

export interface PostUpdateProjectScheduleCustomerData {
  body?: ProjectScheduleDto;
  path: {
        customerId: string;
        projectId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/project/{projectId}/schedule';
}

export interface PostUpdateProjectScheduleCustomerResponses {
  /**
     * Success
     */
    200: ProjectScheduleSet;
}

export interface PostUpdateRegionalCalendarsCalendarData {
  body?: UpdateRegionalCalendarsForm;
  path?: never;
  query?: never;
  url: '/Calendar/updateRegionalCalendars';
}

export interface PostUpdateRegionalCalendarsCalendarResponses {
  /**
     * Success
     */
    200: RegionalCalendarsUpdated;
}

export interface PostUpdateRentalAssetRentalAssetsData {
  body?: UpdateRentalAssetDto;
  path: {
        assetId: string;
    };
  query?: never;
  url: '/RentalAssets/{assetId}';
}

export interface PostUpdateRentalAssetRentalAssetsResponses {
  /**
     * Success
     */
    200: RentalAssetUpdated;
}

export interface PostUpdateSalesOrderLineOrderData {
  body?: SalesOrderLineDto;
  path: {
        id: string;
        lineId: string;
    };
  query?: never;
  url: '/Order/{id}/line/{lineId}';
}

export interface PostUpdateSalesOrderLineOrderResponses {
  /**
     * Success
     */
    200: SalesOrderLineCrudded;
}

export interface PostUpdateSalesOrderLogOrderData {
  body?: SalesOrderLogDto;
  path: {
        id: string;
        logId: string;
    };
  query?: never;
  url: '/Order/{id}/log/{logId}';
}

export interface PostUpdateSalesOrderLogOrderResponses {
  /**
     * Success
     */
    200: SalesOrderLogCrudded;
}

export interface PostUpdateSecondaryDevicesDevice2Data {
  body?: SaveDeviceForm;
  path: {
        deviceId: string;
    };
  query?: never;
  url: '/Integration/Device/{deviceId}/save';
}

export interface PostUpdateSecondaryDevicesDevice2Responses {
  /**
     * Success
     */
    200: SecondaryDevicesMonitored;
}

export interface PostUpdateSecondaryDevicesDeviceData {
  body?: CrudUpdateSecondaryDevice;
  path: {
        deviceId: string;
    };
  query?: never;
  url: '/Integration/Device/{deviceId}/secondary';
}

export interface PostUpdateSecondaryDevicesDeviceResponses {
  /**
     * Success
     */
    200: CrudSecondaryDevicesUpdated;
}

export interface PostUpdateSmtpParserMonitoringData {
  body?: CrudSmtpParserDto;
  path: {
        smtpParserId: string;
    };
  query?: never;
  url: '/Monitoring/smtp/parsers/{smtpParserId}';
}

export interface PostUpdateSmtpParserMonitoringResponses {
  /**
     * Success
     */
    200: NvRecorderCrudded;
}

export interface PostUpdateStatusAlertingData {
  body?: AlertStatusDto;
  path: {
        alertId: string;
        status: string;
    };
  query?: never;
  url: '/Alerting/{alertId}/status/{status}';
}

export interface PostUpdateStatusAlertingResponses {
  /**
     * Success
     */
    200: AlertStatusSet;
}

export interface PostUpdateStatusMonitoringData {
  body?: AlertStatusDto;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/Monitoring/alerts/{alertId}/status';
}

export interface PostUpdateStatusMonitoringResponses {
  /**
     * Success
     */
    200: AlertStatusSet;
}

export interface PostUpdateTenantTenantData {
  body?: ExtendedTenantDto;
  path: {
        tenantId: string;
    };
  query?: never;
  url: '/Tenant/{tenantId}';
}

export interface PostUpdateTenantTenantResponses {
  /**
     * Success
     */
    200: TenantCrudded;
}

export interface PostUpdateTriggersIntegrationData {
  body?: UpdateTriggersForm;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/manage/{id}/triggers';
}

export interface PostUpdateTriggersIntegrationResponses {
  /**
     * Success
     */
    200: TriggersUpdated;
}

export interface PostUpdateUserUsersData {
  body?: UserInfoDto;
  path: {
        id: string;
    };
  query?: never;
  url: '/Users/{id}';
}

export interface PostUpdateUserUsersResponses {
  /**
     * Success
     */
    200: UserInfoUpdated;
}

export interface PostUpdateWorkflowHistoryAlertMonitoringData {
  body?: AlertDispositionWorkflowHistory;
  path: {
        alertId: string;
    };
  query?: never;
  url: '/AlertMonitoring/{alertId}/workflow-history';
}

export interface PostUpdateWorkflowHistoryAlertMonitoringResponses {
  /**
     * Success
     */
    200: DispositionWorkflowStepsSet;
}

export interface PostUploadEmailImageAdminData {
  body?: {
        File?: Blob | File;
    };
  path?: never;
  query?: never;
  url: '/Admin/emails/image/upload';
}

export interface PostUploadEmailImageAdminResponses {
  /**
     * Success
     */
    200: EmailImageUploaded;
}

export interface PostUploadLogoTenantData {
  body?: {
        File?: Blob | File;
    };
  path: {
        tenantId: string;
        logoType: LogoType;
    };
  query?: never;
  url: '/Tenant/{tenantId}/logo/{logoType}';
}

export interface PostUploadLogoTenantResponses {
  /**
     * Success
     */
    200: TenantThemeUpdated;
}

export interface PostVerifyUserAuthData {
  body?: VerifyUserForm;
  path?: never;
  query?: never;
  url: '/Auth/verify';
}

export interface PostVerifyUserAuthResponses {
  /**
     * Success
     */
    200: UserVerified;
}

export interface PreaggJobStatusItemDto {
  token?: string | null;
  table?: string | null;
  status?: string | null;
  timezone?: string | null;
}

export interface PreaggJobStatusRequestDto {
  tokens?: Array<string> | null;
}

export interface PreaggJobStatusResponseDto {
  jobs?: Array<PreaggJobStatusItemDto> | null;
}

export interface PreaggRebuildRequestDto {
  timezones?: Array<string> | null;
  cubes?: Array<string> | null;
  preAggregations?: Array<string> | null;
  dateRange?: Array<string> | null;
}

export interface PreaggRebuildResponseDto {
  tokens?: Array<string> | null;
  jobCount?: number;
}

export interface PrimaryDeviceCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  id?: string;
  primaryDevice?: NvrDto;
  subDevices?: Array<CameraDto> | null;
}

export interface ProductAddedToContract {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface ProductCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  product?: ProductDto;
}

export interface ProductDto {
  id?: string | null;
  name?: string | null;
  fixedPrice?: number | null;
  baseDailyPrice?: number | null;
  baseMonthlyPrice?: number | null;
  accountId?: string;
  isRecurring?: boolean;
  isAssetRental?: boolean;
}

export interface ProductRemovedFromContract {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface ProductSearchDto {
  id?: string;
  name?: string | null;
  baseDailyPrice?: number | null;
  baseMonthlyPrice?: number | null;
  accountId?: string;
  isRecurring?: boolean;
  fixedPrice?: number | null;
  isAssetRental?: boolean;
  productType?: EnumProductType;
}

export interface ProductsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ProductSearchDto> | null;
}

export interface ProjectAccessDto {
  id?: string;
  name?: string | null;
}

export interface ProjectAlertDto {
  id?: string;
  occurred?: string;
  status?: EnumAlertStatus;
  closedAt?: string | null;
}

export interface ProjectAlertingDisarmed {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  projectFull?: ProjectFullDto;
}

export interface ProjectAuditLogDto {
  occurred?: string;
  action?: EnumProjectAction;
  userId?: string;
  userName?: string | null;
  projectId?: string;
  projectName?: string | null;
  description?: string | null;
}

export interface ProjectAuditLogSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ProjectAuditLogDto> | null;
}

export interface ProjectContactCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface ProjectContactDto {
  id?: string | null;
  projectId?: string;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  order?: number;
  role?: string | null;
  contactPreference?: EnumContactPreference;
  companyId?: string;
  companyName?: string | null;
  lastName?: string | null;
  contactId?: string | null;
  contactCompany?: string | null;
}

export interface ProjectContactsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ProjectContactDto> | null;
}

export interface ProjectCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  project?: ProjectDto;
}

export interface ProjectDto {
  id?: string | null;
  companyId?: string;
  name?: string | null;
  onSightLogicGroupId?: string | null;
  archivedAt?: string | null;
  newMonitoringAlertsAfterSeconds?: number | null;
  dashboards?: Array<DashboardName> | null;
  sirenProfile?: EnumSirenProfile;
  armProfile?: EnumArmProfile;
  siteNotes?: string | null;
  guardResponseEnabled?: boolean | null;
  sirenCooldownSeconds?: number | null;
  sirensUnlinked?: boolean | null;
  complianceEnabled?: boolean | null;
  guardResponseDispatchCode?: string | null;
  sirenProfilePerson?: EnumSirenProfile;
  sirenProfileVehicle?: EnumSirenProfile;
  timeZone?: string | null;
  address?: AddressDto;
  aiPrimer?: string | null;
  noThreatAiPrimer?: string | null;
  detectionLabels?: Array<DetectionLabel> | null;
  objectDetectionSensitivity?: number | null;
  aiAutomationLevel?: EnumAiAutomationLevel;
  externalServiceOptions?: {
        [key: string]: {
            [key: string]: string;
        } | null;
    } | null;
  dispositionWorkflowConfig?: {
        [key: string]: Array<WorkflowConfig>;
    } | null;
  disabledDispositions?: Array<EnumAlertStatus> | null;
  defaultRouteNamespaceId?: string | null;
}

export interface ProjectFullDto {
  id?: string | null;
  tenantId?: string | null;
  name?: string | null;
  companyId?: string | null;
  companyName?: string | null;
  onSightLogicGroupId?: string | null;
  items?: Array<ProjectItemDto> | null;
  newMonitoringAlertsAfterSeconds?: number;
  disarmedUntil?: string | null;
  disarmedBy?: string | null;
  noThreatDisarmMinutes?: number | null;
  schedule?: ProjectScheduleDto;
  timeZone?: string | null;
  armedByCalendar?: EnumArmingEventType;
  sirenProfile?: EnumSirenProfile;
  armProfile?: EnumArmProfile;
  siteNotes?: string | null;
  guardResponseEnabled?: boolean;
  sirenCooldownSeconds?: number | null;
  sirensUnlinked?: boolean;
  complianceEnabled?: boolean;
  monitoringCompanies?: Array<ProjectMonitoringDto> | null;
  guardResponseDispatchCode?: string | null;
  sirenProfilePerson?: EnumSirenProfile;
  sirenProfileVehicle?: EnumSirenProfile;
  address?: AddressDto;
  nvRecorderIds?: Array<string> | null;
  aiPrimer?: string | null;
  noThreatAiPrimer?: string | null;
  aiAutomationLevel?: EnumAiAutomationLevel;
  userNotifications?: Array<UserNotificationDto> | null;
  detectionLabels?: Array<DetectionLabel> | null;
  objectDetectionSensitivity?: number | null;
  availableVideoProcessors?: Array<AssetVideoProcessorDto> | null;
  monitoringZones?: Array<MonitoringZoneDto> | null;
  externalServiceOptions?: {
        [key: string]: {
            [key: string]: string;
        } | null;
    } | null;
  dispositionWorkflowConfig?: {
        [key: string]: Array<WorkflowConfig>;
    } | null;
  disabledDispositions?: Array<EnumAlertStatus> | null;
  archivedAt?: string | null;
  defaultRouteNamespaceId?: string | null;
}

export interface ProjectInfoDto {
  id?: string;
  name?: string | null;
}

export interface ProjectInfoFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  project?: ProjectFullDto;
}

export interface ProjectItemDto {
  id?: string;
  onSightDeviceId?: string;
  type?: string | null;
  name?: string | null;
}

export interface ProjectMonitoringCompanySet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface ProjectMonitoringDto {
  monitoringCompanyName?: string | null;
  monitoringCompanyId?: string;
  externalId?: string | null;
  order?: number;
}

export interface ProjectScheduleDto {
  projectId?: string;
  blockSize?: number;
  blocks?: Array<BlockDto> | null;
}

export interface ProjectScheduleSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  project?: ProjectFullDto;
}

export interface ProjectSearchDto {
  id?: string;
  name?: string | null;
  companyId?: string;
  companyName?: string | null;
  isActive?: boolean;
  archivedAt?: string | null;
  timeZone?: string | null;
  armProfile?: EnumArmProfile;
  disarmedUntil?: string | null;
  sirenProfile?: EnumSirenProfile;
  aiAutomationLevel?: EnumAiAutomationLevel;
  secondaryDevicesCount?: number;
  address1?: string | null;
  defaultRouteNamespaceId?: string | null;
}

export interface ProjectSearchUserDto {
  id?: string;
  projectId?: string;
  projectName?: string | null;
  customerId?: string;
  customerName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  alertNotificationsEnabled?: boolean;
  externalId?: string | null;
  memberType?: EnumProjectMemberType;
}

export interface ProjectsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ProjectSearchDto> | null;
}

export interface ProjectUpdateForm {
  name?: string | null;
  newMonitoringAlertsAfterSeconds?: number | null;
  armProfile?: EnumArmProfile;
  sirenProfile?: EnumSirenProfile;
  sirenProfileVehicle?: EnumSirenProfile;
  sirenProfilePerson?: EnumSirenProfile;
  guardResponseEnabled?: boolean | null;
  siteNotes?: string | null;
  sirenCooldownSeconds?: number | null;
  sirensUnlinked?: boolean;
  complianceEnabled?: boolean;
  guardResponseDispatchCode?: string | null;
  timeZone?: string | null;
  address?: AddressDto;
  aiPrimer?: string | null;
  noThreatAiPrimer?: string | null;
  detectionLabels?: Array<DetectionLabel> | null;
  objectDetectionSensitivity?: number | null;
  aiAutomationLevel?: EnumAiAutomationLevel;
  externalServiceOptions?: {
        [key: string]: {
            [key: string]: string;
        } | null;
    } | null;
  dispositionWorkflowConfig?: {
        [key: string]: Array<WorkflowConfig>;
    } | null;
  disabledDispositions?: Array<EnumAlertStatus> | null;
  archivedAt?: string | null;
  defaultRouteNamespaceId?: string | null;
}

export interface ProjectUsersSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ProjectSearchUserDto> | null;
}

export interface PublicAssetInfoFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  asset?: AssetPublicDto;
}

export interface PublicAssetUserStatus {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  status?: AssetUserStatus;
  started?: string | null;
  endTime?: string | null;
}

export interface PublicAssociateAssetResult {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface PutAckShiftAlertMonitoringData {
  body?: never;
  path?: never;
  query?: never;
  url: '/AlertMonitoring/shift';
}

export interface PutAckShiftAlertMonitoringResponses {
  /**
     * Success
     */
    200: AckShift;
}

export interface PutActivateComponentRentalAssetsData {
  body?: never;
  path: {
        assetId: string;
        componentId: string;
    };
  query?: never;
  url: '/RentalAssets/components/{assetId}/{componentId}/activate';
}

export interface PutActivateComponentRentalAssetsResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PutAddApiTokenCompanyData {
  body?: ApiTokenForm;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/Company/{companyId}/apitoken';
}

export interface PutAddApiTokenCompanyResponses {
  /**
     * Success
     */
    200: CompanyCredentialsCrudded;
}

export interface PutCreateDashboardProjectData {
  body?: DashboardForm;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/Project/{projectId}/dashboard';
}

export interface PutCreateDashboardProjectResponses {
  /**
     * Success
     */
    200: WidgetsCrudded;
}

export interface PutCreateExternalConnectionExternalConnectionData {
  body?: ExternalConnectionDto;
  path?: never;
  query?: never;
  url: '/Integration/ExternalConnection';
}

export interface PutCreateExternalConnectionExternalConnectionResponses {
  /**
     * Success
     */
    200: ExternalConnectionCrudded;
}

export interface PutModifyNetworkProviderNetworkData {
  body?: NetworkProviderDto;
  path: {
        id: string;
    };
  query?: never;
  url: '/Network/{id}';
}

export interface PutModifyNetworkProviderNetworkResponses {
  /**
     * Success
     */
    200: NetworkProviderCrudded;
}

export interface PutModifySimCardNetworkData {
  body?: SimConfigDto;
  path: {
        id: string;
    };
  query?: never;
  url: '/Network/simcard/{id}';
}

export interface PutModifySimCardNetworkResponses {
  /**
     * Success
     */
    200: SimConfigCrudded;
}

export interface PutRetireHardwareData {
  body?: never;
  path: {
        companyId: string;
        id: string;
    };
  query?: never;
  url: '/company/{companyId}/Hardware/{id}/retire';
}

export interface PutRetireHardwareResponses {
  /**
     * Success
     */
    200: HardwareRetired;
}

export interface PutSetDeploymentEdgeLinkDeploymentData {
  body?: SetDeploymentRequest;
  path: {
        package: string;
    };
  query?: never;
  url: '/edgelinks/deployments/{package}';
}

export interface PutSetDeploymentEdgeLinkDeploymentResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PutToggleArchiveCustomerCustomerData {
  body?: boolean;
  path: {
        customerId: string;
    };
  query?: never;
  url: '/Customer/{customerId}/archive';
}

export interface PutToggleArchiveCustomerCustomerResponses {
  /**
     * Success
     */
    200: CustomerUpdated;
}

export interface PutUpdateAssetGroupCompanyData {
  body?: AssetGroupForm;
  path: {
        companyId: string;
        assetGroupId: string;
    };
  query?: never;
  url: '/Company/{companyId}/assetgroup/{assetGroupId}';
}

export interface PutUpdateAssetGroupCompanyResponses {
  /**
     * Success
     */
    200: AssetGroupCrudded;
}

export interface PutUpdateBeaconHardwareData {
  body?: UpdateBeaconForm;
  path: {
        companyId: string;
        beaconId: string;
    };
  query?: never;
  url: '/company/{companyId}/Hardware/beacon/{beaconId}';
}

export interface PutUpdateBeaconHardwareResponses {
  /**
     * Success
     */
    200: BeaconCrudded;
}

export interface PutUpdateCompanyInfoCompanyData {
  body?: UpdateCompanyForm;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/Company/{companyId}';
}

export interface PutUpdateCompanyInfoCompanyResponses {
  /**
     * Success
     */
    200: CompanyCrudded;
}

export interface PutUpdateContractContractsData {
  body?: ContractForm;
  path: {
        id: string;
    };
  query?: never;
  url: '/customer/Contracts/{id}';
}

export interface PutUpdateContractContractsResponses {
  /**
     * Success
     */
    200: ContractCrudded;
}

export interface PutUpdateCredentialsCompanyData {
  body?: CredentialsForm;
  path: {
        companyId: string;
    };
  query?: never;
  url: '/Company/{companyId}/credentials';
}

export interface PutUpdateCredentialsCompanyResponses {
  /**
     * Success
     */
    200: CompanyCredentialsCrudded;
}

export interface PutUpdateCustomerCustomerData {
  body?: CustomerUpdateDto;
  path: {
        customerId: string;
    };
  query?: never;
  url: '/Customer/{customerId}';
}

export interface PutUpdateCustomerCustomerResponses {
  /**
     * Success
     */
    200: CustomerUpdated;
}

export interface PutUpdateEdgeLinksData {
  body?: UpdateBridgeDto;
  path: {
        id: string;
    };
  query?: never;
  url: '/EdgeLinks/bridges/{id}';
}

export interface PutUpdateEdgeLinksResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PutUpdateIntegrationKeyIntegrationData {
  body?: UpdateKeyForm;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/manage/{id}/key';
}

export interface PutUpdateIntegrationKeyIntegrationResponses {
  /**
     * Success
     */
    200: IntegrationKeyUpdated;
}

export interface PutUpdateLicenceLicenceData {
  body?: LicenceForm;
  path: {
        companyId: string;
        projectId: string;
        licenceId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Licence/{licenceId}';
}

export interface PutUpdateLicenceLicenceResponses {
  /**
     * Success
     */
    200: LicenceCrudded;
}

export interface PutUpdateProjectNotificationProjectData {
  body?: NotificationSetting;
  path: {
        projectId: string;
        companyId: string;
    };
  query?: never;
  url: '/company/{companyId}/Project/{projectId}/notify';
}

export interface PutUpdateProjectNotificationProjectResponses {
  /**
     * Success
     */
    200: NotificationSettingSet;
}

export interface PutUpdateProjectProjectData {
  body?: UpdateProjectForm;
  path: {
        companyId: string;
        projectId: string;
    };
  query?: never;
  url: '/company/{companyId}/Project/{projectId}';
}

export interface PutUpdateProjectProjectResponses {
  /**
     * Success
     */
    200: CrudProject;
}

export interface PutUpdateProjectScheduleProjectData {
  body?: ProjectScheduleDto;
  path: {
        projectId: string;
        companyId: string;
    };
  query?: never;
  url: '/company/{companyId}/Project/{projectId}/schedule';
}

export interface PutUpdateProjectScheduleProjectResponses {
  /**
     * Success
     */
    200: CrudProject;
}

export interface PutUpdateRelayRelayData {
  body?: RelayDto;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/Relay/{id}';
}

export interface PutUpdateRelayRelayResponses {
  /**
     * Success
     */
    200: RelayCrudded;
}

export interface PutUpdateReportReportData {
  body?: ReportForm;
  path: {
        companyId: string;
        projectId: string;
        reportId: string;
    };
  query?: never;
  url: '/company/{companyId}/project/{projectId}/Report/{reportId}';
}

export interface PutUpdateReportReportResponses {
  /**
     * Success
     */
    200: ReportCrudded;
}

export interface PutUpdateRfidHardwareData {
  body?: UpdateRfidForm;
  path: {
        companyId: string;
        id: string;
    };
  query?: never;
  url: '/company/{companyId}/Hardware/rfid/{id}';
}

export interface PutUpdateRfidHardwareResponses {
  /**
     * Success
     */
    200: RfidCrudded;
}

export interface PutUpdateRouteEdgeLinksData {
  body?: UpdateRouteDto;
  path: {
        bridgeId: string;
        routeId: string;
    };
  query?: never;
  url: '/EdgeLinks/bridges/{bridgeId}/routes/{routeId}';
}

export interface PutUpdateRouteEdgeLinksResponses {
  /**
     * Success
     */
    200: unknown;
}

export interface PutUpdateSiteSiteData {
  body?: SiteForm;
  path: {
        companyId: string;
        siteId: string;
    };
  query?: never;
  url: '/company/{companyId}/Site/{siteId}';
}

export interface PutUpdateSiteSiteResponses {
  /**
     * Success
     */
    200: SiteCrudded;
}

export interface PutUpdateSpeakerSpeakerData {
  body?: SpeakerDto;
  path: {
        id: string;
    };
  query?: never;
  url: '/Integration/Speaker/{id}';
}

export interface PutUpdateSpeakerSpeakerResponses {
  /**
     * Success
     */
    200: SpeakerCrudded;
}

export interface PutUpdateVideoProcessorConfigRentalAssetsData {
  body?: VideoProcessorConfigDto;
  path: {
        assetId: string;
        configId: string;
    };
  query?: never;
  url: '/RentalAssets/{assetId}/videoprocessor/{configId}';
}

export interface PutUpdateVideoProcessorConfigRentalAssetsResponses {
  /**
     * Success
     */
    200: VideoProcessorConfigCrudded;
}

export interface PutUpdateZoneSiteData {
  body?: UpdateZoneForm;
  path: {
        companyId: string;
        siteId: string;
        zoneId: string;
    };
  query?: never;
  url: '/company/{companyId}/Site/{siteId}/zone/{zoneId}';
}

export interface PutUpdateZoneSiteResponses {
  /**
     * Success
     */
    200: ZoneCrudded;
}

export interface QueueState {
  readonly name?: string | null;
  readonly length?: number;
  readonly consumpionRate?: number;
  readonly creationRate?: number;
}

export interface QueueStates {
  queues?: Array<QueueState> | null;
}

export interface RegionalCalendarDto {
  region?: string | null;
  calendarId?: string;
}

export interface RegionalCalendarsUpdated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface RelayCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  relay?: RelayDto;
}

export interface RelayDto {
  id?: string;
  componentGroupId?: string;
  name?: string | null;
  relatedComponentGroups?: Array<string> | null;
  disabled?: boolean;
  nvrId?: string | null;
  integrationName?: string | null;
}

export interface Relocation {
  productId?: string | null;
  charge?: number | null;
  contractAssetId?: string;
  address?: AddressDto;
  description?: string | null;
  chargeQuantity?: number | null;
}

export interface RemoveItemForm {
  endDate?: string | null;
}

export interface RentalAssetApproved {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface RentalAssetComponentAuditLogsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ComponentAuditDto> | null;
}

export interface RentalAssetComponentCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  component?: ComponentDto;
}

export interface RentalAssetComponentsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ComponentDto> | null;
}

export interface RentalAssetCreated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  rentalAsset?: RentalAssetFullDto;
}

export interface RentalAssetFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  asset?: RentalAssetFullDto;
}

export interface RentalAssetFullDto {
  id?: string;
  customerId?: string | null;
  type?: string | null;
  name?: string | null;
  description?: string | null;
  assetId?: string | null;
  buildDate?: string | null;
  status?: EnumAssetStatus;
  xeroId?: string | null;
  dailyChargeRate?: number;
  monthlyChargeRate?: number;
  videoProcessor?: EnumVideoProcessor;
  videoProcessorId?: string | null;
  simConfigId?: string | null;
  mobileNumber?: string | null;
  networkName?: string | null;
  customerName?: string | null;
  videoConfigs?: Array<VideoProcessorConfigDto> | null;
  components?: Array<ComponentDto> | null;
  relays?: Array<RelayDto> | null;
  speakers?: Array<SpeakerDto> | null;
}

export interface RentalAssetSearchDto {
  id?: string;
  description?: string | null;
  isUnderContract?: boolean;
  contractEnd?: string | null;
  assetNumber?: string | null;
  isRentable?: boolean;
  status?: EnumAssetStatus;
  name?: string | null;
  type?: string | null;
  customerName?: string | null;
  currentAddress?: AddressDto;
  customerId?: string | null;
}

export interface RentalAssetsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<RentalAssetSearchDto> | null;
}

export interface RentalAssetTypesFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  types?: Array<AssetTypeDto> | null;
}

export interface RentalAssetUpdated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  asset?: RentalAssetFullDto;
}

export interface RentalEmailTemplatesFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  emailTemplates?: Array<EmailTemplateDto> | null;
}

export interface ReopenAlertDto {
  alertId?: string;
  reopeningAuthor?: string | null;
}

export interface ReportCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  report?: ReportDto;
}

export interface ReportDto {
  id?: string;
  projectId?: string;
  name?: string | null;
  type?: EnumReportType;
  attributes?: string | null;
}

export interface ReportForm {
  name?: string | null;
  attributes?: string | null;
  type?: EnumReportType;
}

export interface ReportSearchDto {
  id?: string;
  projectId?: string;
  companyId?: string;
  name?: string | null;
  type?: EnumReportType;
}

export interface ReportsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ReportSearchDto> | null;
}

export interface RequestorClaim {
  type?: string | null;
  value?: string | null;
}

export interface ResetForm {
  email?: string | null;
  source?: ResetSource;
}

export interface RfidCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  rfid?: RfidDto;
}

export interface RfidDto {
  id?: string;
  companyId?: string;
  tagId?: string | null;
  name?: string | null;
  projectId?: string;
  password?: string | null;
  type?: string | null;
  customField1?: string | null;
  onSightId?: string | null;
  retiredAt?: string | null;
}

export interface RfidForm {
  projectid?: string;
  tagId?: string | null;
  customField1?: string | null;
  password?: string | null;
  type?: string | null;
  onSightId?: string | null;
  name?: string | null;
}

export interface SalesOrderAccepted {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  contractId?: string;
}

export interface SalesOrderCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  salesOrder?: SalesOrderDto;
}

export interface SalesOrderDto {
  id?: string | null;
  customerId?: string;
  timeZone?: string | null;
  expectedStartDate?: string | null;
  expectedEndDate?: string | null;
  address?: AddressDto;
  name?: string | null;
  salesOrderId?: string | null;
  totalRecurring?: number | null;
  totalFixed?: number | null;
  customer?: string | null;
  contractId?: string | null;
}

export interface SalesOrderLineCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  salesOrder?: SalesOrderLineDto;
}

export interface SalesOrderLineDto {
  id?: string | null;
  createdAt?: string;
  salesOrderId?: string;
  productId?: string;
  product?: string | null;
  quantity?: number;
  startDate?: string | null;
  endDate?: string | null;
  dailyCost?: number | null;
  monthlyCost?: number | null;
  fixedCost?: number | null;
  damageWaiverPct?: number | null;
  installationCharge?: number | null;
  description?: string | null;
  isRecurring?: boolean;
  isAssetRental?: boolean;
}

export interface SalesOrderLinesSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<SalesOrderLineDto> | null;
}

export interface SalesOrderLogCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  log?: SalesOrderLogDto;
}

export interface SalesOrderLogDto {
  id?: string;
  salesOrderId?: string;
  note?: string | null;
  filePath?: string | null;
  created?: string;
}

export interface SalesOrderLogsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<SalesOrderLogDto> | null;
}

export interface SalesOrderSearchDto {
  id?: string;
  createdAt?: string;
  createdBy?: string | null;
  name?: string | null;
  salesOrderId?: string | null;
  expectedStartDate?: string | null;
  expectedEndDate?: string | null;
  hasContract?: boolean;
  itemCount?: number;
  customer?: string | null;
  createdById?: string;
  customerId?: string;
}

export interface SalesOrdersSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<SalesOrderSearchDto> | null;
}

export interface SalesPersonAssetDto {
  plannedEndDate?: string;
  assetType?: string | null;
  contractId?: string;
  monthlyRevenue?: number;
}

export interface SalesPersonBillingItem {
  id?: string;
  total?: number | null;
  salesPeopleCount?: number;
  contractId?: string | null;
  contractName?: string | null;
  number?: string | null;
}

export interface SalesPersonCommissionReportData {
  id?: string;
  invoiced?: Array<AssetTypeBillingItem> | null;
  credited?: Array<AssetTypeBillingItem> | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

export interface SalesPersonCommissionReportGenerated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  report?: Array<SalesPersonCommissionReportData> | null;
}

export interface SalesPersonContractDto {
  id?: string;
  name?: string | null;
  customer?: string | null;
}

export interface SalesPersonCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  salesPerson?: SalesPersonDto;
}

export interface SalesPersonDashboardFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  assets?: Array<SalesPersonAssetDto> | null;
  newContracts?: Array<SalesPersonContractDto> | null;
}

export interface SalesPersonDto {
  userId?: string;
  contractId?: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  removedAt?: string | null;
  projectId?: string | null;
}

export interface SalesPersonReportData {
  id?: string;
  invoices?: Array<SalesPersonBillingItem> | null;
  creditNotes?: Array<SalesPersonBillingItem> | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

export interface SalesPersonReportGenerated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  report?: Array<SalesPersonReportData> | null;
}

export interface SaveCodeForm {
  code?: string | null;
  recompile?: boolean;
}

export interface SaveDeviceForm {
  nvr?: NvrDto;
  connectionSettings?: {
        [key: string]: unknown;
    } | null;
  monitoredDevices?: Array<UpdateSecondaryDeviceRequest> | null;
  integrationId?: string;
  customerId?: string;
  address?: AddressDto;
  routeNamespaceId?: string | null;
  deviceCreationChoices?: {
        [key: string]: string | null;
    } | null;
}

export interface SearchIncidentsResponse {
  readonly incidents?: Array<Incident> | null;
  totalCount?: number;
}

export interface SecondaryDeviceFullDto {
  id?: string;
  model?: string | null;
  name?: string | null;
  vendor?: string | null;
  videoProcessorId?: UniqueVideoProcessorId;
  externalId?: string | null;
  capabilities?: Capabilities;
  relays?: Array<RelayDto> | null;
  speakers?: Array<SpeakerDto> | null;
  monitored?: boolean;
  quillNotes?: string | null;
  description?: string | null;
  activationWkt?: string | null;
  datalayerVpc?: string;
  integrationType?: IntegrationType;
}

export interface SecondaryDevicesFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  secondaryDevices?: Array<SecondaryDeviceFullDto> | null;
}

export interface SecondaryDevicesMonitored {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface SendSmsForm {
  sentBy?: string | null;
}

export interface SensorData {
  type?: EnumSensorType;
  gatewayId?: string | null;
  values?: Array<SensorDataValue> | null;
}

export interface SensorDataValue {
  type?: EnumValueType;
  value?: number;
}

export interface SetDeploymentRequest {
  version: string;
}

export interface SetMonitoringCompanyForm {
  externalId?: string | null;
  order?: number | null;
}

export interface SetNoThreatForm {
  disarmTime?: number;
}

export interface SetSuppressionDto {
  suppressions?: Array<SuppressionDto> | null;
}

export interface SettingDto {
  setting?: string | null;
  value?: string | null;
  name?: string | null;
  description?: string | null;
}

export interface SettingSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface SettingsFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  settings?: Array<SettingDto> | null;
}

export interface SetUserPreference {
  requestor?: MessageRequestor;
  receivedAt?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
  key?: string | null;
  value?: string | null;
}

export interface ShiftCreated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  shift?: ShiftDto;
}

export interface ShiftDto {
  shiftId?: string;
  start?: string;
  end?: string | null;
  lastSeen?: string;
  monitoringCompanyId?: string;
}

export interface ShiftEnded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  shift?: ShiftDto;
}

export interface ShiftSearchDto {
  shiftId?: string;
  start?: string;
  end?: string | null;
  lastSeen?: string;
  monitoringCompanyId?: string;
  monitoringOfficerId?: string;
  monitoringOfficerName?: string | null;
  monitoringCompanyName?: string | null;
}

export interface ShiftsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ShiftSearchDto> | null;
}

export interface SimConfigCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  simConfig?: SimConfigDto;
}

export interface SimConfigDto {
  id?: string | null;
  number?: string | null;
  countryCode?: string | null;
  retiredAt?: string | null;
  networkProviderId?: string;
}

export interface SimConfigSearchDto {
  id?: string;
  number?: string | null;
  countryCode?: string | null;
  retiredAt?: string | null;
  networkProviderId?: string;
  networkProviderName?: string | null;
  rentalAssetId?: string | null;
  rentalAssetName?: string | null;
}

export interface SimConfigsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<SimConfigSearchDto> | null;
}

export interface SiteCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  site?: SiteDto;
}

export interface SiteDto {
  id?: string | null;
  companyId?: string;
  name?: string | null;
  description?: string | null;
}

export interface SiteForm {
  name?: string | null;
  description?: string | null;
}

export interface SiteMinDto {
  id?: string;
  companyId?: string;
  name?: string | null;
  description?: string | null;
}

export interface SiteSecondaryDevice {
  secondaryDevice?: SecondaryDeviceFullDto;
  nvrId?: string;
  nvrName?: string | null;
}

export interface SiteSecondaryDevicesFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  devices?: Array<SiteSecondaryDevice> | null;
}

export interface SitesSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<SiteMinDto> | null;
}

export interface SmsSentToProjectMember {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface SmtpParserSearchDto {
  id?: string | null;
  name?: string | null;
  datePrefix?: string | null;
  dateRegex?: string | null;
  dateFormat?: string | null;
  channelPrefix?: string | null;
  channelRegex?: string | null;
  eventTypePrefix?: string | null;
  eventTypeRegex?: string | null;
  eventParsingRules?: Array<MonitoringEventParserDto> | null;
}

export interface SmtpParsersSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<SmtpParserSearchDto> | null;
}

export interface SmtpParsingRuleDto {
  id?: string;
  name?: string | null;
  datePrefix?: string | null;
  dateRegex?: string | null;
  dateFormat?: string | null;
  channelPrefix?: string | null;
  channelRegex?: string | null;
  eventTypePrefix?: string | null;
  eventTypeRegex?: string | null;
  eventParsingRules?: Array<MonitoringEventParsingRuleDto> | null;
}

export interface SmtpRtspDto {
  url?: string | null;
  timeZone?: string | null;
  timeFormat?: string | null;
}

export interface SpeakerCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  speaker?: SpeakerDto;
}

export interface SpeakerDto {
  id?: string;
  componentGroupId?: string;
  name?: string | null;
  relatedComponentGroups?: Array<string> | null;
  disabled?: boolean;
  nvrId?: string | null;
  integrationName?: string | null;
}

export interface Step {
  stepNumber?: number;
  hasNote?: boolean;
  hasCheckbox?: boolean;
  title?: string | null;
  instructions?: string | null;
}

export interface Steps {
  stepIndex?: number;
  completedAt?: string | null;
  note?: string | null;
  actioned?: boolean;
}

export interface SubmitTrainingEvent {
  requestor?: MessageRequestor;
  receivedAt?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
  trainingEventId?: string;
  values?: Array<TrainingEventValueDto> | null;
}

export interface SupportedTimeZone {
  name?: string | null;
  offsetHours?: number;
  readonly displayName?: string | null;
}

export interface SuppressionCandidate {
  cameraName?: string | null;
  wkt?: string | null;
  videoProcessorId?: string;
  snapshotId?: string;
  incidences?: number;
  hasSuppression?: boolean;
  cameraId?: string | null;
}

export interface SuppressionDto {
  videoProcessorId?: string;
  wkt?: string | null;
}

export interface TenantCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  tenant?: TenantDto;
}

export interface TenantDetails {
  tenantId?: string;
  tenantName?: string | null;
  themePath?: string | null;
  themeVersion?: number | null;
  roles?: Array<string> | null;
}

export interface TenantDto {
  id?: string | null;
  name?: string | null;
  themePath?: string | null;
  urlBase?: string | null;
  themeVersion?: number;
  ingressEnabled?: boolean;
}

export interface TenantInfo {
  id?: string;
  name?: string | null;
  themeFilePath?: string | null;
  readonly themeVersion?: number;
}

export interface TenantInfoFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  id?: string;
  name?: string | null;
  xeroShortCode?: string | null;
  billingEnabled?: boolean;
  billingFailed?: boolean;
  mapCenter?: string | null;
  devicePasswordManagementEnabled?: boolean;
  themeFilePath?: string | null;
  themeVersion?: number;
}

export interface TenantLogos {
  name?: string | null;
  primary?: string | null;
  mini?: string | null;
  reversed?: string | null;
  miniReversed?: string | null;
}

export interface TenantLogosFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  tenantLogos?: Array<TenantLogos> | null;
}

export interface TenantMonitoringCompaniesSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<TenantMonitoringCompanySearchDto> | null;
}

export interface TenantMonitoringCompanyCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  monitoringCompany?: TenantMonitoringCompanyDto;
}

export interface TenantMonitoringCompanyDto {
  id?: string | null;
  primaryEmail?: string | null;
  name?: string | null;
  deletedAt?: string | null;
  userId?: string;
  tenantId?: string;
  isDefault?: boolean;
  defaultOrder?: number | null;
  ownedById?: string | null;
  ownedBy?: string | null;
}

export interface TenantMonitoringCompanySearchDto {
  id?: string;
  name?: string | null;
  domain?: string | null;
  deletedAt?: string | null;
  primaryEmail?: string | null;
  userId?: string;
  isDefault?: boolean;
  defaultOrder?: number | null;
  ownedById?: string | null;
  ownedBy?: string | null;
}

export interface TenantResolvedFromUrl {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  tenantId?: string | null;
  tenantName?: string | null;
  themePath?: string | null;
  themeVersion?: number;
}

export interface TenantSearchDto {
  id?: string;
  name?: string | null;
}

export interface TenantsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<TenantSearchDto> | null;
}

export interface TenantThemeUpdated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  tenant?: TenantDto;
  themeFilePath?: string | null;
}

export interface TenantUserCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface TestExternalConnection {
  requestor?: MessageRequestor;
  receivedAt?: string | null;
  readonly userId?: string | null;
  readonly tenantId?: string | null;
  integrationId?: string;
  integrationFields?: {
        [key: string]: unknown;
    } | null;
}

export interface TestHostReachabilityRequest {
  uri?: string | null;
  routeNamespaceId?: string | null;
  timeoutSeconds?: number | null;
}

export interface TimeRange {
  start?: TimeSpan;
  end?: TimeSpan;
}

export interface TimeSpan {
  ticks?: number;
  readonly days?: number;
  readonly hours?: number;
  readonly milliseconds?: number;
  readonly microseconds?: number;
  readonly nanoseconds?: number;
  readonly minutes?: number;
  readonly seconds?: number;
  readonly totalDays?: number;
  readonly totalHours?: number;
  readonly totalMilliseconds?: number;
  readonly totalMicroseconds?: number;
  readonly totalNanoseconds?: number;
  readonly totalMinutes?: number;
  readonly totalSeconds?: number;
}

export interface TimeZoneInfo {
  readonly id?: string | null;
  readonly hasIanaId?: boolean;
  readonly displayName?: string | null;
  readonly standardName?: string | null;
  readonly daylightName?: string | null;
  baseUtcOffset?: TimeSpan;
  readonly supportsDaylightSavingTime?: boolean;
}

export interface TimeZonesResponse {
  timeZones?: Array<SupportedTimeZone> | null;
}

export interface TokenResetForm {
  token?: string | null;
  password?: string | null;
  userId?: string;
}

export interface TrainingEventFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  trainingEventId?: string;
  monitoringEventId?: string;
  snapshotId?: string | null;
  values?: Array<TrainingEventValueDto> | null;
  snapshot?: string | null;
}

export interface TrainingEventSkipped {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface TrainingEventSubmitted {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface TrainingEventValueDto {
  monitoringEventValueId?: string | null;
  type?: MonitoringEventValueType;
  txtValue?: string | null;
  probability?: number | null;
  approved?: boolean | null;
}

export interface TrainingMetricDto {
  id?: string;
  name?: string | null;
  trainingsComplete?: number;
}

export interface TrainingMetricsFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  metrics?: Array<TrainingMetricDto> | null;
}

export interface TriggersUpdated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface UniqueVideoProcessorId {
  value?: string | null;
  deviceId?: string | null;
}

export interface UpdateBeaconForm {
  customField1?: string | null;
  password?: string | null;
  type?: string | null;
  name?: string | null;
}

export interface UpdateBridgeDto {
  name?: string | null;
  userConfig?: string | null;
}

export interface UpdateCompanyForm {
  name?: string | null;
  supportEmail?: string | null;
  supportPhone?: string | null;
}

export interface UpdateIntegrationFieldsForm {
  integrationFields?: Array<PartialIntegrationFieldDto> | null;
}

export interface UpdateKeyForm {
  key?: string | null;
}

export interface UpdateNvRecorder {
  nvRecorder?: NvRecorderDto;
  voidToken?: boolean;
}

export interface UpdateProjectForm {
  name?: string | null;
  armProfile?: EnumArmProfile;
  defaultRouteNamespaceId?: string | null;
}

export interface UpdateRegionalCalendarsForm {
  calendars?: Array<CalendarDto> | null;
}

export interface UpdateRentalAssetDto {
  id?: string;
  name?: string | null;
  serialNumber?: string | null;
  description?: string | null;
  customerId?: string | null;
  assetType?: string | null;
  simConfigId?: string | null;
}

export interface UpdateRfidForm {
  customField1?: string | null;
  password?: string | null;
  type?: string | null;
  name?: string | null;
}

export interface UpdateRouteDto {
  namespaceId?: string;
  edgeAddressRangeCidr?: string | null;
  mappedAddressRange?: string | null;
}

export interface UpdateSecondaryDeviceRequest {
  id?: string;
  capabilities?: Capabilities;
  capabilitiesOverride?: Capabilities;
  monitored?: boolean;
  quillNotes?: string | null;
  description?: string | null;
}

export interface UpdateTriggersForm {
  webhook?: boolean | null;
  smtp?: boolean | null;
  watchfulLifecycle?: boolean | null;
}

export interface UpdateZoneForm {
  name?: string | null;
  description?: string | null;
  wkt?: string | null;
}

export interface UserCruded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  user?: UserDto;
}

export interface UserDto {
  id?: string | null;
  userName?: string | null;
  email?: string | null;
  roles?: Array<string> | null;
  firstName?: string | null;
  lastName?: string | null;
  lockedOut?: boolean;
}

export interface UserInfoDto {
  firstName: string;
  lastName: string;
  number?: string | null;
  userId?: string;
  smsAuthorized?: boolean | null;
}

export interface UserInfoUpdated {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface UserNotificationCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  notification?: NotificationDto;
}

export interface UserNotificationDto {
  setting?: string | null;
  email?: boolean | null;
  push?: boolean | null;
  sms?: boolean | null;
}

export interface UserNotificationsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<NotificationDto> | null;
}

export interface UserPermissionToggled {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface UserPreferenceDto {
  userId?: string | null;
  key?: string | null;
  value?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface UserPreferenceFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  preference?: UserPreferenceDto;
}

export interface UserPreferenceSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  preference?: UserPreferenceDto;
}

export interface UserSearchDto {
  id?: string;
  firstName?: string | null;
  companies?: Array<CompanySearchDto> | null;
  lastName?: string | null;
  email?: string | null;
  roles?: Array<string> | null;
}

export interface UsersSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<UserSearchDto> | null;
}

export interface UserTenantsFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  tenants?: Array<TenantDto> | null;
}

export interface UserVerified {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface ValidationResultDto {
  group?: string | null;
  validation?: string | null;
  status?: ValidationStatus;
  finding?: string | null;
  expected?: string | null;
}

export interface VerifyUserForm {
  userId?: string;
  token?: string | null;
}

export interface VideoFeedHealthFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  recentlyOffline?: Array<VideoHealthDto> | null;
}

export interface VideoHealthDto {
  cameraId?: string | null;
  processor?: EnumVideoProcessor;
  assetId?: string;
  assetName?: string | null;
  projectId?: string;
  projectName?: string | null;
  customerId?: string;
  customerName?: string | null;
  lastOffline?: string | null;
  status?: EnumCameraStatus;
  lastEvent?: LatestEvent;
  lastSnapshot?: LatestSnapshotValue;
}

export interface VideoProcessorConfigCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  rentalAsset?: RentalAssetFullDto;
}

export interface VideoProcessorConfigDebugSet {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface VideoProcessorConfigDto {
  id?: string | null;
  videoProcessor?: EnumVideoProcessor;
  videoProcessorId?: string | null;
  userName?: string | null;
  password?: string | null;
  description?: string | null;
  externalId?: string | null;
  smtpParserId?: string | null;
  smtpParserName?: string | null;
  smtpRtsp?: SmtpRtspDto;
  debugUntil?: string | null;
  nvRecorder?: NvRecorderSearchDto;
  device?: NvrDeviceSearchDto;
  nvrDeviceName?: string | null;
}

export interface WebhookAuthCredDto {
  username?: string | null;
  password?: string | null;
  token?: string | null;
  receiverUrl?: string | null;
}

export interface WeeklySchedule {
  days?: Array<DaySchedule> | null;
}

export interface WidgetDto {
  dashboardId?: string | null;
  companyId?: string;
  projectId?: string;
  widgetData?: string | null;
  name?: string | null;
}

export interface WidgetMinDto {
  id?: string;
  name?: string | null;
  projectId?: string;
  userId?: string | null;
  companyId?: string;
}

export interface WidgetsCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  widgetDto?: WidgetDto;
}

export interface WidgetsSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<WidgetMinDto> | null;
}

export interface WorkflowConfig {
  name?: string | null;
  steps?: Array<Step> | null;
  schedule?: WeeklySchedule;
  isDefault?: boolean;
}

export interface XeroAccount {
  code?: string | null;
  xeroId?: string | null;
  tenantId?: string;
  description?: string | null;
  name?: string | null;
  status?: StatusEnum;
  type?: AccountType;
}

export interface XeroAccountsBound {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
}

export interface XeroConnected {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  xeroShortCode?: string | null;
  xeroAccounts?: Array<XeroAccount> | null;
  dbAccounts?: Array<AccountBindingDto> | null;
  xeroToken?: string | null;
  xeroTokenExpires?: string | null;
  xeroTenantId?: string | null;
  xeroTenantShortCode?: string | null;
  billingEnabled?: boolean;
}

export interface XeroConnectForm {
  scope?: string | null;
  code?: string | null;
}

export interface XeroLoginFetched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  loginUrl?: string | null;
}

export interface ZoneCrudded {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  zone?: ZoneDto;
}

export interface ZoneDto {
  siteId?: string;
  id?: string | null;
  companyId?: string;
  name?: string | null;
  wkt?: string | null;
  description?: string | null;
  onSightId?: string | null;
  deletedAt?: string | null;
}

export interface ZoneForm {
  id?: string | null;
  description?: string | null;
  videoProcessorIds?: Array<string> | null;
  schedule?: ProjectScheduleDto;
}

export interface ZoneMinDto {
  id?: string;
  siteId?: string;
  companyId?: string;
  name?: string | null;
  deleted?: boolean;
}

export interface ZoneSeenDto {
  start?: string;
  end?: string;
  zoneId?: string | null;
  name?: string | null;
  siteId?: string | null;
  siteName?: string | null;
}

export interface ZonesSearched {
  success?: boolean;
  message?: string | null;
  code?: MessageResponseCode;
  errors?: Array<string> | null;
  totalRows?: number;
  rows?: Array<ZoneMinDto> | null;
}

export type DeleteClearIntegrationKvStoreIntegrationResponse = DeleteClearIntegrationKvStoreIntegrationResponses[keyof DeleteClearIntegrationKvStoreIntegrationResponses];

export type DeleteClearIntegrationPollsIntegrationResponse = DeleteClearIntegrationPollsIntegrationResponses[keyof DeleteClearIntegrationPollsIntegrationResponses];

export type DeleteDeleteAdminEventCalendarResponse = DeleteDeleteAdminEventCalendarResponses[keyof DeleteDeleteAdminEventCalendarResponses];

export type DeleteDeleteAssetAssetResponse = DeleteDeleteAssetAssetResponses[keyof DeleteDeleteAssetAssetResponses];

export type DeleteDeleteContractContractsResponse = DeleteDeleteContractContractsResponses[keyof DeleteDeleteContractContractsResponses];

export type DeleteDeleteDashboardProjectResponse = DeleteDeleteDashboardProjectResponses[keyof DeleteDeleteDashboardProjectResponses];

export type DeleteDeleteEventCalendarResponse = DeleteDeleteEventCalendarResponses[keyof DeleteDeleteEventCalendarResponses];

export type DeleteDeleteExternalConnectionExternalConnectionResponse = DeleteDeleteExternalConnectionExternalConnectionResponses[keyof DeleteDeleteExternalConnectionExternalConnectionResponses];

export type DeleteDeleteGatewayGatewayResponse = DeleteDeleteGatewayGatewayResponses[keyof DeleteDeleteGatewayGatewayResponses];

export type DeleteDeleteIntegrationIntegrationResponse = DeleteDeleteIntegrationIntegrationResponses[keyof DeleteDeleteIntegrationIntegrationResponses];

export type DeleteDeleteLicenceLicenceResponse = DeleteDeleteLicenceLicenceResponses[keyof DeleteDeleteLicenceLicenceResponses];

export type DeleteDeleteMonitoringZoneMonitoringResponse = DeleteDeleteMonitoringZoneMonitoringResponses[keyof DeleteDeleteMonitoringZoneMonitoringResponses];

export type DeleteDeleteRegionCalendarResponse = DeleteDeleteRegionCalendarResponses[keyof DeleteDeleteRegionCalendarResponses];

export type DeleteDeleteRelayRelayResponse = DeleteDeleteRelayRelayResponses[keyof DeleteDeleteRelayRelayResponses];

export type DeleteDeleteReportReportResponse = DeleteDeleteReportReportResponses[keyof DeleteDeleteReportReportResponses];

export type DeleteDeleteSalesOrderLineOrderResponse = DeleteDeleteSalesOrderLineOrderResponses[keyof DeleteDeleteSalesOrderLineOrderResponses];

export type DeleteDeleteSalesOrderLogOrderResponse = DeleteDeleteSalesOrderLogOrderResponses[keyof DeleteDeleteSalesOrderLogOrderResponses];

export type DeleteDeleteSiteSiteResponse = DeleteDeleteSiteSiteResponses[keyof DeleteDeleteSiteSiteResponses];

export type DeleteDeleteSmtpParserMonitoringResponse = DeleteDeleteSmtpParserMonitoringResponses[keyof DeleteDeleteSmtpParserMonitoringResponses];

export type DeleteDeleteSpeakerSpeakerResponse = DeleteDeleteSpeakerSpeakerResponses[keyof DeleteDeleteSpeakerSpeakerResponses];

export type DeleteDeleteUserCompanyResponse = DeleteDeleteUserCompanyResponses[keyof DeleteDeleteUserCompanyResponses];

export type DeleteDeleteUserUsersResponse = DeleteDeleteUserUsersResponses[keyof DeleteDeleteUserUsersResponses];

export type DeleteDeleteZoneSiteResponse = DeleteDeleteZoneSiteResponses[keyof DeleteDeleteZoneSiteResponses];

export type DeleteModifySimCardNetworkResponse = DeleteModifySimCardNetworkResponses[keyof DeleteModifySimCardNetworkResponses];

export type DeleteRemoveAssetFromContractContractsResponse = DeleteRemoveAssetFromContractContractsResponses[keyof DeleteRemoveAssetFromContractContractsResponses];

export type DeleteRemoveComponentRentalAssetsResponse = DeleteRemoveComponentRentalAssetsResponses[keyof DeleteRemoveComponentRentalAssetsResponses];

export type DeleteRemoveItemContractsResponse = DeleteRemoveItemContractsResponses[keyof DeleteRemoveItemContractsResponses];

export type DeleteRemoveLicenceGrantAssetResponse = DeleteRemoveLicenceGrantAssetResponses[keyof DeleteRemoveLicenceGrantAssetResponses];

export type DeleteRemoveLicenceRequirementAssetResponse = DeleteRemoveLicenceRequirementAssetResponses[keyof DeleteRemoveLicenceRequirementAssetResponses];

export type DeleteRemoveMonitoringOfficerMonitoringResponse = DeleteRemoveMonitoringOfficerMonitoringResponses[keyof DeleteRemoveMonitoringOfficerMonitoringResponses];

export type DeleteRemoveOrderOrderResponse = DeleteRemoveOrderOrderResponses[keyof DeleteRemoveOrderOrderResponses];

export type DeleteRemoveProjectContactCustomerResponse = DeleteRemoveProjectContactCustomerResponses[keyof DeleteRemoveProjectContactCustomerResponses];

export type DeleteRemoveProjectMemberCustomerResponse = DeleteRemoveProjectMemberCustomerResponses[keyof DeleteRemoveProjectMemberCustomerResponses];

export type DeleteRemoveProjectMonitoringCompanyCustomerResponse = DeleteRemoveProjectMonitoringCompanyCustomerResponses[keyof DeleteRemoveProjectMonitoringCompanyCustomerResponses];

export type DeleteRemoveSalesPersonContractsResponse = DeleteRemoveSalesPersonContractsResponses[keyof DeleteRemoveSalesPersonContractsResponses];

export type DeleteRemoveSystemMonitorTenantResponse = DeleteRemoveSystemMonitorTenantResponses[keyof DeleteRemoveSystemMonitorTenantResponses];

export type DeleteRemoveUserTenantResponse = DeleteRemoveUserTenantResponses[keyof DeleteRemoveUserTenantResponses];

export type DeleteRemoveVideoProcessorConfigRentalAssetsResponse = DeleteRemoveVideoProcessorConfigRentalAssetsResponses[keyof DeleteRemoveVideoProcessorConfigRentalAssetsResponses];

export type DeleteSkipTrainingEventAlertMonitoringResponse = DeleteSkipTrainingEventAlertMonitoringResponses[keyof DeleteSkipTrainingEventAlertMonitoringResponses];

export type GetAlertFullAlertMonitoringResponse = GetAlertFullAlertMonitoringResponses[keyof GetAlertFullAlertMonitoringResponses];

export type GetAnnotateSnapshotAlertMonitoringResponse = GetAnnotateSnapshotAlertMonitoringResponses[keyof GetAnnotateSnapshotAlertMonitoringResponses];

export type GetAssetUtilisationReportResponse = GetAssetUtilisationReportResponses[keyof GetAssetUtilisationReportResponses];

export type GetBillingSearchAccountingResponse = GetBillingSearchAccountingResponses[keyof GetBillingSearchAccountingResponses];

export type GetByDayComplianceResponse = GetByDayComplianceResponses[keyof GetByDayComplianceResponses];

export type GetByHourComplianceResponse = GetByHourComplianceResponses[keyof GetByHourComplianceResponses];

export type GetComplianceEventsSearchComplianceResponse = GetComplianceEventsSearchComplianceResponses[keyof GetComplianceEventsSearchComplianceResponses];

export type GetCurrentShiftAlertMonitoringResponse = GetCurrentShiftAlertMonitoringResponses[keyof GetCurrentShiftAlertMonitoringResponses];

export type GetDashboardAlertMonitoringResponse = GetDashboardAlertMonitoringResponses[keyof GetDashboardAlertMonitoringResponses];

export type GetDashboardV2AlertMonitoringResponse = GetDashboardV2AlertMonitoringResponses[keyof GetDashboardV2AlertMonitoringResponses];

export type GetDetermineTenantPublicResponse = GetDetermineTenantPublicResponses[keyof GetDetermineTenantPublicResponses];

export type GetEnableMonitoringCustomerResponse = GetEnableMonitoringCustomerResponses[keyof GetEnableMonitoringCustomerResponses];

export type GetFetchActiveAssetLocationsRentalAssetsResponse = GetFetchActiveAssetLocationsRentalAssetsResponses[keyof GetFetchActiveAssetLocationsRentalAssetsResponses];

export type GetFetchAdminEventsCalendarResponse = GetFetchAdminEventsCalendarResponses[keyof GetFetchAdminEventsCalendarResponses];

export type GetFetchAdminRegionsCalendarResponse = GetFetchAdminRegionsCalendarResponses[keyof GetFetchAdminRegionsCalendarResponses];

export type GetFetchAlertFullMonitoringLimitedResponse = GetFetchAlertFullMonitoringLimitedResponses[keyof GetFetchAlertFullMonitoringLimitedResponses];

export type GetFetchAlertFullMonitoringResponse = GetFetchAlertFullMonitoringResponses[keyof GetFetchAlertFullMonitoringResponses];

export type GetFetchAlertMonitoringResponse = GetFetchAlertMonitoringResponses[keyof GetFetchAlertMonitoringResponses];

export type GetFetchAlertsMonitoringResponse = GetFetchAlertsMonitoringResponses[keyof GetFetchAlertsMonitoringResponses];

export type GetFetchAlertSuppressionCandidatesMonitoringResponse = GetFetchAlertSuppressionCandidatesMonitoringResponses[keyof GetFetchAlertSuppressionCandidatesMonitoringResponses];

export type GetFetchArmStatusCustomerResponse = GetFetchArmStatusCustomerResponses[keyof GetFetchArmStatusCustomerResponses];

export type GetFetchArmStatusProjectResponse = GetFetchArmStatusProjectResponses[keyof GetFetchArmStatusProjectResponses];

export type GetFetchAssetAssetResponse = GetFetchAssetAssetResponses[keyof GetFetchAssetAssetResponses];

export type GetFetchAssetDataAssetResponse = GetFetchAssetDataAssetResponses[keyof GetFetchAssetDataAssetResponses];

export type GetFetchAssetFullAssetResponse = GetFetchAssetFullAssetResponses[keyof GetFetchAssetFullAssetResponses];

export type GetFetchAssetSensorsProjectResponse = GetFetchAssetSensorsProjectResponses[keyof GetFetchAssetSensorsProjectResponses];

export type GetFetchAvailableHardwareProjectResponse = GetFetchAvailableHardwareProjectResponses[keyof GetFetchAvailableHardwareProjectResponses];

export type GetFetchAvailableZonesSiteResponse = GetFetchAvailableZonesSiteResponses[keyof GetFetchAvailableZonesSiteResponses];

export type GetFetchBeaconHardwareResponse = GetFetchBeaconHardwareResponses[keyof GetFetchBeaconHardwareResponses];

export type GetFetchCalendarIdCalendarResponse = GetFetchCalendarIdCalendarResponses[keyof GetFetchCalendarIdCalendarResponses];

export type GetFetchCameraFeedUrlMonitoringResponse = GetFetchCameraFeedUrlMonitoringResponses[keyof GetFetchCameraFeedUrlMonitoringResponses];

export type GetFetchCameraHealthMonitoringResponse = GetFetchCameraHealthMonitoringResponses[keyof GetFetchCameraHealthMonitoringResponses];

export type GetFetchCameraSnapshotMonitoringResponse = GetFetchCameraSnapshotMonitoringResponses[keyof GetFetchCameraSnapshotMonitoringResponses];

export type GetFetchCompanyInfoCompanyResponse = GetFetchCompanyInfoCompanyResponses[keyof GetFetchCompanyInfoCompanyResponses];

export type GetFetchCompanyMonitoringResponse = GetFetchCompanyMonitoringResponses[keyof GetFetchCompanyMonitoringResponses];

export type GetFetchCompanyTenantMonitoringResponse = GetFetchCompanyTenantMonitoringResponses[keyof GetFetchCompanyTenantMonitoringResponses];

export type GetFetchContractContractsResponse = GetFetchContractContractsResponses[keyof GetFetchContractContractsResponses];

export type GetFetchCredentialsCompanyResponse = GetFetchCredentialsCompanyResponses[keyof GetFetchCredentialsCompanyResponses];

export type GetFetchDashboardProjectResponse = GetFetchDashboardProjectResponses[keyof GetFetchDashboardProjectResponses];

export type GetFetchDetailedContractContractsResponse = GetFetchDetailedContractContractsResponses[keyof GetFetchDetailedContractContractsResponses];

export type GetFetchDeviceDeviceResponse = GetFetchDeviceDeviceResponses[keyof GetFetchDeviceDeviceResponses];

export type GetFetchDeviceSnapshotDeviceResponse = GetFetchDeviceSnapshotDeviceResponses[keyof GetFetchDeviceSnapshotDeviceResponses];

export type GetFetchEmailTemplatesAdminResponse = GetFetchEmailTemplatesAdminResponses[keyof GetFetchEmailTemplatesAdminResponses];

export type GetFetchEventsCalendarResponse = GetFetchEventsCalendarResponses[keyof GetFetchEventsCalendarResponses];

export type GetFetchGatewayGatewayResponse = GetFetchGatewayGatewayResponses[keyof GetFetchGatewayGatewayResponses];

export type GetFetchHardwareAssociatedAssetHardwareResponse = GetFetchHardwareAssociatedAssetHardwareResponses[keyof GetFetchHardwareAssociatedAssetHardwareResponses];

export type GetFetchIntegrationLibraryIntegrationResponse = GetFetchIntegrationLibraryIntegrationResponses[keyof GetFetchIntegrationLibraryIntegrationResponses];

export type GetFetchLicenceLicenceResponse = GetFetchLicenceLicenceResponses[keyof GetFetchLicenceLicenceResponses];

export type GetFetchMonitoringEmailTemplatesAdminResponse = GetFetchMonitoringEmailTemplatesAdminResponses[keyof GetFetchMonitoringEmailTemplatesAdminResponses];

export type GetFetchMonitoringZoneMonitoringResponse = GetFetchMonitoringZoneMonitoringResponses[keyof GetFetchMonitoringZoneMonitoringResponses];

export type GetFetchOrderOrderResponse = GetFetchOrderOrderResponses[keyof GetFetchOrderOrderResponses];

export type GetFetchOverviewMonitoringResponse = GetFetchOverviewMonitoringResponses[keyof GetFetchOverviewMonitoringResponses];

export type GetFetchProjectInfoProjectResponse = GetFetchProjectInfoProjectResponses[keyof GetFetchProjectInfoProjectResponses];

export type GetFetchRegionsCalendarResponse = GetFetchRegionsCalendarResponses[keyof GetFetchRegionsCalendarResponses];

export type GetFetchRelayRelayResponse = GetFetchRelayRelayResponses[keyof GetFetchRelayRelayResponses];

export type GetFetchRentalAssetRentalAssetsResponse = GetFetchRentalAssetRentalAssetsResponses[keyof GetFetchRentalAssetRentalAssetsResponses];

export type GetFetchReportReportResponse = GetFetchReportReportResponses[keyof GetFetchReportReportResponses];

export type GetFetchReportResponse = GetFetchReportResponses[keyof GetFetchReportResponses];

export type GetFetchRfidHardwareResponse = GetFetchRfidHardwareResponses[keyof GetFetchRfidHardwareResponses];

export type GetFetchSiteSecondaryDevicesMonitoringResponse = GetFetchSiteSecondaryDevicesMonitoringResponses[keyof GetFetchSiteSecondaryDevicesMonitoringResponses];

export type GetFetchSiteSiteResponse = GetFetchSiteSiteResponses[keyof GetFetchSiteSiteResponses];

export type GetFetchSmtpParserMonitoringResponse = GetFetchSmtpParserMonitoringResponses[keyof GetFetchSmtpParserMonitoringResponses];

export type GetFetchSpeakerSpeakerResponse = GetFetchSpeakerSpeakerResponses[keyof GetFetchSpeakerSpeakerResponses];

export type GetFetchTenantLogosAdminResponse = GetFetchTenantLogosAdminResponses[keyof GetFetchTenantLogosAdminResponses];

export type GetFetchTenantTenantResponse = GetFetchTenantTenantResponses[keyof GetFetchTenantTenantResponses];

export type GetFetchTrainingEventAlertMonitoringResponse = GetFetchTrainingEventAlertMonitoringResponses[keyof GetFetchTrainingEventAlertMonitoringResponses];

export type GetFetchTrainingMetricsAlertMonitoringResponse = GetFetchTrainingMetricsAlertMonitoringResponses[keyof GetFetchTrainingMetricsAlertMonitoringResponses];

export type GetFetchXeroLoginUrlXeroResponse = GetFetchXeroLoginUrlXeroResponses[keyof GetFetchXeroLoginUrlXeroResponses];

export type GetFetchZoneSiteResponse = GetFetchZoneSiteResponses[keyof GetFetchZoneSiteResponses];

export type GetFindContactAlertMonitoringResponse = GetFindContactAlertMonitoringResponses[keyof GetFindContactAlertMonitoringResponses];

export type GetGenerateAssetActivityReportReportResponse = GetGenerateAssetActivityReportReportResponses[keyof GetGenerateAssetActivityReportReportResponses];

export type GetGetAlertingConfigurationDeviceResponse = GetGetAlertingConfigurationDeviceResponses[keyof GetGetAlertingConfigurationDeviceResponses];

export type GetGetAlertingSetupTypesDeviceResponse = GetGetAlertingSetupTypesDeviceResponses[keyof GetGetAlertingSetupTypesDeviceResponses];

export type GetGetAlertNotesByQuillPredictionAlertReportingResponse = GetGetAlertNotesByQuillPredictionAlertReportingResponses[keyof GetGetAlertNotesByQuillPredictionAlertReportingResponses];

export type GetGetAssetSensorsAssetResponse = GetGetAssetSensorsAssetResponses[keyof GetGetAssetSensorsAssetResponses];

export type GetGetCompanyMetricsCompanyResponse = GetGetCompanyMetricsCompanyResponses[keyof GetGetCompanyMetricsCompanyResponses];

export type GetGetConnectedAssetsEdgeLinksResponse = GetGetConnectedAssetsEdgeLinksResponses[keyof GetGetConnectedAssetsEdgeLinksResponses];

export type GetGetConnectedDevicesExternalConnectionResponse = GetGetConnectedDevicesExternalConnectionResponses[keyof GetGetConnectedDevicesExternalConnectionResponses];

export type GetGetConnectionOptionsExternalConnectionResponse = GetGetConnectionOptionsExternalConnectionResponses[keyof GetGetConnectionOptionsExternalConnectionResponses];

export type GetGetCreditNoteAccountingResponse = GetGetCreditNoteAccountingResponses[keyof GetGetCreditNoteAccountingResponses];

export type GetGetCustomerCustomerResponse = GetGetCustomerCustomerResponses[keyof GetGetCustomerCustomerResponses];

export type GetGetDailyAlertReportAlertReportingResponse = GetGetDailyAlertReportAlertReportingResponses[keyof GetGetDailyAlertReportAlertReportingResponses];

export type GetGetDailyEventReportEventReportingResponse = GetGetDailyEventReportEventReportingResponses[keyof GetGetDailyEventReportEventReportingResponses];

export type GetGetDevicesDeviceResponse = GetGetDevicesDeviceResponses[keyof GetGetDevicesDeviceResponses];

export type GetGetDimensionValuesMetricsResponse = GetGetDimensionValuesMetricsResponses[keyof GetGetDimensionValuesMetricsResponses];

export type GetGetEventValueImgUrlComplianceResponse = GetGetEventValueImgUrlComplianceResponses[keyof GetGetEventValueImgUrlComplianceResponses];

export type GetGetExternalConnectionExternalConnectionResponse = GetGetExternalConnectionExternalConnectionResponses[keyof GetGetExternalConnectionExternalConnectionResponses];

export type GetGetExternalConnectionsExternalConnectionResponse = GetGetExternalConnectionsExternalConnectionResponses[keyof GetGetExternalConnectionsExternalConnectionResponses];

export type GetGetIntegrationIntegrationResponse = GetGetIntegrationIntegrationResponses[keyof GetGetIntegrationIntegrationResponses];

export type GetGetIntegrationsIntegrationResponse = GetGetIntegrationsIntegrationResponses[keyof GetGetIntegrationsIntegrationResponses];

export type GetGetInvoiceAccountingResponse = GetGetInvoiceAccountingResponses[keyof GetGetInvoiceAccountingResponses];

export type GetGetMonitoringEventsMonitoringResponse = GetGetMonitoringEventsMonitoringResponses[keyof GetGetMonitoringEventsMonitoringResponses];

export type GetGetMonitoringEventsRentalAssetsResponse = GetGetMonitoringEventsRentalAssetsResponses[keyof GetGetMonitoringEventsRentalAssetsResponses];

export type GetGetMonitoringEventValueImgMonitoringResponse = GetGetMonitoringEventValueImgMonitoringResponses[keyof GetGetMonitoringEventValueImgMonitoringResponses];

export type GetGetMonitoringEventValueImgUrlMonitoringResponse = GetGetMonitoringEventValueImgUrlMonitoringResponses[keyof GetGetMonitoringEventValueImgUrlMonitoringResponses];

export type GetGetMonitoringEventValueUrlComplianceResponse = GetGetMonitoringEventValueUrlComplianceResponses[keyof GetGetMonitoringEventValueUrlComplianceResponses];

export type GetGetMonitoringEventValueUrlMonitoringResponse = GetGetMonitoringEventValueUrlMonitoringResponses[keyof GetGetMonitoringEventValueUrlMonitoringResponses];

export type GetGetMonitoringLoginsAlertingResponse = GetGetMonitoringLoginsAlertingResponses[keyof GetGetMonitoringLoginsAlertingResponses];

export type GetGetMonthlyEventsByCameraEventReportingResponse = GetGetMonthlyEventsByCameraEventReportingResponses[keyof GetGetMonthlyEventsByCameraEventReportingResponses];

export type GetGetMonthlyEventsBySiteEventReportingResponse = GetGetMonthlyEventsBySiteEventReportingResponses[keyof GetGetMonthlyEventsBySiteEventReportingResponses];

export type GetGetNvRecorderMonitoringResponse = GetGetNvRecorderMonitoringResponses[keyof GetGetNvRecorderMonitoringResponses];

export type GetGetPreferenceUserPreferencesResponse = GetGetPreferenceUserPreferencesResponses[keyof GetGetPreferenceUserPreferencesResponses];

export type GetGetProductProductsResponse = GetGetProductProductsResponses[keyof GetGetProductProductsResponses];

export type GetGetQueueLengthsAdminResponse = GetGetQueueLengthsAdminResponses[keyof GetGetQueueLengthsAdminResponses];

export type GetGetRecentAlertDataMonitoringResponse = GetGetRecentAlertDataMonitoringResponses[keyof GetGetRecentAlertDataMonitoringResponses];

export type GetGetSalesPersonDashboardSalesPersonResponse = GetGetSalesPersonDashboardSalesPersonResponses[keyof GetGetSalesPersonDashboardSalesPersonResponses];

export type GetGetSecondaryDevicesDeviceResponse = GetGetSecondaryDevicesDeviceResponses[keyof GetGetSecondaryDevicesDeviceResponses];

export type GetGetSettingsAdminResponse = GetGetSettingsAdminResponses[keyof GetGetSettingsAdminResponses];

export type GetGetSmtpWebhooksRentalAssetsResponse = GetGetSmtpWebhooksRentalAssetsResponses[keyof GetGetSmtpWebhooksRentalAssetsResponses];

export type GetGetTenantAdminResponse = GetGetTenantAdminResponses[keyof GetGetTenantAdminResponses];

export type GetGetTimeZonesAccountingResponse = GetGetTimeZonesAccountingResponses[keyof GetGetTimeZonesAccountingResponses];

export type GetGetUsersAuthResponse = GetGetUsersAuthResponses[keyof GetGetUsersAuthResponses];

export type GetLastSeenAssetResponse = GetLastSeenAssetResponses[keyof GetLastSeenAssetResponses];

export type GetLastSeenInRangeAssetResponse = GetLastSeenInRangeAssetResponses[keyof GetLastSeenInRangeAssetResponses];

export type GetLastSeenTakexAssetResponse = GetLastSeenTakexAssetResponses[keyof GetLastSeenTakexAssetResponses];

export type GetLineSearchOrderResponse = GetLineSearchOrderResponses[keyof GetLineSearchOrderResponses];

export type GetLogSearchOrderResponse = GetLogSearchOrderResponses[keyof GetLogSearchOrderResponses];

export type GetMissedCallsAlertMonitoringResponse = GetMissedCallsAlertMonitoringResponses[keyof GetMissedCallsAlertMonitoringResponses];

export type GetMonitoringSearchAssetResponse = GetMonitoringSearchAssetResponses[keyof GetMonitoringSearchAssetResponses];

export type GetNetworkProviderNetworkResponse = GetNetworkProviderNetworkResponses[keyof GetNetworkProviderNetworkResponses];

export type GetOpenAlertsAlerting2Response = GetOpenAlertsAlerting2Responses[keyof GetOpenAlertsAlerting2Responses];

export type GetOpenAlertsAlertingResponse = GetOpenAlertsAlertingResponses[keyof GetOpenAlertsAlertingResponses];

export type GetProfileAuthResponse = GetProfileAuthResponses[keyof GetProfileAuthResponses];

export type GetProjectCustomerResponse = GetProjectCustomerResponses[keyof GetProjectCustomerResponses];

export type GetPublicFetchAssetInfoPublicResponse = GetPublicFetchAssetInfoPublicResponses[keyof GetPublicFetchAssetInfoPublicResponses];

export type GetPublicFetchUserAssetInfoPublicResponse = GetPublicFetchUserAssetInfoPublicResponses[keyof GetPublicFetchUserAssetInfoPublicResponses];

export type GetQueryMetricMetricsResponse = GetQueryMetricMetricsResponses[keyof GetQueryMetricMetricsResponses];

export type GetReRunInvoicingAccountingResponse = GetReRunInvoicingAccountingResponses[keyof GetReRunInvoicingAccountingResponses];

export type GetSalesCommissionReportReportResponse = GetSalesCommissionReportReportResponses[keyof GetSalesCommissionReportReportResponses];

export type GetSalesReportReportResponse = GetSalesReportReportResponses[keyof GetSalesReportReportResponses];

export type GetSearchAccountsAccountingResponse = GetSearchAccountsAccountingResponses[keyof GetSearchAccountsAccountingResponses];

export type GetSearchAlertEventsAlertMonitoringResponse = GetSearchAlertEventsAlertMonitoringResponses[keyof GetSearchAlertEventsAlertMonitoringResponses];

export type GetSearchAlertMonitoringResponse = GetSearchAlertMonitoringResponses[keyof GetSearchAlertMonitoringResponses];

export type GetSearchAlertsMonitoringLimitedResponse = GetSearchAlertsMonitoringLimitedResponses[keyof GetSearchAlertsMonitoringLimitedResponses];

export type GetSearchAlertsMonitoringResponse = GetSearchAlertsMonitoringResponses[keyof GetSearchAlertsMonitoringResponses];

export type GetSearchAssetHardwareLogAssetResponse = GetSearchAssetHardwareLogAssetResponses[keyof GetSearchAssetHardwareLogAssetResponses];

export type GetSearchAssetNotificationsNotificationsResponse = GetSearchAssetNotificationsNotificationsResponses[keyof GetSearchAssetNotificationsNotificationsResponses];

export type GetSearchAssetsAssetResponse = GetSearchAssetsAssetResponses[keyof GetSearchAssetsAssetResponses];

export type GetSearchAssetsCustomerResponse = GetSearchAssetsCustomerResponses[keyof GetSearchAssetsCustomerResponses];

export type GetSearchAssetsV2CustomerResponse = GetSearchAssetsV2CustomerResponses[keyof GetSearchAssetsV2CustomerResponses];

export type GetSearchAuditLogsAdminResponse = GetSearchAuditLogsAdminResponses[keyof GetSearchAuditLogsAdminResponses];

export type GetSearchBillingCycleContractsAccountingResponse = GetSearchBillingCycleContractsAccountingResponses[keyof GetSearchBillingCycleContractsAccountingResponses];

export type GetSearchBillingCycleEndedContractsAccountingResponse = GetSearchBillingCycleEndedContractsAccountingResponses[keyof GetSearchBillingCycleEndedContractsAccountingResponses];

export type GetSearchBillingCycleNewContractsAccountingResponse = GetSearchBillingCycleNewContractsAccountingResponses[keyof GetSearchBillingCycleNewContractsAccountingResponses];

export type GetSearchBillingCyclesAccountingResponse = GetSearchBillingCyclesAccountingResponses[keyof GetSearchBillingCyclesAccountingResponses];

export type GetSearchCompaniesMonitoringResponse = GetSearchCompaniesMonitoringResponses[keyof GetSearchCompaniesMonitoringResponses];

export type GetSearchComplianceEventsComplianceResponse = GetSearchComplianceEventsComplianceResponses[keyof GetSearchComplianceEventsComplianceResponses];

export type GetSearchComponentAuditsRentalAssetsResponse = GetSearchComponentAuditsRentalAssetsResponses[keyof GetSearchComponentAuditsRentalAssetsResponses];

export type GetSearchComponentsRentalAssetsResponse = GetSearchComponentsRentalAssetsResponses[keyof GetSearchComponentsRentalAssetsResponses];

export type GetSearchContactsCustomerResponse = GetSearchContactsCustomerResponses[keyof GetSearchContactsCustomerResponses];

export type GetSearchContractAssetsContractsResponse = GetSearchContractAssetsContractsResponses[keyof GetSearchContractAssetsContractsResponses];

export type GetSearchContractLogsContractsResponse = GetSearchContractLogsContractsResponses[keyof GetSearchContractLogsContractsResponses];

export type GetSearchContractProductsContractsResponse = GetSearchContractProductsContractsResponses[keyof GetSearchContractProductsContractsResponses];

export type GetSearchContractSalesPeopleContractsResponse = GetSearchContractSalesPeopleContractsResponses[keyof GetSearchContractSalesPeopleContractsResponses];

export type GetSearchContractsContractsResponse = GetSearchContractsContractsResponses[keyof GetSearchContractsContractsResponses];

export type GetSearchCreditNotesAccountingResponse = GetSearchCreditNotesAccountingResponses[keyof GetSearchCreditNotesAccountingResponses];

export type GetSearchCustomersCustomerResponse = GetSearchCustomersCustomerResponses[keyof GetSearchCustomersCustomerResponses];

export type GetSearchCustomersProductsResponse = GetSearchCustomersProductsResponses[keyof GetSearchCustomersProductsResponses];

export type GetSearchDashboardsProjectResponse = GetSearchDashboardsProjectResponses[keyof GetSearchDashboardsProjectResponses];

export type GetSearchGatewayResponse = GetSearchGatewayResponses[keyof GetSearchGatewayResponses];

export type GetSearchHardwareResponse = GetSearchHardwareResponses[keyof GetSearchHardwareResponses];

export type GetSearchInactiveTenantCamerasTenantResponse = GetSearchInactiveTenantCamerasTenantResponses[keyof GetSearchInactiveTenantCamerasTenantResponses];

export type GetSearchIncidentsIncidentReportingResponse = GetSearchIncidentsIncidentReportingResponses[keyof GetSearchIncidentsIncidentReportingResponses];

export type GetSearchInvoicesAccountingResponse = GetSearchInvoicesAccountingResponses[keyof GetSearchInvoicesAccountingResponses];

export type GetSearchMonitoringOfficerShiftsMonitoringResponse = GetSearchMonitoringOfficerShiftsMonitoringResponses[keyof GetSearchMonitoringOfficerShiftsMonitoringResponses];

export type GetSearchNetworkProvidersNetworkResponse = GetSearchNetworkProvidersNetworkResponses[keyof GetSearchNetworkProvidersNetworkResponses];

export type GetSearchNvrDevicesMonitoringResponse = GetSearchNvrDevicesMonitoringResponses[keyof GetSearchNvrDevicesMonitoringResponses];

export type GetSearchOrderResponse = GetSearchOrderResponses[keyof GetSearchOrderResponses];

export type GetSearchProjectAuditLogMonitoringResponse = GetSearchProjectAuditLogMonitoringResponses[keyof GetSearchProjectAuditLogMonitoringResponses];

export type GetSearchProjectContactsCustomerResponse = GetSearchProjectContactsCustomerResponses[keyof GetSearchProjectContactsCustomerResponses];

export type GetSearchProjectContactsProjectResponse = GetSearchProjectContactsProjectResponses[keyof GetSearchProjectContactsProjectResponses];

export type GetSearchProjectMemberCustomerResponse = GetSearchProjectMemberCustomerResponses[keyof GetSearchProjectMemberCustomerResponses];

export type GetSearchProjectsCustomerResponse = GetSearchProjectsCustomerResponses[keyof GetSearchProjectsCustomerResponses];

export type GetSearchProjectsMonitoringResponse = GetSearchProjectsMonitoringResponses[keyof GetSearchProjectsMonitoringResponses];

export type GetSearchRentalAssetsRentalAssetsResponse = GetSearchRentalAssetsRentalAssetsResponses[keyof GetSearchRentalAssetsRentalAssetsResponses];

export type GetSearchReportsReportResponse = GetSearchReportsReportResponses[keyof GetSearchReportsReportResponses];

export type GetSearchSimCardNetworkResponse = GetSearchSimCardNetworkResponses[keyof GetSearchSimCardNetworkResponses];

export type GetSearchSitesInstallerResponse = GetSearchSitesInstallerResponses[keyof GetSearchSitesInstallerResponses];

export type GetSearchTenantAvailableMonitorsTenantResponse = GetSearchTenantAvailableMonitorsTenantResponses[keyof GetSearchTenantAvailableMonitorsTenantResponses];

export type GetSearchTenantsFailedWebhooksTenantResponse = GetSearchTenantsFailedWebhooksTenantResponses[keyof GetSearchTenantsFailedWebhooksTenantResponses];

export type GetSearchTenantsTenantMonitoringResponse = GetSearchTenantsTenantMonitoringResponses[keyof GetSearchTenantsTenantMonitoringResponses];

export type GetSearchTenantsTenantResponse = GetSearchTenantsTenantResponses[keyof GetSearchTenantsTenantResponses];

export type GetSearchTenantsUsersTenantResponse = GetSearchTenantsUsersTenantResponses[keyof GetSearchTenantsUsersTenantResponses];

export type GetSearchUsersUsersResponse = GetSearchUsersUsersResponses[keyof GetSearchUsersUsersResponses];

export type GetSearchv2AlertMonitoringResponse = GetSearchv2AlertMonitoringResponses[keyof GetSearchv2AlertMonitoringResponses];

export type GetSearchWebhooksMonitoringResponse = GetSearchWebhooksMonitoringResponses[keyof GetSearchWebhooksMonitoringResponses];

export type GetShiftInformationAlertMonitoringResponse = GetShiftInformationAlertMonitoringResponses[keyof GetShiftInformationAlertMonitoringResponses];

export type GetSimCardNetworkResponse = GetSimCardNetworkResponses[keyof GetSimCardNetworkResponses];

export type GetTenantAuthResponse = GetTenantAuthResponses[keyof GetTenantAuthResponses];

export type GetValidateConfigurationDeviceResponse = GetValidateConfigurationDeviceResponses[keyof GetValidateConfigurationDeviceResponses];

export type PatchEndShiftV2AlertMonitoringResponse = PatchEndShiftV2AlertMonitoringResponses[keyof PatchEndShiftV2AlertMonitoringResponses];

export type PostAcknowledgeMissedCallsAlertMonitoringResponse = PostAcknowledgeMissedCallsAlertMonitoringResponses[keyof PostAcknowledgeMissedCallsAlertMonitoringResponses];

export type PostAddAccountAccountingResponse = PostAddAccountAccountingResponses[keyof PostAddAccountAccountingResponses];

export type PostAddAssetToContractContractsResponse = PostAddAssetToContractContractsResponses[keyof PostAddAssetToContractContractsResponses];

export type PostAddCompanyAdminResponse = PostAddCompanyAdminResponses[keyof PostAddCompanyAdminResponses];

export type PostAddComponentRentalAssetsResponse = PostAddComponentRentalAssetsResponses[keyof PostAddComponentRentalAssetsResponses];

export type PostAddContactEventMonitoringResponse = PostAddContactEventMonitoringResponses[keyof PostAddContactEventMonitoringResponses];

export type PostAddMonitoringOfficerMonitoringResponse = PostAddMonitoringOfficerMonitoringResponses[keyof PostAddMonitoringOfficerMonitoringResponses];

export type PostAddNoteMonitoringResponse = PostAddNoteMonitoringResponses[keyof PostAddNoteMonitoringResponses];

export type PostAddProductContractsResponse = PostAddProductContractsResponses[keyof PostAddProductContractsResponses];

export type PostAddProjectContactCustomerResponse = PostAddProjectContactCustomerResponses[keyof PostAddProjectContactCustomerResponses];

export type PostAddProjectMemberCustomerResponse = PostAddProjectMemberCustomerResponses[keyof PostAddProjectMemberCustomerResponses];

export type PostAddProjectNvRecorderCustomerResponse = PostAddProjectNvRecorderCustomerResponses[keyof PostAddProjectNvRecorderCustomerResponses];

export type PostAddSalesOrderLineOrderResponse = PostAddSalesOrderLineOrderResponses[keyof PostAddSalesOrderLineOrderResponses];

export type PostAddSalesOrderLogOrderResponse = PostAddSalesOrderLogOrderResponses[keyof PostAddSalesOrderLogOrderResponses];

export type PostAddSalesPersonContractsResponse = PostAddSalesPersonContractsResponses[keyof PostAddSalesPersonContractsResponses];

export type PostAddUserCompanyResponse = PostAddUserCompanyResponses[keyof PostAddUserCompanyResponses];

export type PostAddUserProjectResponse = PostAddUserProjectResponses[keyof PostAddUserProjectResponses];

export type PostAddUserTenantResponse = PostAddUserTenantResponses[keyof PostAddUserTenantResponses];

export type PostAddVideoProcessorConfigRentalAssetsResponse = PostAddVideoProcessorConfigRentalAssetsResponses[keyof PostAddVideoProcessorConfigRentalAssetsResponses];

export type PostApplyAlertingChangesDeviceResponse = PostApplyAlertingChangesDeviceResponses[keyof PostApplyAlertingChangesDeviceResponses];

export type PostApproveRentalAssetRentalAssetsResponse = PostApproveRentalAssetRentalAssetsResponses[keyof PostApproveRentalAssetRentalAssetsResponses];

export type PostAssignAssetToAssetPublicResponse = PostAssignAssetToAssetPublicResponses[keyof PostAssignAssetToAssetPublicResponses];

export type PostAssignHardwareAssetResponse = PostAssignHardwareAssetResponses[keyof PostAssignHardwareAssetResponses];

export type PostBindToProjectContractsResponse = PostBindToProjectContractsResponses[keyof PostBindToProjectContractsResponses];

export type PostBindXeroAccountsAccountingResponse = PostBindXeroAccountsAccountingResponses[keyof PostBindXeroAccountsAccountingResponses];

export type PostCallbackXeroConnectXeroResponse = PostCallbackXeroConnectXeroResponses[keyof PostCallbackXeroConnectXeroResponses];

export type PostCloseAlertAlertingResponse = PostCloseAlertAlertingResponses[keyof PostCloseAlertAlertingResponses];

export type PostCloseAlertMonitoringResponse = PostCloseAlertMonitoringResponses[keyof PostCloseAlertMonitoringResponses];

export type PostCloseComplianceEventComplianceResponse = PostCloseComplianceEventComplianceResponses[keyof PostCloseComplianceEventComplianceResponses];

export type PostConvertSalesOrderToContractOrderResponse = PostConvertSalesOrderToContractOrderResponses[keyof PostConvertSalesOrderToContractOrderResponses];

export type PostCreateAdminEventCalendarResponse = PostCreateAdminEventCalendarResponses[keyof PostCreateAdminEventCalendarResponses];

export type PostCreateAssetAssetResponse = PostCreateAssetAssetResponses[keyof PostCreateAssetAssetResponses];

export type PostCreateAssetGroupCompanyResponse = PostCreateAssetGroupCompanyResponses[keyof PostCreateAssetGroupCompanyResponses];

export type PostCreateBeaconHardwareResponse = PostCreateBeaconHardwareResponses[keyof PostCreateBeaconHardwareResponses];

export type PostCreateCompanyMonitoringResponse = PostCreateCompanyMonitoringResponses[keyof PostCreateCompanyMonitoringResponses];

export type PostCreateCompanyTenantMonitoringResponse = PostCreateCompanyTenantMonitoringResponses[keyof PostCreateCompanyTenantMonitoringResponses];

export type PostCreateContractContractsResponse = PostCreateContractContractsResponses[keyof PostCreateContractContractsResponses];

export type PostCreateCustomerCustomerResponse = PostCreateCustomerCustomerResponses[keyof PostCreateCustomerCustomerResponses];

export type PostCreateDeviceDeviceResponse = PostCreateDeviceDeviceResponses[keyof PostCreateDeviceDeviceResponses];

export type PostCreateDeviceExternalConnectionResponse = PostCreateDeviceExternalConnectionResponses[keyof PostCreateDeviceExternalConnectionResponses];

export type PostCreateEventCalendarResponse = PostCreateEventCalendarResponses[keyof PostCreateEventCalendarResponses];

export type PostCreateGatewayGatewayResponse = PostCreateGatewayGatewayResponses[keyof PostCreateGatewayGatewayResponses];

export type PostCreateIntegrationIntegrationResponse = PostCreateIntegrationIntegrationResponses[keyof PostCreateIntegrationIntegrationResponses];

export type PostCreateLicenceLicenceResponse = PostCreateLicenceLicenceResponses[keyof PostCreateLicenceLicenceResponses];

export type PostCreateMonitoringZoneMonitoringResponse = PostCreateMonitoringZoneMonitoringResponses[keyof PostCreateMonitoringZoneMonitoringResponses];

export type PostCreateNetworkProviderNetworkResponse = PostCreateNetworkProviderNetworkResponses[keyof PostCreateNetworkProviderNetworkResponses];

export type PostCreateNotificationUsersResponse = PostCreateNotificationUsersResponses[keyof PostCreateNotificationUsersResponses];

export type PostCreateNvrDeviceMonitoringResponse = PostCreateNvrDeviceMonitoringResponses[keyof PostCreateNvrDeviceMonitoringResponses];

export type PostCreateNvRecorderMonitoringResponse = PostCreateNvRecorderMonitoringResponses[keyof PostCreateNvRecorderMonitoringResponses];

export type PostCreateOrderOrderResponse = PostCreateOrderOrderResponses[keyof PostCreateOrderOrderResponses];

export type PostCreateProductProductsResponse = PostCreateProductProductsResponses[keyof PostCreateProductProductsResponses];

export type PostCreateProjectCustomerResponse = PostCreateProjectCustomerResponses[keyof PostCreateProjectCustomerResponses];

export type PostCreateRegionCalendarResponse = PostCreateRegionCalendarResponses[keyof PostCreateRegionCalendarResponses];

export type PostCreateRelayRelayResponse = PostCreateRelayRelayResponses[keyof PostCreateRelayRelayResponses];

export type PostCreateRentalAssetRentalAssetsResponse = PostCreateRentalAssetRentalAssetsResponses[keyof PostCreateRentalAssetRentalAssetsResponses];

export type PostCreateReportReportResponse = PostCreateReportReportResponses[keyof PostCreateReportReportResponses];

export type PostCreateRfidHardwareResponse = PostCreateRfidHardwareResponses[keyof PostCreateRfidHardwareResponses];

export type PostCreateSimCardNetworkResponse = PostCreateSimCardNetworkResponses[keyof PostCreateSimCardNetworkResponses];

export type PostCreateSiteSiteResponse = PostCreateSiteSiteResponses[keyof PostCreateSiteSiteResponses];

export type PostCreateSmtpParserMonitoringResponse = PostCreateSmtpParserMonitoringResponses[keyof PostCreateSmtpParserMonitoringResponses];

export type PostCreateSpeakerSpeakerResponse = PostCreateSpeakerSpeakerResponses[keyof PostCreateSpeakerSpeakerResponses];

export type PostCreateTenantTenantResponse = PostCreateTenantTenantResponses[keyof PostCreateTenantTenantResponses];

export type PostCreateUserUsersResponse = PostCreateUserUsersResponses[keyof PostCreateUserUsersResponses];

export type PostCreateZoneFromExistingSiteResponse = PostCreateZoneFromExistingSiteResponses[keyof PostCreateZoneFromExistingSiteResponses];

export type PostCreateZoneSiteResponse = PostCreateZoneSiteResponses[keyof PostCreateZoneSiteResponses];

export type PostDeleteDeviceDeviceResponse = PostDeleteDeviceDeviceResponses[keyof PostDeleteDeviceDeviceResponses];

export type PostDescribePeopleAlertMonitoringResponse = PostDescribePeopleAlertMonitoringResponses[keyof PostDescribePeopleAlertMonitoringResponses];

export type PostDisarmAlertAlertingResponse = PostDisarmAlertAlertingResponses[keyof PostDisarmAlertAlertingResponses];

export type PostDisarmAlertMonitoringResponse = PostDisarmAlertMonitoringResponses[keyof PostDisarmAlertMonitoringResponses];

export type PostDisarmProjectCustomerResponse = PostDisarmProjectCustomerResponses[keyof PostDisarmProjectCustomerResponses];

export type PostDisarmProjectProjectResponse = PostDisarmProjectProjectResponses[keyof PostDisarmProjectProjectResponses];

export type PostDoTokenResetAuthResponse = PostDoTokenResetAuthResponses[keyof PostDoTokenResetAuthResponses];

export type PostEncryptionKeyAdminResponse = PostEncryptionKeyAdminResponses[keyof PostEncryptionKeyAdminResponses];

export type PostEndShiftAlertMonitoringResponse = PostEndShiftAlertMonitoringResponses[keyof PostEndShiftAlertMonitoringResponses];

export type PostFetchAssetTypesRentalAssetsResponse = PostFetchAssetTypesRentalAssetsResponses[keyof PostFetchAssetTypesRentalAssetsResponses];

export type PostFetchComponentCredentialsRentalAssetsResponse = PostFetchComponentCredentialsRentalAssetsResponses[keyof PostFetchComponentCredentialsRentalAssetsResponses];

export type PostGetJobStatusPreaggAdminResponse = PostGetJobStatusPreaggAdminResponses[keyof PostGetJobStatusPreaggAdminResponses];

export type PostGrantLicenceAssetResponse = PostGrantLicenceAssetResponses[keyof PostGrantLicenceAssetResponses];

export type PostHashEmailAuthResponse = PostHashEmailAuthResponses[keyof PostHashEmailAuthResponses];

export type PostHideNonRentableAssetRentalAssetsResponse = PostHideNonRentableAssetRentalAssetsResponses[keyof PostHideNonRentableAssetRentalAssetsResponses];

export type PostIdentifySiteInstructionsAlertMonitoringResponse = PostIdentifySiteInstructionsAlertMonitoringResponses[keyof PostIdentifySiteInstructionsAlertMonitoringResponses];

export type PostLoginAuthResponse = PostLoginAuthResponses[keyof PostLoginAuthResponses];

export type PostModifyAssetOnContractContractsResponse = PostModifyAssetOnContractContractsResponses[keyof PostModifyAssetOnContractContractsResponses];

export type PostMonitoringLoginAuthResponse = PostMonitoringLoginAuthResponses[keyof PostMonitoringLoginAuthResponses];

export type PostMoveDeviceDeviceResponse = PostMoveDeviceDeviceResponses[keyof PostMoveDeviceDeviceResponses];

export type PostMyNotificationsUsersResponse = PostMyNotificationsUsersResponses[keyof PostMyNotificationsUsersResponses];

export type PostNotificationAcknowledgedUsersResponse = PostNotificationAcknowledgedUsersResponses[keyof PostNotificationAcknowledgedUsersResponses];

export type PostNotificationActionedUsersResponse = PostNotificationActionedUsersResponses[keyof PostNotificationActionedUsersResponses];

export type PostNvRecorderConnectMonitoringResponse = PostNvRecorderConnectMonitoringResponses[keyof PostNvRecorderConnectMonitoringResponses];

export type PostRedeemTokenOidcResponse = PostRedeemTokenOidcResponses[keyof PostRedeemTokenOidcResponses];

export type PostReindexExternalConnectionExternalConnectionResponse = PostReindexExternalConnectionExternalConnectionResponses[keyof PostReindexExternalConnectionExternalConnectionResponses];

export type PostRelocateAssetContractsResponse = PostRelocateAssetContractsResponses[keyof PostRelocateAssetContractsResponses];

export type PostReopenAlertAlertingResponse = PostReopenAlertAlertingResponses[keyof PostReopenAlertAlertingResponses];

export type PostRequestMonitoringLoginAuthResponse = PostRequestMonitoringLoginAuthResponses[keyof PostRequestMonitoringLoginAuthResponses];

export type PostRequestResetPasswordAuthResponse = PostRequestResetPasswordAuthResponses[keyof PostRequestResetPasswordAuthResponses];

export type PostRequireLicenceAssetResponse = PostRequireLicenceAssetResponses[keyof PostRequireLicenceAssetResponses];

export type PostRetireRentalAssetRentalAssetsResponse = PostRetireRentalAssetRentalAssetsResponses[keyof PostRetireRentalAssetRentalAssetsResponses];

export type PostSaveIntegrationCodeIntegrationResponse = PostSaveIntegrationCodeIntegrationResponses[keyof PostSaveIntegrationCodeIntegrationResponses];

export type PostSearchAssetGroupsCompanyResponse = PostSearchAssetGroupsCompanyResponses[keyof PostSearchAssetGroupsCompanyResponses];

export type PostSearchCompaniesAdminResponse = PostSearchCompaniesAdminResponses[keyof PostSearchCompaniesAdminResponses];

export type PostSearchLicencesLicenceResponse = PostSearchLicencesLicenceResponses[keyof PostSearchLicencesLicenceResponses];

export type PostSearchMonitoringOfficersMonitoringResponse = PostSearchMonitoringOfficersMonitoringResponses[keyof PostSearchMonitoringOfficersMonitoringResponses];

export type PostSearchNvRecordersMonitoringResponse = PostSearchNvRecordersMonitoringResponses[keyof PostSearchNvRecordersMonitoringResponses];

export type PostSearchSitesSiteResponse = PostSearchSitesSiteResponses[keyof PostSearchSitesSiteResponses];

export type PostSearchSmtpParsersMonitoringResponse = PostSearchSmtpParsersMonitoringResponses[keyof PostSearchSmtpParsersMonitoringResponses];

export type PostSearchUserProjectsUsersResponse = PostSearchUserProjectsUsersResponses[keyof PostSearchUserProjectsUsersResponses];

export type PostSearchUsersCompanyResponse = PostSearchUsersCompanyResponses[keyof PostSearchUsersCompanyResponses];

export type PostSearchUsersProjectResponse = PostSearchUsersProjectResponses[keyof PostSearchUsersProjectResponses];

export type PostSearchZonesSiteResponse = PostSearchZonesSiteResponses[keyof PostSearchZonesSiteResponses];

export type PostSendContactSmsMonitoringResponse = PostSendContactSmsMonitoringResponses[keyof PostSendContactSmsMonitoringResponses];

export type PostSetAlertOnHoldAlertMonitoringResponse = PostSetAlertOnHoldAlertMonitoringResponses[keyof PostSetAlertOnHoldAlertMonitoringResponses];

export type PostSetAlertSuppressionCandidatesMonitoringResponse = PostSetAlertSuppressionCandidatesMonitoringResponses[keyof PostSetAlertSuppressionCandidatesMonitoringResponses];

export type PostSetAssetContractEndDateContractsResponse = PostSetAssetContractEndDateContractsResponses[keyof PostSetAssetContractEndDateContractsResponses];

export type PostSetAssetInstalledContractsResponse = PostSetAssetInstalledContractsResponses[keyof PostSetAssetInstalledContractsResponses];

export type PostSetAssetRemovedContractsResponse = PostSetAssetRemovedContractsResponses[keyof PostSetAssetRemovedContractsResponses];

export type PostSetAssetReturnedContractsResponse = PostSetAssetReturnedContractsResponses[keyof PostSetAssetReturnedContractsResponses];

export type PostSetCameraActivationZoneMonitoringResponse = PostSetCameraActivationZoneMonitoringResponses[keyof PostSetCameraActivationZoneMonitoringResponses];

export type PostSetEventViewedAlertMonitoringResponse = PostSetEventViewedAlertMonitoringResponses[keyof PostSetEventViewedAlertMonitoringResponses];

export type PostSetLineItemAssetContractsResponse = PostSetLineItemAssetContractsResponses[keyof PostSetLineItemAssetContractsResponses];

export type PostSetMaintainanceTaskAlertMonitoringResponse = PostSetMaintainanceTaskAlertMonitoringResponses[keyof PostSetMaintainanceTaskAlertMonitoringResponses];

export type PostSetPreferenceUserPreferencesResponse = PostSetPreferenceUserPreferencesResponses[keyof PostSetPreferenceUserPreferencesResponses];

export type PostSetProjectMonitoringCompanyCustomerResponse = PostSetProjectMonitoringCompanyCustomerResponses[keyof PostSetProjectMonitoringCompanyCustomerResponses];

export type PostSetProjectNoThreatDispositionCustomerResponse = PostSetProjectNoThreatDispositionCustomerResponses[keyof PostSetProjectNoThreatDispositionCustomerResponses];

export type PostSetRegionCalendarResponse = PostSetRegionCalendarResponses[keyof PostSetRegionCalendarResponses];

export type PostSetSettingAdminResponse = PostSetSettingAdminResponses[keyof PostSetSettingAdminResponses];

export type PostSetVideoProcessorDebugModeRentalAssetsResponse = PostSetVideoProcessorDebugModeRentalAssetsResponses[keyof PostSetVideoProcessorDebugModeRentalAssetsResponses];

export type PostShiftStartAlertMonitoringResponse = PostShiftStartAlertMonitoringResponses[keyof PostShiftStartAlertMonitoringResponses];

export type PostSubmitTrainingEventAlertMonitoringResponse = PostSubmitTrainingEventAlertMonitoringResponses[keyof PostSubmitTrainingEventAlertMonitoringResponses];

export type PostTestExternalConnectionExternalConnectionResponse = PostTestExternalConnectionExternalConnectionResponses[keyof PostTestExternalConnectionExternalConnectionResponses];

export type PostTestHostReachabilityDeviceResponse = PostTestHostReachabilityDeviceResponses[keyof PostTestHostReachabilityDeviceResponses];

export type PostTogglePermissionUsersResponse = PostTogglePermissionUsersResponses[keyof PostTogglePermissionUsersResponses];

export type PostTokenLoginAuthResponse = PostTokenLoginAuthResponses[keyof PostTokenLoginAuthResponses];

export type PostTriggerRebuildPreaggAdminResponse = PostTriggerRebuildPreaggAdminResponses[keyof PostTriggerRebuildPreaggAdminResponses];

export type PostUnAssignHardwareAssetResponse = PostUnAssignHardwareAssetResponses[keyof PostUnAssignHardwareAssetResponses];

export type PostUpdateAccountAccountingResponse = PostUpdateAccountAccountingResponses[keyof PostUpdateAccountAccountingResponses];

export type PostUpdateAdminEventCalendarResponse = PostUpdateAdminEventCalendarResponses[keyof PostUpdateAdminEventCalendarResponses];

export type PostUpdateAssetAssetResponse = PostUpdateAssetAssetResponses[keyof PostUpdateAssetAssetResponses];

export type PostUpdateAssetMonitoringGroupResponse = PostUpdateAssetMonitoringGroupResponses[keyof PostUpdateAssetMonitoringGroupResponses];

export type PostUpdateCompanyMonitoringResponse = PostUpdateCompanyMonitoringResponses[keyof PostUpdateCompanyMonitoringResponses];

export type PostUpdateCompanyTenantMonitoringResponse = PostUpdateCompanyTenantMonitoringResponses[keyof PostUpdateCompanyTenantMonitoringResponses];

export type PostUpdateDashboardProjectResponse = PostUpdateDashboardProjectResponses[keyof PostUpdateDashboardProjectResponses];

export type PostUpdateEmailTemplateAdminResponse = PostUpdateEmailTemplateAdminResponses[keyof PostUpdateEmailTemplateAdminResponses];

export type PostUpdateEventCalendarResponse = PostUpdateEventCalendarResponses[keyof PostUpdateEventCalendarResponses];

export type PostUpdateExternalConnectionExternalConnectionResponse = PostUpdateExternalConnectionExternalConnectionResponses[keyof PostUpdateExternalConnectionExternalConnectionResponses];

export type PostUpdateGatewayGatewayResponse = PostUpdateGatewayGatewayResponses[keyof PostUpdateGatewayGatewayResponses];

export type PostUpdateInformationAuthResponse = PostUpdateInformationAuthResponses[keyof PostUpdateInformationAuthResponses];

export type PostUpdateIntegrationFieldsIntegrationResponse = PostUpdateIntegrationFieldsIntegrationResponses[keyof PostUpdateIntegrationFieldsIntegrationResponses];

export type PostUpdateIntruderInfoAlertMonitoringResponse = PostUpdateIntruderInfoAlertMonitoringResponses[keyof PostUpdateIntruderInfoAlertMonitoringResponses];

export type PostUpdateIntruderInfoMonitoringResponse = PostUpdateIntruderInfoMonitoringResponses[keyof PostUpdateIntruderInfoMonitoringResponses];

export type PostUpdateMonitoringEmailTemplateAdminResponse = PostUpdateMonitoringEmailTemplateAdminResponses[keyof PostUpdateMonitoringEmailTemplateAdminResponses];

export type PostUpdateMonitoringZoneMonitoringResponse = PostUpdateMonitoringZoneMonitoringResponses[keyof PostUpdateMonitoringZoneMonitoringResponses];

export type PostUpdateNvRecorderMonitoringResponse = PostUpdateNvRecorderMonitoringResponses[keyof PostUpdateNvRecorderMonitoringResponses];

export type PostUpdateOrderOrderResponse = PostUpdateOrderOrderResponses[keyof PostUpdateOrderOrderResponses];

export type PostUpdateProductProductsResponse = PostUpdateProductProductsResponses[keyof PostUpdateProductProductsResponses];

export type PostUpdateProjectContactCustomerResponse = PostUpdateProjectContactCustomerResponses[keyof PostUpdateProjectContactCustomerResponses];

export type PostUpdateProjectCustomerResponse = PostUpdateProjectCustomerResponses[keyof PostUpdateProjectCustomerResponses];

export type PostUpdateProjectScheduleCustomerResponse = PostUpdateProjectScheduleCustomerResponses[keyof PostUpdateProjectScheduleCustomerResponses];

export type PostUpdateRegionalCalendarsCalendarResponse = PostUpdateRegionalCalendarsCalendarResponses[keyof PostUpdateRegionalCalendarsCalendarResponses];

export type PostUpdateRentalAssetRentalAssetsResponse = PostUpdateRentalAssetRentalAssetsResponses[keyof PostUpdateRentalAssetRentalAssetsResponses];

export type PostUpdateSalesOrderLineOrderResponse = PostUpdateSalesOrderLineOrderResponses[keyof PostUpdateSalesOrderLineOrderResponses];

export type PostUpdateSalesOrderLogOrderResponse = PostUpdateSalesOrderLogOrderResponses[keyof PostUpdateSalesOrderLogOrderResponses];

export type PostUpdateSecondaryDevicesDevice2Response = PostUpdateSecondaryDevicesDevice2Responses[keyof PostUpdateSecondaryDevicesDevice2Responses];

export type PostUpdateSecondaryDevicesDeviceResponse = PostUpdateSecondaryDevicesDeviceResponses[keyof PostUpdateSecondaryDevicesDeviceResponses];

export type PostUpdateSmtpParserMonitoringResponse = PostUpdateSmtpParserMonitoringResponses[keyof PostUpdateSmtpParserMonitoringResponses];

export type PostUpdateStatusAlertingResponse = PostUpdateStatusAlertingResponses[keyof PostUpdateStatusAlertingResponses];

export type PostUpdateStatusMonitoringResponse = PostUpdateStatusMonitoringResponses[keyof PostUpdateStatusMonitoringResponses];

export type PostUpdateTenantTenantResponse = PostUpdateTenantTenantResponses[keyof PostUpdateTenantTenantResponses];

export type PostUpdateTriggersIntegrationResponse = PostUpdateTriggersIntegrationResponses[keyof PostUpdateTriggersIntegrationResponses];

export type PostUpdateUserUsersResponse = PostUpdateUserUsersResponses[keyof PostUpdateUserUsersResponses];

export type PostUpdateWorkflowHistoryAlertMonitoringResponse = PostUpdateWorkflowHistoryAlertMonitoringResponses[keyof PostUpdateWorkflowHistoryAlertMonitoringResponses];

export type PostUploadEmailImageAdminResponse = PostUploadEmailImageAdminResponses[keyof PostUploadEmailImageAdminResponses];

export type PostUploadLogoTenantResponse = PostUploadLogoTenantResponses[keyof PostUploadLogoTenantResponses];

export type PostVerifyUserAuthResponse = PostVerifyUserAuthResponses[keyof PostVerifyUserAuthResponses];

export type PutAckShiftAlertMonitoringResponse = PutAckShiftAlertMonitoringResponses[keyof PutAckShiftAlertMonitoringResponses];

export type PutAddApiTokenCompanyResponse = PutAddApiTokenCompanyResponses[keyof PutAddApiTokenCompanyResponses];

export type PutCreateDashboardProjectResponse = PutCreateDashboardProjectResponses[keyof PutCreateDashboardProjectResponses];

export type PutCreateExternalConnectionExternalConnectionResponse = PutCreateExternalConnectionExternalConnectionResponses[keyof PutCreateExternalConnectionExternalConnectionResponses];

export type PutModifyNetworkProviderNetworkResponse = PutModifyNetworkProviderNetworkResponses[keyof PutModifyNetworkProviderNetworkResponses];

export type PutModifySimCardNetworkResponse = PutModifySimCardNetworkResponses[keyof PutModifySimCardNetworkResponses];

export type PutRetireHardwareResponse = PutRetireHardwareResponses[keyof PutRetireHardwareResponses];

export type PutToggleArchiveCustomerCustomerResponse = PutToggleArchiveCustomerCustomerResponses[keyof PutToggleArchiveCustomerCustomerResponses];

export type PutUpdateAssetGroupCompanyResponse = PutUpdateAssetGroupCompanyResponses[keyof PutUpdateAssetGroupCompanyResponses];

export type PutUpdateBeaconHardwareResponse = PutUpdateBeaconHardwareResponses[keyof PutUpdateBeaconHardwareResponses];

export type PutUpdateCompanyInfoCompanyResponse = PutUpdateCompanyInfoCompanyResponses[keyof PutUpdateCompanyInfoCompanyResponses];

export type PutUpdateContractContractsResponse = PutUpdateContractContractsResponses[keyof PutUpdateContractContractsResponses];

export type PutUpdateCredentialsCompanyResponse = PutUpdateCredentialsCompanyResponses[keyof PutUpdateCredentialsCompanyResponses];

export type PutUpdateCustomerCustomerResponse = PutUpdateCustomerCustomerResponses[keyof PutUpdateCustomerCustomerResponses];

export type PutUpdateIntegrationKeyIntegrationResponse = PutUpdateIntegrationKeyIntegrationResponses[keyof PutUpdateIntegrationKeyIntegrationResponses];

export type PutUpdateLicenceLicenceResponse = PutUpdateLicenceLicenceResponses[keyof PutUpdateLicenceLicenceResponses];

export type PutUpdateProjectNotificationProjectResponse = PutUpdateProjectNotificationProjectResponses[keyof PutUpdateProjectNotificationProjectResponses];

export type PutUpdateProjectProjectResponse = PutUpdateProjectProjectResponses[keyof PutUpdateProjectProjectResponses];

export type PutUpdateProjectScheduleProjectResponse = PutUpdateProjectScheduleProjectResponses[keyof PutUpdateProjectScheduleProjectResponses];

export type PutUpdateRelayRelayResponse = PutUpdateRelayRelayResponses[keyof PutUpdateRelayRelayResponses];

export type PutUpdateReportReportResponse = PutUpdateReportReportResponses[keyof PutUpdateReportReportResponses];

export type PutUpdateRfidHardwareResponse = PutUpdateRfidHardwareResponses[keyof PutUpdateRfidHardwareResponses];

export type PutUpdateSiteSiteResponse = PutUpdateSiteSiteResponses[keyof PutUpdateSiteSiteResponses];

export type PutUpdateSpeakerSpeakerResponse = PutUpdateSpeakerSpeakerResponses[keyof PutUpdateSpeakerSpeakerResponses];

export type PutUpdateVideoProcessorConfigRentalAssetsResponse = PutUpdateVideoProcessorConfigRentalAssetsResponses[keyof PutUpdateVideoProcessorConfigRentalAssetsResponses];

export type PutUpdateZoneSiteResponse = PutUpdateZoneSiteResponses[keyof PutUpdateZoneSiteResponses];

